(function() {
  'use strict';

  angular
    .module('hydra', [
      // core angular
      'ngSanitize', // sanitize form input
      'ngCookies', // handle $cookies (TODO: remove)
      'ngAria', // automatic conversion of ng-disabled to ARIA conform elments

      // extending angular
      'ui.router', // Routing
      'restangular', // REST API helpers

      'angular-google-analytics',
      'pascalprecht.translate',
      'tmh.dynamicLocale',
      'angularMoment',
      'angular-jwt',

      'ngIdle', // handle user inactivity

      // UI elements
      'ui.bootstrap', // using (at least):
      /*
        - uib-collapse in main navigation
        - uib-button, ui-dropdown-menu in case list
        - $uibModal for case saving and loading
        - uib-tabset, ui-tab for data debugging tabs in form
      */

      'duScroll', // angular-scroll (to scroll form sections)
      'angular.backtop', // to scroll back to top (from end of page)

      'schemaForm',
      'angularSchemaFormUiDatepicker',

      'eehNavigation', // for main Navigation
      'angular-loading-bar',
      'sticky', // for sub-navigation (e.g. "Tarifierung | Antrag | Dateien | Kontakte")

//      'ngAnimate',
//      'ngTouch',
//      'ngMessages',
      'toastr', // for notifications afer saving or editing actions

      'ui.select',
      //'ui.highlight', // used in ui-select (to highlight part of words in search results)

      'ui.ace' // In data debugging tabs for form
      /*
      'mgcrea.ngStrap',
      'mgcrea.ngStrap.modal',
      'mgcrea.ngStrap.select'
      */
    ]);


})();

(function() {
  'use strict';

  angular
    .module('hydra')
    .factory('userSettingsService', function (storageService, $q) {

      var _defaults = {
        content : {
          use_cases : true
        }
      };

      var service = {
        data : {
          settings : {
            /*
            content : null
            */
          }
        },
        loadSettings : function() {
          var deferred = $q.defer();

          // return directly in case it's already loaded
          if (Object.keys(service.data.settings).length > 0) {
            deferred.resolve(service.data.settings);
          }
          else {
            storageService.getStorage('userSettings').then(function(storedSettings) {
              if (storedSettings !== null) {
                // override defaults (and make sure new elements that were not saved before don't get lost)
                service.data.settings = angular.merge(_defaults, storedSettings[0]);
              }
              else {
                service.data.settings = _defaults;
              }
              deferred.resolve(service.data.settings);
            });
          }

          return deferred.promise;
        },
        saveSettings : function(newSettings) {
          return storageService.save('userSettings', newSettings);
        },
        getSetting : function(name) {
          var res = false;
          if (service.data.settings && service.data.settings.hasOwnProperty('content') && service.data.settings.content.hasOwnProperty(name)) {
            res = service.data.settings.content[name];
          }

          return res;
        }
      };

      service.loadSettings();

      return service;
    });
})();

(function() {
  'use strict';

  angular
    .module('hydra')
    .controller('SettingsController', function($timeout, $scope, userSettingsService, toastr) {
      var vm = this;

      vm.password = {};
      vm.password.loading = false;
      vm.password.model = null;
      userSettingsService.loadSettings().then(function(result) {
        vm.password.model = result;
      });
      vm.userinfo = {};

      vm.password.schema = {
        "type": "object",
        "properties": {
          "use_cases": {
            "title": "Speichern von Anfragen erlauben",
            "type": "boolean",
            "description": "Soll es möglich sein, Anfragen für später zu speichern?"
          }
        },
        "required": [
          //"password_confirmation"
        ]
      };

      vm.password.form = [{
        "type": "fieldset",
        "title": "Einstellungen",
        "items": [
          {
          "key": "use_cases",
          "type": "checkbox",
          "placeholder": "",
          "feedback": false,
          "disableSuccessState": true,
          "disableErrorState": false
          }
        , {
          "type": "actions",
          "style": "col-md-12",
          "items": [{
            "type": "button",
            "icon": "fa fa-save",
            "style": "btn-primary btn-block",
            "title": " speichern",
            "onClick": "ctrl.password.submit(passwordForm, ctrl.password.model)"
          }]
        }]
      }];

      vm.password.submit = function (form, model) {
        // Event broadcasten um alle Felder zu validieren
        $scope.$broadcast('schemaFormValidate');
        // Prüfen ob Form valide ist
        if (form.$valid) {
          userSettingsService.saveSettings(model).then(function(results) {
            toastr.success('Die Einstellungen wurden erfolgreich gespeichert.', 'Einstellungen gespeichert');
          });
        }
      }

    });
})();

(function() {
  'use strict';

  angular
    .module('hydra')
    .controller('ResetPwdRequestController', ResetPwdRequestController);

  /** @ngInject */
  function ResetPwdRequestController($log, $scope, $state, $stateParams, Restangular, $translate, hydraData, principal, config) {

    /*
        if (!$state.params.user || !$state.params.ticket) {
          $state.go('main.404');
        }
    */

    var vm = this;
    vm.model = {};
    vm.error = false;
    vm.loading = false;
    vm.success = false;
    vm.externalUser=true;
    vm.redirectUri = window.location.origin+window.location.pathname+"login";
    vm.clientId = null;
    vm.oktaURL = null;

    if(window.__env.name == "local")
      {
        vm.clientId = "0oahb61cr6vlK8ZgI1d7";
        vm.oktaURL = 'https://devauth1.customerpltfm.aig.com/oauth2/ausmgmbyeSo2EHuJs1d6';
      }
      else if(window.__env.name == "dev")
      {
        vm.clientId = "0oagmdfa485CGlLKd1d7";
        vm.oktaURL = 'https://devauth1.customerpltfm.aig.com/oauth2/ausmgmbyeSo2EHuJs1d6';
      }
      else if(window.__env.name == "test")
      {
        vm.clientId = "0oahka2twr7EGJLPM1d7";
        vm.oktaURL = 'https://uatauth1.customerpltfm.aig.com/oauth2/ausuekxpsCZZKg0Cw1d6';
      }
      else if(window.__env.name == "production")
      {
        vm.clientId = "0oalfxqpecsY6VRW75d7";
        vm.oktaURL = 'https://auth1.customerpltfm.aig.com/oauth2/aus187xvth5kQKY1t5d7';
      }

    vm.schema = {
      "type": "object",
      "properties": {
        "email": {
          "title": "E-Mail-Adresse",
          "type": "string",
          "minLength": 6,
          "pattern": config.patterns.email
          //"description": "Bitte geben Sie ihre E-Mail-Adresse ein."
        }
      },
      "required": [
        "email"
      ]
    };

    vm.form = [{
      "type": "fieldset",
      "title": "Anforderung Passwort-Reset",
      "items": [{
        "key": "email",
        "type": "text",
        "feedback": false,
        "disableSuccessState": true,
        "disableErrorState": true,
        "validationMessage": {
          "302": "Bitte E-Mail eingeben.",
          "202": "Bitte geben Sie eine gültige E-Mail-Adresse ein."
        },
        onChange: function(modelValue, form) {
          // Update the visibility of the password field based on the email entered
          vm.externalUser = !modelValue || !modelValue.endsWith('@aig.com');
        }
      }, {
        "type": "actions",
        "style": "col-md-12",
        "items": [{
          "type": "button",
          "icon": "fa fa-arrow-right",
          "style": "btn-primary btn-block",
          "title": " Absenden",
          "onClick": "ctrl.onSubmit(resetPwdRequestForm, ctrl.model)"
        }]
      }]
    }];

    vm.onSubmit = function(form, model) {
      // Event broadcasten um alle Felder zu validieren
      $scope.$broadcast('schemaFormValidate');
      
      if(!vm.externalUser)
      {
        // Construct the Okta authorization URL
        var oktaAuthUrl = vm.oktaURL +
                          '/v1/authorize' +
                          '?client_id=' + vm.clientId +
                          '&response_type=code' +
                          '&response_mode=query' +
                          '&scope=openid profile email' +
                          '&redirect_uri=' + vm.redirectUri +
                          '&state=OpenIdConnect.AuthenticationProperties%3D66WSycePo8QkeHdWUhWjukxKmjOKMwE14WtWzj1mPfUz7keqUI-TmABMgp4jVyaPlZ5VvSnWTr2cK8wCcSJ90H1aiFoQfbFaWnWPWRkJMRND_Hn9K8rL7DkpJ--i_XUYLHONYvT8TkUbfCn8bcu7jhemu7V9CATMqLhBURZB3L_FZwqrWGczMQ8OU-LmHBIBo7SjBcm5iK0ayKOWbJnNHnWZEN5ZG8ofAyfWZdCX4hnoPM0BMT-3-LX3Iu0oFwSQ' +
                          '&nonce=638252853153817108.NTgxYTExMWItMGE2Ni00ZWFmLTkwYjEtMzg3OWU1NDIzZDdhYmZhMjljODctN2Y4Yy00MDI5LWIyY2MtMTA2NDdlNTQ5OWVh';

        // Redirect to the Okta authorization URL
        window.location.href = oktaAuthUrl;
      }
      // Prüfen ob Form valide ist
      else if (form.$valid) {
        vm.loading = true;
        Restangular.one('user').one('password').withHttpConfig({
          cache: false
        }).customPOST({
          "userid": model.email
        }).then(function() {
          vm.error = false;
          vm.success = true;
        }, function(response) {
          vm.error = true;
          try {
            vm.errorCode = response.status;
          } catch (e) {
            vm.errorCode = response.status;
            vm.errorText = "Dieser Service ist momentan leider nicht verfügbar.";
          }
        }).finally(function() {
          vm.loading = false;
        });
      }
    }


  }
})();

(function() {
  'use strict';

  angular
    .module('hydra')
    .controller('RegisterController', RegisterController);

  /** @ngInject */
  function RegisterController($log, $scope, $state, $stateParams, Restangular, $translate, hydraData, config) {

    var vm = this;
    vm.model = {};
    vm.error = false;
    vm.loading = false;
    vm.success = false;
    vm.token = $state.params.token;
    //$log.debug("1 vm.token: "+ vm.token);
    vm.user = {};

    vm.loading = true;
    Restangular.one('user').one('session').one('registration').withHttpConfig({
      cache: false
    }).get({token: vm.token}).
    then(function(response) {
        vm.loading = false;
        if (response === undefined) {
          // falls registrierung bereits abgeschlossen (WCG_ABGESCHLOSSEN_AM gesetzt)
          // oder token nicht in der db bekannt liefert X4 keine response + status 204 zurück
          vm.error = true;
          vm.errorCode = 204;
          vm.errorText = "Es ist ein Problem beim Laden der Seite aufgetreten. Bitte kontaktieren Sie die Maklerbetreuung.";
          //$log.debug("2: response undefined");
        } else {
          //$log.debug("3: "+ angular.toJson(response));
          vm.user = response;
        }
    }, function(response) {
      //$log.debug("4 response.status: "+ response.status);
      vm.loading = false;
      vm.error   = true;
      vm.errorCode = response.status;
      vm.errorText = "Aus technischen Gründen ist die Seite gegenwärtig nicht verfügbar."
    });


    //$log.debug("5 vm.user: " + angular.toJson(vm.user));

    vm.schema = {
      "type": "object",
      "properties": {
        "password": {
          "title": "Neues Passwort",
          "type": "string",
          "minLength": 8,
          "pattern": config.patterns.password
          // "description": "Geben Sie hier ein neues Passwort ein."
        },
        "password_confirmation": {
          "title": "Neues Passwort (nochmal zur Bestätigung)",
          "type": "string",
          "pattern": config.patterns.password,
          "minLength": 8
          // "description": "Geben Sie zur Bestätigung Ihr neues Passwort nochmal ein."
        }
      },
      "required": [
        "password",
        "password_confirmation"
      ]
    };

    vm.form = [{
      "type": "fieldset",
      // "title": "Passwort vergeben",
      "items": [{
        "key": "password",
        "type": "password",
        "placeholder": "Neues Passwort",
        "feedback": false,
        "disableSuccessState": true,
        "disableErrorState": false,
        onChange: function() {
          vm.model.password_confirm = '';
          vm.error = false;
        },
        "validationMessage": {
          "302": "Bitte das neue Password eingeben.",
          "202": "Das Passwort muss aus Klein- und Großbuchstaben, Zahlen und Sonderzeichen bestehen."
        }
      }, {
        "key": "password_confirmation",
        "type": "password",
        "placeholder": "Neues Passwort",
        "feedback": false,
        "disableSuccessState": true,
        "disableErrorState": false,
        "validationMessage": {
          "302": "Geben Sie zur Bestätigung Ihr neues Passwort hier nochmal ein.",
          "202": "Das Passwort muss aus Klein- und Großbuchstaben, Zahlen und Sonderzeichen bestehen.",
          "isEqual": "Die Passwörter müssen identisch sein."
        },
        $validators: {
          isEqual: function(value) {
            if (value == vm.model.password) {
              return true;
            }
            return false;
          }
        },
        onChange: function() {
          vm.error = false;
        }
      }, {
        "type": "actions",
        "style": "col-md-12",
        "items": [{
          "type": "submit",
          "icon": "fa fa-check-square-o",
          "style": "btn-primary btn-block",
          "title": " Registrierung abschließen"
          // "onClick": "ctrl.onSubmit(registerForm, ctrl.model)"
        }]
      }]
    }];

    vm.onSubmit = function(form, model) {
      // Event broadcasten um alle Felder zu validieren
      $scope.$broadcast('schemaFormValidate');
      // Prüfen ob Form valide ist
      if (form.$valid) {
        vm.loading = true;
        Restangular.one('user').one('session').one('registration').withHttpConfig({
          cache: false
        }).customPOST({
          "password": model.password,
          "token": vm.token
        }).then(function(response) {
            vm.error = false;
            vm.success = true;
        }, function(response) {
          vm.error = true;
          vm.success = false;
          vm.errorCode = response.status;
          vm.errorText = "Registrierung konnte nicht abgeschlossen werden. Bitte prüfen Sie ob Ihr Passwort den Kriterien entspricht und nicht Teile Ihrer E-Mail-Adresse enthält.";
        }).finally(function(response) {
          vm.loading = false;
        });
      }
    }


  }
})();

(function() {
  'use strict';

  angular
    .module('hydra')
    .controller('ResetPasswordController', ResetPasswordController);

  /** @ngInject */
  function ResetPasswordController($log, $scope, $state, $stateParams, Restangular, $translate, hydraData, principal, config) {

    /*
        if (!$state.params.user || !$state.params.ticket) {
          $state.go('main.404');
        }
    */

    var vm = this;
    vm.model = {};
    vm.error = false;
    vm.loading = false;
    vm.success = false;
    vm.token = $state.params.token;
    vm.user = {};

    //Ueberpruefung Token
    vm.loading = true;
    Restangular.one('user').one('password').withHttpConfig({
      cache: false
    }).get({token: vm.token}).
    then(function(response) {
        vm.loading = false;
        if (response === angular.isUndefined) {
          // falls registrierung bereits abgeschlossen (WCG_ABGESCHLOSSEN_AM gesetzt)
          // oder token nicht in der db bekannt liefert X4 keine response + status 204 zurück
          vm.error = true;
          vm.errorCode = 204;
          vm.errorText = "Es ist ein Problem beim Laden der Seite aufgetreten. Bitte kontaktieren Sie die Maklerbetreuung.";
          //$log.debug("2: response undefined");
        } else {
          //$log.debug("3: "+ angular.toJson(response));
          vm.user = response.userid;
        }
    }, function(response) {
      //$log.debug("4 response.status: "+ response.status);
      vm.loading = false;
      vm.error   = true;
      vm.errorCode = response.status;
      vm.errorText = "Aus technischen Gründen ist die Seite gegenwärtig nicht verfügbar."
    });

    // Schema und Form Definition
    vm.schema = {
      "type": "object",
      "properties": {
        "password": {
          "title": "Neues Passwort",
          "type": "string",
          "minLength": 8,
          "pattern": config.patterns.password,
          "description": "Geben Sie hier ein neues Passwort ein."
        },
        "password_confirmation": {
          "title": "Neues Passwort (nochmal zur Bestätigung)",
          "type": "string",
          "pattern": config.patterns.password,
          "minLength": 8,
          "description": "Geben Sie zur Bestätigung Ihr neues Passwort nochmal ein."
        }
      },
      "required": [
        "password",
        "password_confirmation"
      ]
    };

    vm.form = [{
      "type": "fieldset",
      // "title": "Neues Passwort vergeben",
      "items": [{
        "key": "password",
        "type": "password",
        "placeholder": "Neues Passwort",
        "feedback": false,
        "disableSuccessState": true,
        "disableErrorState": false,
        onChange: function() {
          vm.model.password_confirm = '';
          vm.error = false;
        },
        "validationMessage": {
          "302": "Bitte Password eingeben.",
          "202": "Das Passwort muss aus Klein- und Großbuchstaben sowie Zahlen bestehen."
        }
      }, {
        "key": "password_confirmation",
        "type": "password",
        "placeholder": "Neues Passwort",
        "feedback": false,
        "disableSuccessState": true,
        "disableErrorState": false,
        "validationMessage": {
          "302": "Bitte Password eingeben.",
          "202": "Das Passwort muss aus Klein- und Großbuchstaben sowie Zahlen bestehen.",
          "isEqual": "Die Passwörter müssen identisch sein."
        },
        $validators: {
          isEqual: function(value) {
            if (value == vm.model.password) {
              return true;
            }
            return false;
          }
        },
        onChange: function() {
          vm.error = false;
        }
      }, {
        "type": "actions",
        "style": "col-md-12",
        "items": [{
          "type": "button",
          "icon": "fa fa-arrow-right",
          "style": "btn-primary btn-block",
          "title": " weiter",
          "onClick": "ctrl.onSubmit(resetPasswordForm, ctrl.model)"
        }]
      }]
    }];

    vm.onSubmit = function(form, model) {
      // Event broadcasten um alle Felder zu validieren
      $scope.$broadcast('schemaFormValidate');
      // Prüfen ob Form valide ist
      if (form.$valid) {
        vm.loading = true;
        Restangular.one('user').one('password').withHttpConfig({
          cache: false
        }).customPUT({
          "token": vm.token,
          "password": model.password
        }).then(function() {
            vm.error = false;
            vm.success = true;
        }, function(response) {
          vm.error = true;
          vm.success = false;
          vm.errorCode = response.status;
          vm.errorText = "Passwort-Reset konnte nicht abgeschlossen werden. Bitte prüfen Sie ob Ihr Passwort den Kriterien entspricht und nicht Teile Ihrer E-Mail-Adresse enthält.";
        }).finally(function() {
          vm.loading = false;
        });
      }
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('hydra')
    .controller('ProfileController', ProfileController);

  /** @ngInject */
  function ProfileController($timeout, $scope, config, $log, principal, Restangular, toastr, $translate) {
    var vm = this;

    var logModName = 'PROFILE';
    var log = function(message) {
      $log.info(logModName + " " + message);
    }

    vm.password = {};
    vm.password.loading = false;
    vm.password.model = {};
    vm.userinfo = {};

    vm.password.schema = {
      "type": "object",
      "properties": {
        "old_password": {
          "title": "altes Passwort",
          "type": "string",
          "description": "Geben Sie hier Ihr altes Passwort ein."
        },
        "password": {
          "title": "Neues Passwort",
          "type": "string",
          "minLength": 8,
          "pattern": config.patterns.password,
          "description": "Geben Sie hier ein neues Passwort ein."
        },
        "password_confirmation": {
          "title": "Neues Passwort (nochmal zur Bestätigung)",
          "type": "string",
          "pattern": config.patterns.password,
          "minLength": 8,
          "description": "Geben Sie zur Bestätigung Ihr neues Passwort nochmal ein."
        }
      },
      "required": [
        "old_password",
        "password",
        "password_confirmation"
      ]
    };

    vm.password.form = [{
      "type": "fieldset",
      "title": "Passwort",
      "items": [{
        "key": "old_password",
        "type": "password",
        "placeholder": "altes Passwort",
        "feedback": false,
        "disableSuccessState": true,
        "disableErrorState": false,
        "validationMessage": {
          "302": "Bitte altes Password eingeben."
        }
      }, {
        "key": "password",
        "type": "password",
        "placeholder": "Neues Passwort",
        "feedback": false,
        "disableSuccessState": true,
        "disableErrorState": false,
        onChange: function() {
          vm.password.model.password_confirmation = '';
          vm.password.error = false;
          vm.password.errorCode = null;
        },
        "validationMessage": {
          "302": "Bitte Password eingeben.",
          "202": "Das Passwort muss aus Klein- und Großbuchstaben sowie Zahlen bestehen."
        }
      }, {
        "key": "password_confirmation",
        "type": "password",
        "placeholder": "Neues Passwort",
        "feedback": false,
        "disableSuccessState": true,
        "disableErrorState": false,
        onChange: function() {
          vm.password.error = false;
          vm.password.errorCode = null;
        },
        "validationMessage": {
          "302": "Bitte Password eingeben.",
          "202": "Das Passwort muss aus Klein- und Großbuchstaben sowie Zahlen bestehen.",
          "isEqual": "Die Passwörter müssen identisch sein."
        },
        $validators: {
          isEqual: function(value) {
            if (value == vm.password.model.password) {
              return true;
            }
            return false;
          }
        }
      }, {
        "type": "actions",
        "style": "col-md-12",
        "items": [{
          "type": "button",
          "icon": "fa fa-save",
          "style": "btn-primary btn-block",
          "title": " speichern",
          "onClick": "ctrl.password.submit(passwordForm, ctrl.password.model)"
        }]
      }]
    }];

    vm.password.submit = function(form, model) {
      // Event broadcasten um alle Felder zu validieren
      $scope.$broadcast('schemaFormValidate');
      // Prüfen ob Form valide ist
      if (form.$valid) {
        vm.password.loading = true;
        vm.password.error = false;
        vm.password.errorCode = null;
        Restangular.all('user').one('profile').one('password').withHttpConfig({
          cache: false
        }).customPOST({
          "username": vm.userinfo.email,
          "password": model.old_password,
          "password_confirmation": model.password,
          "accesstoken": principal.getAccessToken()
        }).then(function(response) {
          $log.debug("CHANGE PW SUCCESS");
          $log.debug(response);
          toastr.success('Das Passwort wurde erfolgreich geändert.', 'Passwort geändert');
        }, function(response) {
          $log.debug("CHANGE PW FAILED");
          $log.debug(response);
          vm.password.error = true;
          try {
            vm.password.errorCode = response.data.details.code;
            $translate("DSU_ERROR_" + vm.password.errorCode).then(function(error) {
              vm.password.errorText = error;
            }, function(translationId) {
              vm.password.errorText = translationId;
            });
          } catch (e) {
            vm.password.errorCode = response.status;
            vm.password.errorText = "Dieser Service ist momentan leider nicht verfügbar.";
          }
        }).finally(function(response) {
          $log.debug("CHANGE PW FINISHED");
          $log.debug(response);
          vm.password.loading = false;
        });
      }
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('hydra')
    .controller('LoginShopSelectController', LoginShopSelectController);

  /** @ngInject */
  function LoginShopSelectController($scope, $state, $stateParams, Restangular, $translate, principal, jwtHelper, userShopsService) {

    var vm = this;
    vm.model = {};
    vm.error = false;
    vm.loading = false;
    vm.shopsTitleMap = [];
    vm.shopsEnum = [];

    //principal.authenticate(null);

    // alles aus JWT auslesen
    vm.jwt = $state.params.jwt;

    // ODER aus localStorage
    if (!vm.jwt) {
      vm.jwt = principal.getToken();
    }

    // oder zurück zum Login
    if (!vm.jwt) {
      $state.go('main.login', {site : null});
    }

    var decodedJwt = jwtHelper.decodeToken(vm.jwt);

    userShopsService.getUserShopsViaRights(decodedJwt.user.rights).then(function(shops) {

      // removing shops that are not accessible to the user (user do not have proper broker)
      shops = vm.getShopsAudience(shops, decodedJwt);

      // shows error message if user don't have any broker associated
      if (shops.length == 0) {
        vm.error = true;
        vm.errorCode = 302;
        vm.errorText = "Keine Berechtigung – Bitte kontaktieren Sie den Kundensupport";
      }

      // set scope variables
      vm.shopsTitleMap = vm.formatAsTitleMap(shops);
      vm.shopsEnum = vm.formatAsEnum(shops);

      // also here, so we get the results rendered correctly
      vm.form[0].items[0].titleMap = vm.shopsTitleMap;
      vm.schema.properties.site.enum = vm.shopsEnum;
    });


    vm.schema = {
      "type": "object",
      "properties": {
        "site": {
          "title": "Wählen Sie die den gewünschten Partnershop",
          "type": "string",
          "description": ""
        }
      },
      "required": [
        "site"
      ]
    };

    vm.form = [{
      "type": "fieldset",
      "title": "Partnershop auswählen",
      "items": [{
        "key": "site",
        "type": "radios",
        "feedback": false,
        "titleMap": vm.shopsTitleMap,
        "disableSuccessState": true,
        "disableErrorState": true,
        "validationMessage": {
          "302": "Bitte einen Partnershop auswählen."
        }
      }, {
        "type": "actions",
        "style": "col-md-12",
        "items": [{
          "type": "button",
          "icon": "fa fa-arrow-right",
          "style": "btn-primary btn-block",
          "title": " weiter",
          "onClick": "ctrl.onSubmit(loginShopSelectForm, ctrl.model)"
        }]
      }]
    }];

    vm.onSubmit = function(form, model) {
      /*
      // Workaround because restangular often sets the bearer to null when using custom Header in just one request
      Restangular.addFullRequestInterceptor(function(element, operation, what, url, headers, params, httpConfig) {
        return {
          element: element,
          params: params,
          headers: _.extend(headers, {Authorization: 'Bearer ' + vm.jwt}),
          httpConfig: httpConfig
        };
      });
      */

      // Event broadcasten um alle Felder zu validieren
      $scope.$broadcast('schemaFormValidate');
      // Prüfen ob Form valide ist
      if (form.$valid) {
        vm.loading = true;
        Restangular.one('renewal').withHttpConfig({
          cache: false
        }).get({
          'source': 'hydra_' + model.site
        }).then(function(renewalResponse) {
            if (renewalResponse.Jwt.Token) {
              var stateGoObj = {
                "jwt": renewalResponse.Jwt.Token,
                "site": model.site
              };
              $state.go('main.loginJwt', stateGoObj);
            } else {
              vm.error = true;
            }
          },
          function(renewalResponse) {
            vm.error = true;
          }).finally(
          function(response) {
            vm.loading = false;
          }
        );
      }
    };

    $scope.$on('sf-render-finished', function(event, data) {
      vm.form[0].items[0].titleMap = vm.shopsTitleMap;
      vm.schema.properties.site.enum = vm.shopsEnum;
    });

    /**
     * return shop list as simple array with value > name mapping
     * @returns {Array}
     */
    vm.formatAsTitleMap = function (_shops) {
      var shopsTitleMap = [];

      for (var z = 0; z < _shops.length; z++) {
        shopsTitleMap.push({
          "value": _shops[z].key,
          "name" : _shops[z].name
        });
      }

      return shopsTitleMap;
    };

    /**
     * return shop keys as a flat array
     * @returns {Array}
     */
    vm.formatAsEnum = function (_shops) {
      var keys = [];

      for (var i = 0; i < _shops.length; i++) {
        keys.push(_shops[i].key);
      }

      return keys;
    };

    /**
     * returns the shop list based on the user brokers audience
     * @returns {Array}
     */
    vm.getShopsAudience = function (_shops, _decodedJwt) {
      var shops2 = [];
      for (var i = 0; i < _shops.length; i++) {
        if (vm.shopContainedInBrokerList(_shops[i].key, _decodedJwt.user.brokers.broker)) {
          shops2.push(_shops[i]);
        }
      }
      return shops2;
    }

    /**
     * verify if the shop is contained in the user brokers list audience
     * @returns {boolean}
     */
    vm.shopContainedInBrokerList = function (_id, _brokers) {
      for (var i = 0; i < _brokers.length; i++) {
        if (_brokers[i].audience && _brokers[i].audience.split("!/")[1] === _id) {
          return true;
        }
      }
      return false;
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('hydra')
    .factory('userShopsService', function (Restangular, $q, $filter, $cookies, $log) {

      var service = {
        data : {
          _shops: [], // all available (for this user)
          _shop: $q.defer(), // currently selected shop Data
          _siteKey: null,
          products : []
        },

        initialize : function() {
          this.getSiteKey();
          this.data._shop = this.getShop(this.data._siteKey);
          return this;
        },

        getUserShopsViaRights: function (userRights) {

          var mainPromise = $q.defer();
          var allPromises = [];
          var self = this;

          self.data._shops = [];

          angular.forEach(userRights, function (right) {

            if (right.match(/hydra_[^\.]*\.READ/)) {
              var deferred  = $q.defer();

              var siteKey = right.substr(0, right.indexOf('.')).substr(right.indexOf('_') + 1);
              Restangular.one('sites', siteKey).get().then(
                function (shop) {
                  self.data._shops.push(shop);
                  deferred.resolve(shop);
                },
                // on error
                function() {
                  // because a failing promise makes the whole chain fail, we need to handle this more "optimistically"
                  // "sites/vfmservice" throws 404 error, so we just skip the _shops.push()
                  deferred.resolve(null);
                }

              );

              allPromises.push(deferred.promise);
            }
          });

          $q.all(allPromises).then(
            // success
            function() {
              // mainPromise.resolve(results);
              // Send over only the list of shops that didn't fail with a 404

              self.data._shops = $filter('orderBy')(self.data._shops, 'name');
              mainPromise.resolve(self.data._shops);
            },
            // error
            function() {
              // something went wrong, how to handle it gracefully?
              mainPromise.reject();
            }
          );

          return mainPromise.promise;
        },

        getSiteId : function() {
          return this.data._shop.id;
        },

        getSiteKey : function() {
          if (this.data._siteKey === null) {
            this.data._siteKey = $cookies.get('aig.hydra.site');
          }
          return this.data._siteKey;
        },
        setSiteKey : function(key) {
          $cookies.put('aig.hydra.site', key);
          this.data._siteKey = key;

          this.data._shop = this.getShop(key);
        },

        currentShop : function() {
          return this.getShop(this.getSiteKey());
        },

        getShop : function(key) {
          var self = this;
          var deferred = $q.defer();

          if (key === null || typeof key === 'undefined') {
            return null;
          }

          Restangular.one('sites', key).get().then(
            function(response) {
              // Seite erfolgreich abgerufen
              self.data._shop = response;

              // TODO: handle parent relation for shops
              if (self.data._shop.mother != null) {
                Restangular.one('sites', self.data._shop.mother).get().then(
                  function(motherresponse) {
                    // Mutterseite erfolgreich abgerufen
                    self.data._shop.mother = motherresponse;
                    // daten ebenfalls in LS abspeichern
                    //self.site.set(self.site.data);
                    return motherresponse;
                  });
              }
              $log.log("site.get : " + self.data._shop.key);
              deferred.resolve(self.data._shop);
          });

          return deferred.promise;
        },

        getCategories : function(siteId) {

          if (typeof(siteId) === 'undefined') {
            siteId = this.getSiteId();
          }

          var listData = $q.defer();
          var categories = [];
          var promises = [];

          // previously loaded?
          if (_.isArray(service.data.products[siteId])) {
            listData.resolve(service.data.products[siteId]);
          }

          // first load
          Restangular.all('sitecategories').getList({
            "site": siteId
          }).then(function(sitecategories) {
            angular.forEach(sitecategories, function(sitecategory) {

              var subPromise = $q.defer();
              promises.push(subPromise.promise);

              Restangular.one('categories', sitecategory.category).get().then(
                function(category) {
                  category.sort = sitecategory.sort;
                  category.sitecategory = sitecategory.id;
                  category.site = sitecategory.site;

                  subPromise.resolve(category);
                  categories.push(category);
                }
              );
            });


            $q.all(promises).then(
              // on success
              function() {
                //return main promise
                service.data.products[siteId] = categories;
                listData.resolve(categories);
              },
              // on error
              function() {
                $log.error('subpromise failed');
                listData.reject();
              }
            );
          });

          return listData.promise;
        }
      };

      return service.initialize();
    });
})();


(function() {
  'use strict';

  angular
    .module('hydra')
    .factory('trackingService', function ($window, principal, Analytics, userShopsService) {

      var service = {
        data : {
          _user : null,
          startTime : null
        },
        dimensions : [
          'appVersion',
          'appEnv',
          'appDomain',

          'siteIdentifier', // e.g. "aig"
          'productCategoryId', // e.g. 46 in http://__/#!/authenticated/category/46
          'productKey', // e.g. wg022S

          'caseId' // backend saving ID
        ],
        metrics : [
          'versicherungssumme',
          'laufzeit',
          'praemie'
        ],

        getUserId : function() {
          // test test rights[49] >> tt49
          // TODO: get backend User IDs into frontend
          return service.data._user.name.substring(0,1) + service.data._user.surname.substring(0,1) + service.data._user.rights.length;
        },

        setUserId : function() {
          service.data._user = principal.user();
          // Set the User Id
          //Analytics.set('&uid', 1234);

          // Set Custom Dimensions and Metrics
          // configured also here: https://analytics.google.com/analytics/web/?hl=de#management/Settings/____/%3Fm.page%3DCustomDimensions%26m-content-dimensionsContent.rowShow%3D10%26m-content-dimensionsContent.rowStart%3D0%26m-content-dimensionsContent.sortColumnId%3Dindex%26m-content-dimensionsContent.sortDescending%3Dfalse%26m-content.mode%3DLIST/


          // TODO : track user timing (time to checkout, etc.)
          service.data.startTime = new Date().getTime();
        },
        trackTiming : function (actionName) {
          var endTime = new Date().getTime(),
            timeSpent = endTime - service.data.startTime;
          Analytics.trackTimings(actionName, 'User Timings', timeSpent);
        },

        trackEvent : function(category, action, label, value, customDimensions) {
          var nonInteraction = false; // https://support.google.com/analytics/answer/1033068#NonInteractionEvents

          // define site wide dimensions and metrics
          var defaultDimensions = {
            // application logic part
            siteIdentifier : userShopsService.getSiteKey(),

            // general app info
            appDomain : $window.location.hostname,
            appEnv : __env.name,
            appVersion : __env.version
          };

          var allDimensions = angular.merge({}, defaultDimensions, customDimensions);

          Analytics.trackEvent(category, action, label, value, nonInteraction, this.convertDimensions(allDimensions));
        },
        /**
         * turn named dimensions into dimension1 to dimension18 and metric1 to metric18
         * @param dimensions
         */
        convertDimensions : function(named) {
          var mixedDimMet  = {};
          var names = Object.keys(named);

          for (var x = 0; x < names.length; x++) {
            var dimpos = service.dimensions.indexOf(names[x]);
            var metpos = service.metrics.indexOf(names[x]);

            // case 1: named dimension
            if (dimpos > -1) {
              mixedDimMet['dimension' + (dimpos+1)] = named[names[x]];
            }
            // case 2 : named metric
            else if (metpos > -1) {
              mixedDimMet['metric' + (metpos+1)] = named[names[x]];
            }
            // case 3 : not defined previously, so add as new metrics or dimension
            else {
              if (isNaN(parseInt(named[names[x]]))) {
                // send as dimension
                mixedDimMet['dimension' + service.dimensions.length] = named[names[x]];
              }
              else {
                // send as metric
                mixedDimMet['metric' + service.metrics.length] = named[names[x]];
              }
            }
          }

          return mixedDimMet;
        },
        trackLogin : function() {
          service.setUserId();
          service.trackEvent('user', 'login', 'user login', 1); //, service.getUserId());
        }
      };

      return service;
    });
})();

(function () {
  'use strict';

  angular
    .module('hydra')
    .factory('principal', principal);

  /** @ngInject */
  function principal($q, $timeout, $cookies, jwtHelper, $log, $window, userShopsService, $state, brokerService) {
    var _identity = undefined;
    var _authenticated = false;
    var _token = null;
    var _site = null;
    var _brokers = null;
    var logModName = 'Principal.service -';
    var log = function (message) {
      $log.info(logModName + " " + message);
    };

    return {
      getAudience: function () {
        return _identity.aud;
      },
      getTokenExpirationDate: function () {
        return jwtHelper.getTokenExpirationDate(_token);
      },
      setBrokers: function (decodedJwt) {
        $log('setBrokers(): DEPRECATED: call setBrokers in brokerService');
        brokerService.setBrokers(decodedJwt);
      },
      setSite: function (siteKey) {
        _site = siteKey;
        userShopsService.setSiteKey(_site);
        log('setSite(): ' + _site);
      },
      getSite: function () {
        _site = userShopsService.getSiteKey(); //$cookies.get('aig.hydra.site');
        return _site;
      },
      isIdentityResolved: function () {
        return angular.isDefined(_identity);
      },
      isAuthenticated: function () {
        return _authenticated;
      },
      hasRight: function (right) {
        if (!_authenticated || !_identity.user.rights) return false;
        log("hasRight(): " + right.split(".")[0] + '_' + _site.toLowerCase() + "." + right.split(".")[1]);
        return _identity.user.rights.indexOf(right.split(".")[0] + '_' + _site.toLowerCase() + "." + right.split(".")[1]) != -1;
      },
      hasAnyRight: function (rights) {
        if (!_authenticated || !_identity.user.rights) return false;

        for (var i = 0; i < rights.length; i++) {
          if (this.hasRight(rights[i])) return true;
        }

        return false;
      },
      getToken: function () {
        if (_token === null) {
          _token = $window.localStorage.getItem('jwtToken');
          if (_token !== null && _token !== "null" && jwtHelper.isTokenExpired(_token)) {
            // make sure that localStorage is reset as well
            this.setToken(null);
          }
        }
        return _token;
      },
      setToken: function (token) {
        _token = token;
        $window.localStorage.setItem('jwtToken', token);
        return true;
      },
      authorize: function () {
        var isAuthenticated = this.isAuthenticated();
        var isAuthorizedToViewPage = true;
        var needToCheck = $state.current.hasOwnProperty('data') && $state.current.data.hasOwnProperty('rights') && $state.current.data.rights.length > 0;
        if (needToCheck) {
          isAuthorizedToViewPage = this.hasAnyRight($state.current.data.rights);
        }

        if (isAuthenticated && !isAuthorizedToViewPage) {
          // user is signed in but not authorized for the desired state
          $log.debug("Principal.service - authorize(): 401 - Not authorized to view page");
          return $state.go('main.404');
        }
        if (!isAuthenticated) {
          // User is not authenticated. Store the state the user wanted to go to before forwarding to the sign-in state, so
          // you can return them when you're done
          // TODO: $rootScope.returnToState = $rootScope.toState;
          // TODO: $rootScope.returnToStateParams = $rootScope.toStateParams;
          // now, send them to the signin state so they can log in
          $log.debug("Principal.service - authorize(): Forwarding to login page");
          return $state.go('main.login', {
            site: this.getSite()
          });
        }
        // Or do nothing (pass through original transition)
        // done in run block with onFinish Event navigationService.createNav();
      },

      authenticate: function (jwt, tryRestore) {
        _identity = null;
        _authenticated = false;
        //$log.debug(this.getSite());
        //$log.debug('trying to authenticate');
        // Store the identity in localStorage
        if (jwt) {
          //$log.debug('trying new authentication');
          // Store jwt in Cookie
          var decodedJwt = jwtHelper.decodeToken(jwt);
          $log.debug('Principal.service - authenticate(): decode token: ' + decodedJwt);
          $log.debug('Principal.service - authenticate(): hydra_' + _site.toLowerCase() + '.READ');

          $log.debug(decodedJwt.user.rights.indexOf('hydra_' + _site.toLowerCase() + '.READ'));
          if (decodedJwt.user.rights.indexOf('hydra_' + _site.toLowerCase() + '.READ') != -1) {

            $cookies.put('aig.hydra_' + _site + '.jwt', jwt);
            _identity = decodedJwt;
            $log.debug("Principal.service - authenticate(): ACCESSTOKEN: " + _identity.user.accesstoken);
            _authenticated = true;
            this.setToken(jwt); // make sure to do this before setBrokers, so we can read most recent from localStorage
            brokerService.setBrokers(decodedJwt);

            if (decodedJwt.user.brokers != undefined && decodedJwt.user.brokers.broker.length > 0) {
              // noop
            } else {
              log('authenticate(): access denied - no brokers assigned to user');
            }
          } else {
            log('authenticate(): access denied - insufficient rights');
          }
        } else {
          if (isLogoutTriggered(jwt, tryRestore)) {
            this.logout();
          } else {
            this.restoreAuthFromCookie();
          }
        }
        return _authenticated;
      },
      authenticateJwt : function(jwt) {
        var defer = $q.defer();
        var decodedJwt = jwtHelper.decodeToken(jwt);
        $log.debug('Principal.service - authenticate(): decode token: ' + decodedJwt);
        $log.debug('Principal.service - authenticate(): hydra_' + _site.toLowerCase() + '.READ');

        // is user allowed to access currently selected site?
        if (decodedJwt.user.rights.indexOf('hydra_' + _site.toLowerCase() + '.READ') === -1) {
          log('authenticate(): access denied - insufficient rights');
          defer.reject();
        }

        // does she have a broker id?
        else if (decodedJwt.user.brokers === undefined || decodedJwt.user.brokers.broker === undefined || decodedJwt.user.brokers.broker.length === 0) {
          log('authenticate(): access denied - no brokers assigned to user');
          defer.reject({status: 'no brokers assigned to user', reason: 'broker'});
        }

        // all good
        else {
          $cookies.put('aig.hydra_' + _site + '.jwt', jwt);
          _identity = decodedJwt;
          $log.debug("Principal.service - authenticate(): ACCESSTOKEN: " + _identity.user.accesstoken);
          _authenticated = true;
          this.setToken(jwt);
          brokerService.setBrokers(decodedJwt).then(
            function(brokers) {
              defer.resolve({done : true});
            },
            function() {
              defer.reject({status : 'error loading broker details', reason : 'broker'});
            }
          );
        }

        return defer.promise;
      },
      logout : function() {
        _authenticated = false;
        log('authenticate(): forcing log out and removing cookies');
        $cookies.remove('aig.hydra_' + _site + '.jwt');
        $cookies.remove('aig.hydra_' + _site + '.broker');
      },
      restore : function() {

      },
      restoreAuthFromCookie: function() {
        log('authenticate(): trying to restore authentication using jwt-cookie');
        // No valid jwt available, check if cookie has a valid jwt
        var jwtFromCookie = $cookies.get('aig.hydra_' + _site + '.jwt');
        if (jwtFromCookie) {
          log('authenticate(): jwt-cookie found');
          var decodedToken = jwtHelper.decodeToken(jwtFromCookie);
          // Check if token has expired
          if (!jwtHelper.isTokenExpired(jwtFromCookie)) {
            log('authenticate(): token is still valid');
            _identity = decodedToken;
            this.setToken(jwtFromCookie);
            _authenticated = true;
            return brokerService.setBrokers(decodedToken);
          } else {
            log('authenticate(): token has expired. Forcing log out and removing cookies');
            $cookies.remove('aig.hydra_' + _site + '.jwt');
            $cookies.remove('aig.hydra_' + _site + '.broker');
          }
        }

      },
      getRefreshToken: function () {
        return _identity.user.refreshtoken;
      },
      getAccessToken: function () {
        return _identity.user.accesstoken;
      },
      user: function () {
        return _identity.user;
      },
      username: function () {
        return (_identity !== null && _identity.hasOwnProperty('sub')) ? _identity.sub : '';
      },
      identity: function (force) {
        var deferred = $q.defer();

        if (force === true) {
          _identity = undefined;
        }

        // check and see if we have retrieved the
        // identity data from the server. if we have,
        // reuse it by immediately resolving
        if (angular.isDefined(_identity) && angular.isDefined(_site) && angular.isDefined(_brokers)) {
          deferred.resolve(_identity);
          deferred.resolve(_site);
          deferred.resolve(_brokers);
        }

        // otherwise, retrieve the identity data from the
        // server, update the identity object, and then
        // resolve.
        //           $http.get('/svc/account/identity',
        //                     { ignoreErrors: true })
        //                .success(function(data) {
        //                    _identity = data;
        //                    _authenticated = true;
        //                    deferred.resolve(_identity);
        //                })
        //                .error(function () {
        //                    _identity = null;
        //                    _authenticated = false;
        //                    deferred.resolve(_identity);
        //                });

        // for the sake of the demo, fake the lookup
        // by using a timeout to create a valid
        // fake identity. in reality,  you'll want
        // something more like the $http request
        // commented out above. in this example, we fake
        // looking up to find the user is
        // not logged in

        /*
                var self = this;
                $timeout(function() {
                  self.authenticate(null);
                  deferred.resolve(_identity);
                }, 1000);
        */
        return deferred.promise;
      }
    };

    function isLogoutTriggered(jwt, tryRestore) {
      return jwt == null && !tryRestore
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('hydra')
    .controller('LoginController', LoginController);

  /** @ngInject */
  function LoginController(config, $log, $scope, $state, $stateParams, Restangular, $translate, hydraData, principal, jwtHelper, trackingService) {

    var vm = this;
    var logModName = 'Login.controller -';

    vm.model = {};
    vm.error = false;
    vm.errorReason = '';
    vm.loading = false;
    vm.site = null;
    //CIAM Changes - Starts
    vm.userName = $state.params.user;
    vm.redirectUri = window.location.origin+window.location.pathname+"login";
    vm.clientId = null;
    vm.oktaURL = null;
    vm.showPasswordField=true;

    if(window.__env.name == "local")
    {
      vm.clientId = "0oahb61cr6vlK8ZgI1d7";
      vm.oktaURL = 'https://devauth1.customerpltfm.aig.com/oauth2/ausmgmbyeSo2EHuJs1d6';
    }
    else if(window.__env.name == "dev")
    {
      vm.clientId = "0oagmdfa485CGlLKd1d7";
      vm.oktaURL = 'https://devauth1.customerpltfm.aig.com/oauth2/ausmgmbyeSo2EHuJs1d6';
    }
    else if(window.__env.name == "test")
    {
      vm.clientId = "0oahka2twr7EGJLPM1d7";
      vm.oktaURL = 'https://uatauth1.customerpltfm.aig.com/oauth2/ausuekxpsCZZKg0Cw1d6';
    }
    else if(window.__env.name == "production")
    {
      vm.clientId = "0oalfxqpecsY6VRW75d7";
      vm.oktaURL = 'https://auth1.customerpltfm.aig.com/oauth2/aus187xvth5kQKY1t5d7';
    }
    //CIAM Changes - Ends
    vm.ticket = $state.params.ticket;
    vm.siteselect = false;
    vm.sites = null;

    vm.getPartnerSite = getPartnerSite;
    vm.loginWithJwt = loginWithJwt;
    vm.loginNeutral = loginNeutral;
    vm.login = login;
    vm.onSubmit = onSubmit;

    vm.schema = {
      type: 'object',
      properties: {
        site: {
          type: 'string',
          title: 'Partnershop',
          default: null
        }
        //CIAM Changes - Starts
        ,
        user: {
          title: 'E-Mail-Adresse',
          type: 'string',
          minLength: 6,
          pattern: config.patterns.email
        },
        password: {
          title: 'Passwort',
          type: 'string',
          minLength: 1
        }
        //CIAM Changes - Starts
      }
      //CIAM Changes - Starts
      ,
      required: [
        'user',
        'password'
      ]
      //CIAM Changes - Ends
    };

    vm.form = [
    //CIAM Changes - Starts
      {
      type: 'fieldset',
      items: [{
        key: 'user',
        feedback: false,
        disableSuccessState: true,
        disableErrorState: true,
        validationMessage: {
          302: 'Bitte E-Mail eingeben.',
          202: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.'
        },
        readonly : false,
        onChange: function(modelValue, form) {
          // Update the visibility of the password field based on the email entered
          vm.showPasswordField = !modelValue || !modelValue.endsWith('@aig.com');
        }

      }, {
        key: 'password',
        disableSuccessState: true,
        disableErrorState: true,
        feedback: false,
        type: 'password',
        validationMessage: {
          302: 'Bitte geben Sie ein Passwort ein.'
        },
        readonly : false,
        condition: "ctrl.showPasswordField" // Default to visible, will be toggled by onChange above

      }]
    }, 
    //CIAM Changes - Ends
    {
      type: 'actions',
      style: 'col-md-12',
      items: [{
        type: 'submit',
        icon: 'fa fa-sign-in',
        style: 'btn-primary btn-block',
        title: ' ANMELDEN'
      }]
    }];

    principal.authenticate(null);

    // Microsite abrufen
    if ($state.params.site) {
      vm.getPartnerSite($state.params.site);
    }

    if ($state.params.jwt && $state.params.site) {
      vm.loginWithJwt($state.params.site, $state.params.jwt);
    }

    //CIAM Changes - Starts
    if ($state.params.site && $state.params.code) {
      vm.login($state.params.site, null, null, $state.params.code);
    }
    else if ($state.params.site && $state.params.pass && $state.params.user) {
      vm.login($state.params.site, $state.params.user, $state.params.pass, null);
    }
    //CIAM Changes - Ends

    //CIAM Changes - Starts
    if (vm.userName) {
      vm.schema.properties.user.default = vm.userName;
    }
    //CIAM Changes - Ends

    function getPartnerSite (siteKey) {
      Restangular.one('sites', siteKey).get().then(
        function(response) {
          // Seite erfolgreich abgerufen
          hydraData.site.set(response);
          vm.site = response;
          principal.setSite(response.key);
          // geht man auf die Anmeldeseite und ist noch
          if (principal.isAuthenticated()) {
            principal.authenticate(null);
          }
          return response;
        },
        function() {
          $state.go('main.404');
        }
      );
    }

    /** when logging in via shopSelect, we pass a JWT via URL to the login form
     * PROBLEM: while broker info is still loading, user is presented with an empty login form
     * SOLUTION: make sure to disable all fields
     */
    function disableForms() {
      vm.form.forEach(function(form) {
        form.items.forEach(function(item) {
          item.readonly = true;
          item.style += ' disabled';
        });
      });
    }

    function loginWithJwt (siteKey, jwt) {
      //$log.debug('XXX - loginCtrl/loginWithJwt - start');
      vm.loading = true;
      disableForms();
      //vm.getPartnerSite(siteKey);
      Restangular.one('sites', siteKey).get().then(
        function(response) {
          // Seite erfolgreich abgerufen
          hydraData.site.set(response);
          vm.site = response;
          principal.setSite(response.key);
          // geht man auf die Anmeldeseite und ist noch
          if (principal.isAuthenticated()) {
            principal.authenticate(null);
          }
          if (jwt) {
            doJwtLogin(jwt);
          }
        },
        function() {
          $state.go('main.404');
        }
      );
      vm.loading = false;
    }

    //CIAM Changes - Starts
    //function loginNeutral (user, pass, ticket) {
      function loginNeutral (user, pass, code, ticket) {
    //CIAM Changes - Ends
      vm.loading = true;
      var bodyParams = null;
      
      if(code)
      {
          bodyParams = {
            //CIAM Changes - Starts
            // user: user,
            // password: pass,
            code: code,
            redirectUri: vm.redirectUri,
            //CIAM Changes - Ends
            ticket: ticket
          };
      }
      else
      {
        bodyParams = {
          user: user,
          password: pass,
          ticket: ticket
        };
      }
      Restangular.all('login').withHttpConfig({
        cache: false
      }).post(bodyParams, {
        source: 'hydra'
      }).then(function(response) {
          vm.loading = false;
          if (response.Jwt && response.Jwt.Token) {
            vm.error = null;

            // TODO: find other way to pass JWT (not as URL parameter)
            principal.setToken(response.Jwt.Token);
            // BECAUSE: IE11 has a smaller size limit for URL length, which gives
            // us a cryptic 'Access Denied' error when trying to set it
            // compare: https://stackoverflow.com/a/16991678
            $state.go('main.loginShopSelect', {});
          } else {
            log('onSubmit(): FAILED');
            vm.error = true;
          }
        },
        function() {
          log('onSubmit(): FAILED - service response status failure');
          vm.error = true;
        }
      ).finally(function() {
        vm.loading = false;
      });
    }

    //CIAM Changes - Starts
    //function login (siteKey, user, pass) {
    function login (siteKey, user, pass, code) {
    //CIAM Changes - Ends
      vm.loading = true;
      vm.getPartnerSite(siteKey);
      var bodyParams = null;
      
      if(code)
      {
          bodyParams = {
            //CIAM Changes - Starts
            // user: user,
            // password: pass,
            code: code,
            redirectUri: vm.redirectUri,
            //CIAM Changes - Ends
          };
      }
      else
      {
        bodyParams = {
          user: user,
          password: pass,
        };
      }
      Restangular.all('login').withHttpConfig({
        cache: false
      }).post(bodyParams, {
        source: 'hydra_' + siteKey
      }).then(function(response) {
          vm.loading = false;
          if (response.Jwt && response.Jwt.Token) {
            doJwtLogin(response.Jwt.Token);
          } else {
            log('onSubmit(): FAILED');
            vm.error = true;
          }
        },
        function() {
          log('onSubmit(): FAILED - service response status failure');
          vm.error = true;
        }
      ).finally(function() {
        vm.loading = false;
      });
    }

    function doJwtLogin(jwt) {
      vm.error = null;
      principal.authenticateJwt(jwt).then(
        // finished successfully
        function(result){
          log('onSubmit(): SUCCESS');
          trackingService.trackLogin();
          $state.go('main.authenticated.categories');
        },
        // finished with error
        function(err) {
          log('onSubmit(): FAILED');
          if (err.hasOwnProperty('reason') && err.reason === 'broker') {
            vm.errorReason = 'broker';
          }
          else {
            vm.errorReason = 'auth';
          }
          vm.error = true;
        });
    }

    //CIAM Changes - Starts
    // function onSubmit (form, login) {
    //   // Event broadcasten um alle Felder zu validieren
    //   $scope.$broadcast('schemaFormValidate');
    //   // Prüfen ob Form valide ist
    //   if (form.$valid) {
    //     if (vm.site) {
    //       vm.login(vm.site.key, login.user, login.password, null);
    //     } else {
    //       vm.loginNeutral(login.user, login.password, null);
    //     }
    //   }
    // }
    function onSubmit (form, login) {
      
      // Replace the following with your Okta domain and client ID
      if(login.user.endsWith("@aig.com"))
      {
        // Construct the Okta authorization URL
        var oktaAuthUrl = vm.oktaURL +
                          '/v1/authorize' +
                          '?client_id=' + vm.clientId +
                          '&response_type=code' +
                          '&response_mode=query' +
                          '&scope=openid profile email' +
                          '&redirect_uri=' + vm.redirectUri +
                          '&state=OpenIdConnect.AuthenticationProperties%3D66WSycePo8QkeHdWUhWjukxKmjOKMwE14WtWzj1mPfUz7keqUI-TmABMgp4jVyaPlZ5VvSnWTr2cK8wCcSJ90H1aiFoQfbFaWnWPWRkJMRND_Hn9K8rL7DkpJ--i_XUYLHONYvT8TkUbfCn8bcu7jhemu7V9CATMqLhBURZB3L_FZwqrWGczMQ8OU-LmHBIBo7SjBcm5iK0ayKOWbJnNHnWZEN5ZG8ofAyfWZdCX4hnoPM0BMT-3-LX3Iu0oFwSQ' +
                          '&nonce=638252853153817108.NTgxYTExMWItMGE2Ni00ZWFmLTkwYjEtMzg3OWU1NDIzZDdhYmZhMjljODctN2Y4Yy00MDI5LWIyY2MtMTA2NDdlNTQ5OWVh';

        // Redirect to the Okta authorization URL
        window.location.href = oktaAuthUrl;
      }
      else{
          $scope.$broadcast('schemaFormValidate');
          // Prüfen ob Form valide ist
          if (form.$valid) {
            if (vm.site) {
              vm.login(vm.site.key, login.user, login.password, null);
            } else {
              vm.loginNeutral(login.user, login.password, null, null);
            }
          }
      }
    }
    //CIAM Changes - Ends
    

    function log (message) {
      $log.info(logModName + ' ' + message);
    }

    //CIAM Changes - Starts
    // Capture the authorization code from the URL
    vm.checkForAuthorizationCode = function() {

      //var urlParams = new URLSearchParams(window.location.search);
      //var code = urlParams.get('code');
      console.log('in checkForAuthorizationCode');
      // Get the full URL
    var fullUrl = window.location.href;
    console.log(fullUrl);
    // Extract the part after #! (or just #)
    var hashIndex = fullUrl.indexOf('#!');
    var queryString = (hashIndex !== -1) ? fullUrl.substring(hashIndex + 2) : '';
    console.log(queryString);
    // Use URLSearchParams to parse the query string (after `?`)
    if (queryString.includes('?')) {
      var paramsString = queryString.split('?')[1];
      var urlParams = new URLSearchParams(paramsString);

      var code = urlParams.get('code');
      

      console.log('code: ', code); // value1
    

      if (code) {
          // You have the authorization code. Now, you need to exchange it for tokens.
          console.log('Authorization code:', code);

          // Example: Send the code to your backend server to exchange for tokens
            if (vm.site) {
              vm.login(vm.site.key, null, null, code);
            } else {
              vm.loginNeutral(null, null, code, null);
            }
      }
      else{
          $scope.$broadcast('schemaFormValidate');
          // Prüfen ob Form valide ist
          if (form.$valid) {
            if (vm.site) {
              vm.login(vm.site.key, login.user, login.password, null);
            } else {
              vm.loginNeutral(login.user, login.password, null, null);
            }
          }
      }
    }
    }
    //CIAM Changes - Ends

    vm.checkForAuthorizationCode();
  }
})();

(function () {
  'use strict';

  angular
    .module('hydra')
    .factory('brokerService', /** @ngInject */function (Restangular, $http, $state, $log, $q, config, jwtHelper, $rootScope) {

      var _brokers = [];
      var brokerIndex = 0;

      var service = {

        current : null,

        setBrokers: function (decodedJwt) {

          var mainPromise = $q.defer();

          /* skip this as it breaks shop switch of logged in user
          result: this will be called during login and on every auth refresh
          // resolve directly if broker info has already been loaded
          if (_brokers.length > 0) {
            mainPromise.resolve(_brokers);
          }
          */

          if (decodedJwt.user.brokers !== undefined && decodedJwt.user.brokers.broker.length > 0) {
            var brokers = decodedJwt.user.brokers.broker;
            var allPromises = [];

            var rawJwt = window.localStorage.getItem('jwtToken'); // need to get the newest one, don't trust global request interceptor

            // make sure we only load every brokerId once
            var loadingIds = [];
            var brokerData = [];

            // Load additional data here, once so it's available for whole session
            _.forEach(brokers, function(broker) {

              if (loadingIds.indexOf(broker.id) === -1) {
                var defer = $q.defer();

                $http({
                  method: 'GET',
                  url: config.baseUrl + '/broker',
                  headers: {Authorization: 'Bearer ' + rawJwt},
                  params: {id: broker.id},
                  cache: false
                }).then(
                  function (res) {
                    // add additional fields (such as contact and billing) [but keep the rights part intact]
                    //broker = _.extend(broker, res.data.broker);
                    defer.resolve(res.data.broker);
                  },
                  function() {
                    defer.reject();
                  }
                );
                allPromises.push(defer.promise);

                loadingIds.push(broker.id);
              }
            });

            $q.all(allPromises).then(
              function(brokerIdDetails) {
                // refresh data (in case needed) by assiging payment details from subsequent request based on broker.id match
                _brokers = assignBrokerDetails(brokers, brokerIdDetails);
                // re-set currently selected broker
                service.current = _brokers[brokerIndex];

                mainPromise.resolve(_brokers);
              },
              function() {
                mainPromise.reject({status : 'at least one broker did not load'});
              }
            );

          } else {
            _brokers = [];
            mainPromise.resolve(_brokers);
          }

          return mainPromise.promise;
        },
        getBrokers: function () {
          return _brokers;
        },
        setBroker: function (broker) {

          brokerIndex = _brokers.indexOf(broker); // to survive resetting broker model after re-auth
          service.current = broker;
          $state.go('.', {brokerId : broker.id}, {notify : false});

          //$rootScope.$emit('broker:switch'); // to make sure form payment method updates accordingly
        },
        setBrokerById: function (brokerId) {
          service.current = _.findWhere(_brokers, {id : brokerId});
          brokerIndex = _brokers.indexOf(service.current); // to survive resetting broker model after re-auth
        },
        getBroker: function () {
          // PROBLEM: need default broker
          // ASSUMPTION: user has at least one broker assigned
          // SOLUTION: use first in array of brokers
          if (!service.current) {
            service.current = _brokers[0];
          }
          return service.current;
        },
        getBrokerName: function () {
          var broker = this.getBroker();
          return broker.name + ' ' + broker.number;
        },
        matchingAudience: function (broker, currentSite) {
          // e.g. "audience": "http://www.wuebanet.de/hydra/#!/kreative"

          // early exit
          if (broker.hasOwnProperty('audience') === false) {
            return false;
          }

          var parts = broker.audience.split('/');

          // if last element in audience URL matches currentSite key, we have a match
          return (parts[parts.length - 1] === currentSite);
        },
        /**
         * get extra information for a broker (payment method etc)
         * @param token
         * @returns {Promise<U>|Promise<R>}
         */
        getBrokerById: function (token) {
          return $http({
            method: 'GET',
            url: config.baseUrl + '/broker',
            headers: {Authorization: 'Bearer ' + token},
            params: {id: this.getBroker().id},
            cache: false
          })
          .then(function (response) {
            return $q.resolve(response.data);
          })
          .catch(function (error) {
            $log.error('Broker.service - getBrokerById(): Request failed with error: ', error);
            return $q.reject();
          });
        }
      };

      function assignBrokerDetails(brokerList, brokerIdInfo) {
        brokerList.forEach(function(broker) {
          var matchingBrokerInfo = _.findWhere(brokerIdInfo, {id : broker.id});
          _.extend(broker, matchingBrokerInfo);
        });

        return brokerList;
      }

      return service;
    });
})();

(function() {
  'use strict';

  angular
    .module('hydra')
    .factory('authorization', authorization);

  /** @ngInject */
  function authorization($log, $q, $http, $timeout, principal, $rootScope, $state, hydraData, navigationService) {
    return {
      authorize: function() {
        return principal.identity()
          .then(function() {
            var isAuthenticated = principal.isAuthenticated();

            if ($state.current.hasOwnProperty('data') && $state.current.data.hasOwnProperty('rights') && $state.current.data.rights.length > 0 && !principal.hasAnyRight($state.current.data.rights)) {
            //if ($rootScope.toState.data.rights && $rootScope.toState.data.rights.length > 0 && !principal.hasAnyRight($rootScope.toState.data.rights)) {
              if (isAuthenticated) {
                // user is signed in but not
                // authorized for desired state
                $log.debug("go 404 - auth but no rights");
                $state.go('main.404');
              } else {
                // user is not authenticated. Stow
                // the state they wanted before you
                // send them to the sign-in state, so
                // you can return them when you're done
                $rootScope.returnToState = $rootScope.toState;
                $rootScope.returnToStateParams = $rootScope.toStateParams;
                // now, send them to the signin state
                // so they can log in
                $log.debug("go back to login");
                $state.go('main.login', {
                  "site": principal.getSite()
                });
              }
            }
            navigationService.createNav();
          });
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('hydra')
    .service('SchemaFormService', function () {
      return {
        markRequiredFieldsWithAsterisk: markRequiredFieldsWithAsterisk
      }

      function markRequiredFieldsWithAsterisk(schema) {
        var editableSchema = copySchema(schema);
        editableSchema.required.forEach(function (value) {
          editableSchema.properties[value].title += '*';
        });
        return editableSchema;
      }

      function copySchema(schema) {
        return Object.assign({}, schema);
      }
    });
})();

(function () {
  'use strict';

  angular
    .module('hydra')
    .service('QualitySealService', function () {
      var availableQualitySeals = {
       // xsp01: 'topschutz_fff',
       // xhp01: 'topfam_ff'
      }

      return {
        findQualitySealName: findQualitySealName
      }

      function findQualitySealName(categoryKey) {
        var keys = Object.keys(availableQualitySeals);
        var result = _.find(keys, function (key) {
          return key === categoryKey
        });
        if (result != null) {
          return availableQualitySeals[categoryKey];
        }
        return result;
      }
    })
})();

(function() {
  'use strict';

  angular
    .module('hydra')
    .controller('TransferServiceApprovalController', TransferServiceApprovalController);

  /** @ngInject */
  function TransferServiceApprovalController($log,
                                            $scope,
                                            $state,
                                            Restangular,
                                            config,
                                            SchemaFormService) {

    var vm = this;
    vm.model = {};
    vm.loading = false;
    vm.success = false;
    vm.error = false;
    vm.onSubmit = onSubmit;
    vm.schema = {
      type: "object",
      properties: {
        surname: {
          title: "Vorname", // required field will be marked with an asterisk
          type: "string",
          minLength: 1,
          maxLength: 70
        },
        lastname: {
          title: "Nachname", // required field will be marked with an asterisk
          type: "string",
          minLength: 1,
          maxLength: 70
        },
        email: {
          title: "E-Mail-Adresse", // required field will be marked with an asterisk
          type: "string",
          minLength: 6,
          maxLength: 50,
          pattern: config.patterns.email
        },
        telephone: {
          title: "Telefonnr. für Rückfragen", // required field will be marked with an asterisk
          type: "string",
          minLength: 1,
          maxLength: 30,
          pattern: config.patterns.telephone
        },
        applicationbrokers: {
          type: "array",
          minItems: 1,
          title: "Vermittler",
          items: {
            type: "object",
            properties: {
              brokernumber: {
                title: "Vermittlernr.",
                type: "string",
                minLength: 1,
                maxLength: 30,
                pattern: config.patterns.brokernumber,
              },
              ihknumber: {
                title: "IHK-Nr.",
                type: "string",
                minLength: 1,
                maxLength: 30
              }
            },
            required: [
              "brokernumber",
              "ihknumber"
            ]
          }
        }
      },
      required: [
        "surname",
        "lastname",
        "email",
        "telephone"
      ]
    };

    vm.form = [{
      type: "fieldset",
      title: "Antrag auf Nutzung des Transferservice",
      items: [{
        type: "section",
        htmlClass: "row",
        items: [{
          type: "section",
          htmlClass: "col-xs-12 col-md-4",
          items: [{
            key: "surname",
            type: "text",
            disableSuccessState: true,
            disableErrorState: false,
            feedback: false,
            validationMessage: {
              302: ""
            }
          }]
        }, {
          type: "section",
          htmlClass: "col-xs-12 col-md-4",
          items: [{
            key: "lastname",
            type: "text",
            disableSuccessState: true,
            disableErrorState: false,
            feedback: false,
            validationMessage: {
              302: ""
            }
          }]
        }, {
          type: "section",
          htmlClass: "col-xs-12 col-md-4",
          items: [{
            key: "email",
            type: "text",
            feedback: false,
            disableSuccessState: true,
            disableErrorState: false,
            validationMessage: {
              202: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
              302: "Bitte E-Mail eingeben."
            }
          }]
        }]
      }, {
        type: "section",
        htmlClass: "row",
        items: [{
          type: "section",
          htmlClass: "col-xs-12 col-md-4",
          items: [{
              key: "telephone",
              type: "text",
              disableSuccessState: true,
              disableErrorState: false,
              feedback: false,
              validationMessage: {
                202: "Es sind Ziffern von 0 bis 9 sowie die Sonderzeichen +, - und / erlaubt.",
                302: "Bitte Telefonnummer eingeben."
              }
            }
          ]
        }, {
          type: "section",
          htmlClass: "col-xs-12 col-md-8",
          items: [{
            key: "applicationbrokers",
            notitle: false,
            add: "weitere",
            items: [{
              type: "section",
              htmlClass: "row",
              items: [{
                type: "section",
                htmlClass: "col-xs-12 col-md-6",
                items: [{
                  key: "applicationbrokers[].brokernumber",
                  disableSuccessState: true,
                  disableErrorState: false,
                  feedback: false,
                  validationMessage: {
                    202: "Es sind Ziffern von 0 bis 9 erlaubt.",
                    302: "Bitte Vermittlernummer eingeben."
                  }
                }]
              }, {
                type: "section",
                htmlClass: "col-xs-12 col-md-6",
                items: [{
                  key: "applicationbrokers[].ihknumber",
                  disableSuccessState: true,
                  disableErrorState: false,
                  feedback: false,
                  validationMessage: {
                    302: "Bitte IHK-Nummer eingeben."
                  }
                }]
              }]
            }]
          }]
        }]
      }, {
        type: "actions",
        style: "col-md-12",
        items: [{
          type: "button",
          icon: "fa fa-arrow-right",
          style: "btn-primary btn-block",
          title: " Absenden",
          onClick: "ctrl.onSubmit(registerForm, ctrl.model)"
        }]
      }]
    }];

    SchemaFormService.markRequiredFieldsWithAsterisk(vm.schema);
    SchemaFormService.markRequiredFieldsWithAsterisk(vm.schema.properties.applicationbrokers.items);

    function onSubmit(form, model) {
        // Event broadcasten um alle Felder zu validieren
        $scope.$broadcast('schemaFormValidate');
        if (form.$valid) {
          var editableModel = Restangular.copy(model); // leave original model unmodified
          editableModel.type = 'bipro_430';
          vm.loading = true;
          Restangular
            .one('applications')
            .withHttpConfig({
              cache: false
            })
            .customPOST(editableModel)
            .then(
              function() {
                vm.success = true;
                vm.error = false;
              },
              function(response) {
                vm.success = false;
                vm.error = true;
                try {
                  vm.errorCode = response.status;
                  if (vm.errorCode === 404) { //token falsch
                    vm.errorText = "Überprüfung des Tokens nicht erfolgreich. Bitte neu eingeben und Gross-/Kleinschreibung beachten.";
                  } else if (vm.errorCode === 500) {
                    vm.errorText = "Dieser Service ist momentan leider nicht verfügbar.";
                  } else {
                    vm.errorText = "Aus technischen Gründen ist die Seite gegenwärtig nicht verfügbar."
                  }
                } catch (e) {
                  vm.errorText = "Dieser Service ist momentan leider nicht verfügbar.";
                }
              })
              .finally(function() {
                vm.loading = false;
              }); // finally
        } //$valid
      } //onSubmit
  } //ClearanceRequestController
})();

(function() {
  'use strict';

  angular
    .module('hydra')
    .directive('randomBackground', randomBackground);

  /** @ngInject */
  function randomBackground() {
    var directive = {
      restrict: 'E',
      transclude: true,
      scope: {},
      templateUrl: 'app/components/randomBackground/randomBackground.directive.html',
      link: function(scope){
        var backgrounds = [
          "image019.jpg",
          "image013.jpg",
          "image012.jpg",
          "image009.jpg",
          "image008.jpg",
          "image007.jpg",
          "image003.jpg",
          "image209.jpg",
          "image175.jpg",
          "image112.jpg",
          "image055.jpg",
          "image050.jpg",
          "image039.jpg",
          "image035.jpg",
          "image021.jpg",
          "image020.jpg"
        ];
        scope.image = backgrounds[Math.floor(Math.random() * backgrounds.length)];
      }
    };
    return directive;
  }
})();

(function() {
  'use strict';

  angular
    .module('hydra')
    .component('qualitySeal', {
      templateUrl: 'app/components/quality-seal/quality-seal.component.html',
      bindings: {
        category: '<'
      },
      controller: function QualitySealController (QualitySealService) {
        this.getImageName = getImageName;

        function getImageName(categoryKey) {
          return QualitySealService.findQualitySealName(categoryKey);
        }
      }
    });
})();

// based on http://plnkr.co/edit/oRmKRV?p=preview
(function() {
  'use strict';

  angular
    .module('hydra')

    .directive('uiSelectChoices', ['$timeout', '$parse', '$compile', '$document', '$filter', function($timeout, $parse, $compile, $document, $filter) {
  return function(scope, elm, attr) {
    var raw = elm[0];
    var scrollCompleted = true;

    //attr.allChoices = 'form.titleMap';
    //attr.repeat = 'item in $select.pageOptions.items';
    if (!attr.allChoices) {
      throw new Error('ief:ui-select: Attribute all-choices is required in  ui-select-choices so that we can handle  pagination.');
    }

    scope.pagingOptions = {
      rawData: scope.$eval(attr.allChoices)
    };

    attr.refresh = 'addMoreItems()';
    var refreshCallBack = $parse(attr.refresh);
    elm.bind('scroll', function(event) {
      var remainingHeight = raw.offsetHeight - raw.scrollHeight;
      var scrollTop = raw.scrollTop;
      var percent = Math.abs((scrollTop / remainingHeight) * 100);

      if (percent >= 80) {
        if (scrollCompleted) {
          scrollCompleted = false;
          event.preventDefault();
          event.stopPropagation();
          var callback = function() {
            scope.addingMore = true;
            refreshCallBack(scope, {
              $event: event
            });
            scrollCompleted = true;

          };
          $timeout(callback, 100);
        }
      }
    });

    var closeDestroyer = scope.$on('uis:close', function() {
      var pagingOptions = scope.$select.pagingOptions || {};
      pagingOptions.filteredItems = undefined;
      pagingOptions.page = 0;
    });

    /**
     * PROBLEM: if using asyncCallback to get the titlemap, initial data source is empty
     * SOLUTION: scope watch on attr.allChoices (form.titlemap)
     */
    var callbackWatcher = scope.$watch(attr.allChoices, function (newList) {
      if (newList !== undefined) {
        scope.pagingOptions.rawData = newList;
      }
      //console.log('got new allChoices (= form.titlemap), probably via getTitlemap asny call', newList);
    });


    scope.addMoreItems = function(doneCalBack) {
      console.log('new addMoreItems');
      var $select = scope.$select;
      var allItems = scope.pagingOptions.rawData || [];
      var searchResults = [];
      var search = $select.search;

      var pagingOptions = $select.pagingOptions = $select.pagingOptions || {
          page: 0,
          pageSize: 20,
          items: $select.items
        };

      var itemsThreshold = pagingOptions.pageSize; // used to be 100

      console.log('search term=' + search);
      console.log('prev search term=' + pagingOptions.prevSearch);
      var searchChanged = (search !== pagingOptions.prevSearch);
      console.log('isSearchChanged=' + searchChanged);

      // show old list of search results again (on second open of list)
      if (pagingOptions.searchResults && searchChanged === false) {
        return true;
      }

      if (pagingOptions.page === 0) {
        pagingOptions.items.length = 0;
      }
      if (!pagingOptions.originalAllItems) {
        pagingOptions.originalAllItems = scope.pagingOptions.rawData;
      }
      //scope.searchResultCount = (pagingOptions.hasOwnProperty('filteredItems') && typeof(pagingOptions.filteredItems) !== 'undefined') ? pagingOptions.filteredItems.length : 0;

      /*if (pagingOptions.filteredItems && searchDidNotChange) {
        allItems = pagingOptions.filteredItems;
      }*/

      if (search === '') {
        pagingOptions.searchResults = undefined;
      }


      // early exit (already displaying full list)
      if (pagingOptions.hasOwnProperty('items') && pagingOptions.items.length === allItems.length && searchChanged === false) {
        return true;
      }

      // save search input for next round
      pagingOptions.prevSearch = search;

      //search
      //if (search && search.length > 0 && pagingOptions.items.length < allItems.length && searchChanged) {
      if (search && search.length > 0 && searchChanged) {

        // reset list
        pagingOptions.filteredItems = undefined;

        // do search
        searchResults = $filter('filter')(pagingOptions.originalAllItems, search);
        pagingOptions.searchResults = searchResults;

        pagingOptions.items.length = 0;
        allItems = searchResults;

        //if filtered items are too many scrolling should occur for filtered items
        if (searchResults.length > itemsThreshold) {
          pagingOptions.page = 0;
          pagingOptions.filteredItems = searchResults;

        } else {
          pagingOptions.filteredItems = undefined;
        }

      } else {
        console.log('plain paging');
      }

      pagingOptions.page++;

      // select next entries to display
      if (pagingOptions.page * pagingOptions.pageSize <= allItems.length) {
        searchResults = allItems.slice(pagingOptions.items.length, pagingOptions.page * pagingOptions.pageSize);
      }

      // special case: last page with a few items (Zimmerei)
      else if (pagingOptions.page * pagingOptions.pageSize > allItems.length && pagingOptions.items.length < allItems.length) {
        searchResults = allItems.slice(pagingOptions.items.length);
      }

      // In case no paging is needed
      else if (pagingOptions.pageSize > allItems.length && search === '') {
        searchResults = allItems;
      }

      // add to list used in ui
      for (var k = 0; k < searchResults.length; k++) {
        pagingOptions.items.push(searchResults[k]);
      }

      scope.calculateDropdownPos();
      scope.$broadcast('uis:refresh');
      if (doneCalBack) doneCalBack();
    };

    // selecting an item via mouse click does not reset the dropdown selection,
    // so we need to pretend it was selected  (via keyboard) using "ENTER"
    scope.fakeEnter = function($select, item) {
      $select.activeIndex = $select.items.indexOf(item);
      //$select.select($select.items[$select.activeIndex], false);
    };

    /**
     * PROBLEM: $$value$$ magic is broken for ui-select inside an Array repeater (such as "Private Risiken" in Haftpflicht)
     * DETAIL: on-select="model['Wagnis']['PrivatRisiko']['']['Wagnisart']=$item.value; (NOTICE: the [''] should be an array index
     * SOLUTION: we know that this item is part of a repeater when "item" is defined as a variable, we also know which attribute to set (via $scope.form.key)
     *
     * @param $item
     * @param repeaterItem
     */
    scope.extraSelectBinding = function($item, repeaterItem) {
      // only do this if inside a repeater element
      if (typeof repeaterItem !== 'undefined') {
        var attrName = _.last(scope.form.key);
        repeaterItem[attrName] = $item.value;
      }
    };

    /** PROBLEM: we resetting a form (by loading an entry again, after manual but unsaved changes, the form is not reset correctly
     *  SOLUTION: watch the bound property for external changes
     *  ASSUMPTION: in index.run.js we changed ui-choices to have an extra attribute form-model="$$value$$"
     */
    var currentFormField = attr.formModel; // e.g. model['Wagnis']['Hauptwagnis']['Wagnisart'] (as string)

    // PROBLEM:   nested dropdowns in Array (such as Privatrisiko) don't have properly addressable names
    // ASSUMTION: and also don't need this workaround, because resetting them works correctly
    // SOLUTION: filter them out
    var fieldWatcher = function() {
      // nothing, but don't break $destroy logic
    };

    if (currentFormField.indexOf('[\'\']') === -1) {
      fieldWatcher = scope.$watch(currentFormField, function(newValue, oldValue) {

        // only if change was not trigged via UI
        if (newValue !== undefined && scope.$select.hasOwnProperty('selected') && scope.$select.selected.value !== newValue) {
          var externalResetValue = _.findWhere(scope.$select.items, {value : newValue});
          scope.$select.select(externalResetValue);
        }

      });
    }

    // unbind events
    scope.$on('$destroy', function() {
      elm.off('scroll');
      closeDestroyer();
      // clear watchers
      callbackWatcher();
      fieldWatcher();
    });
  };
}]);


})();

(function() {
  'use strict';

  angular
    .module('hydra')
    .controller('PlaygroundController', PlaygroundController);

  /** @ngInject */
  function PlaygroundController($log, $scope, $state, $stateParams, $translate, hydraData, config, $http, $q, principal, brokerService, Restangular, jsonParserService) {

    var vm = this;

    // to prevent errors
    $scope.getTitlemaps = /*function() {
      var defer = $q.defer();
      defer.resolve(vm.groupedTitlemap);
      return defer.promise;
    };*/
    function getTitlemaps(paramObj) {
      return $http({
        method: 'GET',
        url: config.baseUrl + '/titlemaps',
        params: paramObj,
        cache: true
      });
    };

    vm.forms = {
      login : {
        name : 'Login Form (Email + Password)',
        schema : {
          "type": "object",
          properties : {
            "eins" : {
              "type": "string",
              "default":"dr"
            },

            "zwei" : {
              "type": "number",
              "format" : "decimal",
              "default":1
            },

            "drei" : {
              "type": "number",
              "format" : "currency",
              "default":2
            },

            // copied from /X4/Service/hydra/definitions/versicherungsbeginn
            "vier" : {
              "type" : "string",
              "format" : "datepicker",
              "title": "Versicherungsbeginn",
              "x-schema-form":{
                "dateOptions":{
                  "minDate":"today",
                  "autoclose":true,
                  "dateFormat":"mediumDate",
                  "startDate":"today"
                }
              }
            }
          }
        },
        form : [
          {"key" : "vier", "type" : "datepicker"}, // twice
          {"key" : "eins"},
          {"key" : "zwei"},
          {"key" : "drei"},
          {"key" : "vier"}
        ]
      }
    };

    vm.form = {};
    vm.showModel = false;

    if (angular.isDefined($stateParams.formId) && $stateParams.formId !== '') {

        if ($stateParams.formId === 'regex') {

          var notJson = '';
          $http.get('app/components/playground/data/notjson.txt').then(function(result) {
            notJson = result.data;

            function allIndexes(str, needle) {
              var indices = [];
              var offset = 0,
                  nextIndex = 0;

              for(var i=0; i<str.length; i++) {
                nextIndex = str.indexOf(needle, i);
                indices.push(nextIndex);
                // skip contents of search string
                i += nextIndex + needle.length;
                // and look for next match after
                offset += nextIndex;
              }
              return indices;
            }

            function findFunctions(input) {
              var startString = '$validators: ';
              var endString = '}';
              var openingBrackets = 0;
              var closingBrackets = 0;
              var currentSymbol = '';
              var beginnings = allIndexes(input, startString);
              var endings = [];
              var functions = [];
              var functionCounter = 0;

              // find matching closing bracket (after all if else clauses etc.)
              for (var i = 0; i < input.length; i++) {
                currentSymbol = input[beginnings[functionCounter] + startString.length + i];
                if (currentSymbol === '{') {
                  openingBrackets++;
                }
                else if (currentSymbol === '}') {
                  closingBrackets++;
                }

                // reached end of function?
                if (closingBrackets-1 === openingBrackets) {
                  endings.push(beginnings[functionCounter] + startString.length + i);

                  functions.push(input.substring(beginnings[functionCounter] + startString.length, endings[functionCounter]));

                  functionCounter++;

                  i = 0;
                  closingBrackets = 0;
                  openingBrackets = 1;
                }
                if (functionCounter === beginnings.length) {
                  break;
                }
              }

              return functions;
            }

            function replaceFunctions(input) {
              var output = input;
              var functions = findFunctions(input);

              for(var i=0; i < functions.length; i++) {
                output = output.replace(functions[i], '"dummy"');
              }

              output = output.replace(/\$validators/g, '"$validators"');

              return output;
            }
            var realJson = replaceFunctions(notJson);

            /*
            var validatorfunctionsAsStrings = XRegExp.matchRecursive(notJson, '$validators: { function(value) {', '}}', 'g', {
              valueNames: ['one', 'two', 'three', 'four']
              //valueNames: ['literal', null, 'value', null],
              //escapeChar: '\\'
            });

            console.log(validatorfunctionsAsStrings);
            */
            //console.log(realJson);
              /*

              XRegExp.matchChain(notJson, [
              {regex: /\$validators : {([^"]+)}/i, backref: 1},
              {regex: XRegExp('(?i)^https?://(?<domain>[^/?#]+)'), backref: 'domain'}
            ]);
            */
          });
        }
        else if ($stateParams.formId === 'hauruck') {
          hydraData.entities.getList(17).then(
            // success
            function(results) {
            vm.model = angular.merge({},vm.model, results.defaults);
            //localStorage.setItem('debug2', JSON.stringify(results));
            vm.form = {
              form: results.entities[0].JSONReqForm,
              schema : results.entities[0].JSONReqSchema
            };
          },
          // on error
            function(results) {
              console.error(results);
            }
          );
        }

        else if($stateParams.formId === 'duno64') {
           Restangular.one('definitions', 63).get({js: false}).then(function(res) {
             console.log(res);
             var yes = jsonParserService.safeParse(res.content);
             console.log('done', yes);
           } );
        }
        else {

          vm.form = vm.forms[$stateParams.formId];
          if (vm.form.model) {
            vm.model = angular.merge({}, vm.form.model);
          }
        }
    }
    else {
      vm.form = vm.forms.login;
    }

    var COLLECTION_METHODS = {
      'Maklerinkasso' : 1,
      'Direktinkasso' : 2
    };

    function showPaymentType() {
      // Inkassoart (true / false >> 1=Maklerinkasso, 2=Direktinkasso)
      if (brokerService.getBroker()) {
        vm.model.Inkassoart = COLLECTION_METHODS[brokerService.getBroker().billing];
      }
    }

    // run once on page load
    showPaymentType();

    var brokerWatcher = $scope.$watch(brokerService.getBroker, function(newValue, oldValue) {
      if (newValue !== oldValue) {
        vm.broker = newValue;
        showPaymentType();
      }
    });


  } // PlaygroundController
})();

(function() {
  'use strict';

  angular.module('hydra').controller('MigrationCategoryController', MigrationCategoryController);

  /** @ngInject */
  function MigrationCategoryController(migration, migrationDefaults, site, siteCategories, category, categoryData, contacts, files, $rootScope, $http, $log, $scope, $state, $stateParams, hydraData, Restangular, $window, toastr, principal) {
    var vm = this;
    var logModName = 'MIGRATIONCATEGORY';


    var log = function(message) {
      $log.info(logModName + " " + message);
    }

    vm.model = {};
    vm.category = category;
    vm.categoryData = categoryData;
    vm.initialRenderFinished = false;
    vm.migrationDefaults = migrationDefaults;
    vm.defaultModel = angular.merge({}, vm.categoryData.defaults, vm.migrationDefaults, {
      Versicherungsnehmer: {
        Neuanlage: false
      }
    });

    vm.getPdfFormUrl = function(pdfFormId, processId) {
      //$analytics.eventTrack(pdfFormId, {  category: 'PDF', label: 'Druckversion' });
      return Restangular.configuration.baseUrl + '/pdfforms/' + pdfFormId + '/'+processId;
    }

    vm.model = vm.defaultModel;
    $log.debug(vm.model);
    //$scope.$broadcast('schemaFormRedraw');
    vm.contacts = contacts;
    vm.files = files;
    vm.error = false;
    vm.errorCode = null;
    vm.loading = false;
    vm.initialRenderFinished = false;
    vm.site = site;

    // URL für Dateidownload aufgrund Dateiinformationen erstellen
    vm.getFileUrl = function(file) {
      return Restangular.configuration.baseUrl + '/files/' + file.id + '?content=true';
    };

    $scope.$on('sf-render-finished', function(event, data) {
      if (!vm.initialRenderFinished) {
        vm.initialRenderFinished = true;
        vm.model = angular.merge({}, vm.model, vm.defaultModel);
    $log.debug(vm.model);
        //$scope.$broadcast('schemaFormRedraw');
     }
   });

    vm.onSubmit = function(formController, entity, model) {
      var form = formController[entity.method];
      $scope.$broadcast('schemaFormValidate');
      if (form.$valid) {
        vm.submitted = true;
        vm.loading = true;
        // Sicherstellen dass Methode verfügbar
        var bipromethod = Restangular.one('bipromethods', entity.method);
        bipromethod.customPOST(model).then(function(response) {
          entity.response = response;
        }, function() {}).finally(function() {
          vm.loading = false;
        });
      } else {
        toastr.error('Es sind noch nicht alle benötigten Felder korrekt ausgefüllt. Bitte überprüfen Sie die rot markierten Felder und probieren Sie es erneut.', 'Fehlende Angaben');
      }
    };

    vm.getPdfFormUrl = function(pdfFormId, processId) {
      //$analytics.eventTrack(pdfFormId, {  category: 'PDF', label: 'Druckversion' });
      return Restangular.configuration.baseUrl + '/pdfforms/' + pdfFormId + '/'+processId;
    }

  }
})();

(function() {
  'use strict';

  angular.module('hydra').controller('MigrationController', MigrationController);

  /** @ngInject */
  function MigrationController($log, $scope, $state, $stateParams, Restangular, $translate, hydraData, principal, config) {


    var vm = this;
    var logModName = 'MIGRATION';
    var log = function(message) {
      $log.info(logModName + " " + message);
    }

    vm.model = {};
    vm.error = false;
    vm.errorCode = null;
    vm.loading = false;
    vm.site = null;
    principal.authenticate(null);
    vm.migrationallowance_status = null;
    vm.migrationallowance_meldung = null;


    vm.getPartnerSite = function(siteKey) {
      log('getPartnerSite');
      Restangular.one('sites', siteKey).get().then(
        function(response) {
          // Seite erfolgreich abgerufen
          hydraData.site.set(response);
          vm.site = response;
          principal.setSite(response.key);
          // geht man auf die Anmeldeseite und ist noch
          if (principal.isAuthenticated()) {
            principal.authenticate(null);
          }
          return response;
        },
        function(response) {
          // setPartnerSelectMode();
          $state.go('main.404');
        });
    };

    vm.getPartnerSite('migration');

    vm.schema = {
      "type": "object",
      "properties": {
        "token": {
          "title": "Token",
          "type": "string",
          "minLength": 6,
          "pattern": config.patterns.token,
          "default": $state.params.token,
          "description": "Bitte geben Sie den Token ein."
        }
      },
      "required": ["token"]
    };

    vm.form = [
      {
        "type": "fieldset",
        "title": "Vertragsumstellung",
        "items": [
          {
            "key": "token",
            "placeholder": "Token",
            "feedback": false,
            "disableSuccessState": true,
            "disableErrorState": false,
            "validationMessage": {
              "302": "Bitte Token eingeben.",
              "202": "Bitte geben Sie einen gültige Token ein."
            },
            onChange: function() {
              vm.error = false;
            }
          }, {
            "type": "actions",
            "style": "col-md-12",
            "items": [
              {
                "type": "button",
                "icon": "fa fa-arrow-right",
                "style": "btn-primary btn-block",
                "title": " weiter",
                "onClick": "ctrl.onSubmit(resetForm, ctrl.model)"
              }
            ]
          }
        ]
      }
    ];

    vm.onSubmit = function(form, model) {
      // Event broadcasten um alle Felder zu validieren
      $scope.$broadcast('schemaFormValidate');
      // Prüfen ob Form valide ist
      if (form.$valid) {
        vm.loading = true;

        // Prüfen, ob der Token valide ist.
        Restangular.one('migrationallowance').withHttpConfig({cache: false}).get({ "token": model.token}).then(function(response) {
          vm.migrationallowance_status = response.Status;
          vm.migrationallowance_meldung = response.Meldung;

          if(vm.migrationallowance_status && vm.migrationallowance_status == 'OK') {
            /////////////////////////////////////////////////////////////////////
            Restangular.one('migrations', model.token).withHttpConfig({cache: false}).get().then(function(response) {
              vm.loading = false;
              if (response != undefined) {
                if (response.Jwt && response.Jwt.Token) {
                  vm.error = null;
                  if ( principal.authenticate(response.Jwt.Token)) {
                    var stateGoObj = {
                      token: model.token
                    };
                    $state.go('main.authenticated.migrationcategory', stateGoObj);
                  } else {
                    vm.error = true;
                    vm.errorCode = '2302';
                    vm.errorText = 'Anmeldung nicht möglich.';
                  }
                }
              } else {
                vm.error = true;
                vm.errorCode = '2302';
                vm.errorText = 'Token ungültig.';
                vm.loading = false;
              }
            }, function(response) {
              $log.debug("FAILED");
              vm.loading = false;
              vm.error = true;
              vm.errorCode = '2302';
              vm.errorText = 'Token ungültig.'
            }).finally(function(response) {
              vm.loading = false;
            });
            //////////////////////////////////////////////////////////////////////
          }
          else {
            vm.error = true;
            vm.errorCode = '2302';
            vm.errorText = vm.migrationallowance_meldung;
            vm.loading = false;
          }
        }, function(err) {
          log(err); // Fehler loggen;
        });
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('hydra')
    .factory('navigationService', function ($q, principal, $state, $stateParams, $rootScope, eehNavigation, userSettingsService, $uibModal, trackingService, brokerService) {

      var observers = [];
      return {
        createNav: function () {
          var self = this;
          var isAuthenticated = principal.isAuthenticated();

          // Menü aufbauen

          if (isAuthenticated && principal.getSite() === 'migration') {
            eehNavigation.menuItem('navbar.migration').isVisible = function () {
              return principal.isAuthenticated() && principal.getSite() === 'migration';
            };
            eehNavigation.menuItem('navbar.migration').click = function () {
              principal.logout();
              $state.go('main.migration');
            };
          }
          if (isAuthenticated && principal.getSite() !== 'migration') {
            var brokers = brokerService.getBrokers();
            var broker = brokerService.getBroker();
            eehNavigation.menuItem('navbar.home').isVisible = function () {
              return principal.isAuthenticated() && principal.getSite() !== 'migration';
            };
            eehNavigation.menuItem('navbar.broker').isVisible = function () {
              return principal.isAuthenticated() && principal.getSite() !== 'migration';
            };
            eehNavigation.menuItem('navbar.user').isVisible = function () {
              return principal.isAuthenticated() && principal.getSite() !== 'migration';
            };
            if (broker) {
              eehNavigation.menuItem('navbar.broker').text = broker.number;
            }
            eehNavigation.menuItem('navbar.user').text = principal.username();
            eehNavigation.menuItem('navbar.user.logout').isVisible = function () {
              return principal.isAuthenticated() && principal.getSite() !== 'migration';
            };
            eehNavigation.menuItem('navbar.user.logout').click = function () {
              trackingService.trackEvent('user', 'click-logout', 'User clicks logout', 1, {});
              principal.logout();
              $state.go('main.login', {
                "site": principal.getSite() //hydraData.site.data.key
              });
            };


            var count = 0;
            var menuItem;
            angular.forEach(brokers, function (broker) {
              //aud in JWT not matching broker.audience
              if (brokerService.matchingAudience(broker, principal.getSite())) {
                menuItem = 'navbar.broker.' + count;
                eehNavigation.menuItem(menuItem).text = broker.number + " " + broker.name;
                eehNavigation.menuItem(menuItem).isVisible = function () {
                  return principal.isAuthenticated() && principal.getSite() !== 'migration';
                };
                eehNavigation.menuItem(menuItem).click = function () {
                  brokerService.setBroker(broker);
                  eehNavigation.menuItem('navbar.broker').text = broker.number;
                };
                count++;
              }
            });
            for (count; count < 100; count++) {
              menuItem = 'navbar.broker.' + count;
              eehNavigation.menuItem(menuItem).isVisible = false;
              eehNavigation.menuItem(menuItem).click = null;
            }


            eehNavigation.menuItem('navbar.caseList').isVisible = function () {
              var regular = principal.isAuthenticated() && principal.getSite() !== 'migration';
              var featureIsActive = userSettingsService.getSetting('use_cases');
              return regular && featureIsActive;
            };

            eehNavigation.menuItem('navbar.caseList').click = function () {
              // todo
              trackingService.trackEvent('user', 'click-caseList', 'User clicks caseList', 1, {});

              $uibModal.open({
                //windowClass: 'modal-danger',
                templateUrl: 'app/components/cases/case-list.html',
                controller: 'CasesController',
                controllerAs: 'ctrl',
                bindToController: true,
                size: 'lg'
              });

            };
            eehNavigation.menuItem('navbar.caseNew').isVisible = function () {
              // todo: check if current form ist $dirty and we are on single category view
              var regular = principal.isAuthenticated() && principal.getSite() !== 'migration';
              var featureIsActive = userSettingsService.getSetting('use_cases');
              var onCategoryDetailPage = ($state.current.name === "main.authenticated.category");
              return regular && onCategoryDetailPage && featureIsActive;
            };

            eehNavigation.menuItem('navbar.caseNew').click = function () {
              console.log($state, $stateParams, "now to go where");

              $state.go($state.current.name,
                {
                  brokerId : $stateParams.brokerId,
                  sitecategoryId : $stateParams.sitecategoryId,
                  caseId : null
                },
                {
                  reload : true // make sure it also works if we did not save entry yet
                }
              );
            };
            eehNavigation.menuItem('navbar.caseSave').isVisible = function () {
              // todo: check if current form ist $dirty and we are on single category view
              var regular = principal.isAuthenticated() && principal.getSite() !== 'migration';
              var featureIsActive = userSettingsService.getSetting('use_cases');
              var onCategoryDetailPage = ($state.current.name === "main.authenticated.category");
              return regular && onCategoryDetailPage && featureIsActive;
            };

            eehNavigation.menuItem('navbar.caseSave').click = function () {
              trackingService.trackEvent('user', 'click-caseSave', 'User clicks caseSave', 1, {});

              $rootScope.$broadcast('case:saveIntent', {});
            };
          } // end if (migration)
        }
      };
    });

})();

(function() {
  'use strict';

  angular
    .module('hydra')
    .controller('ClearanceRequestController', ClearanceRequestController);

  /** @ngInject */
  function ClearanceRequestController($log, $scope, $state, Restangular, config) {

    var vm = this;
    vm.model = {};
    //steuerungsflags view
    vm.loading = false;
    vm.success = false;
    vm.error   = false;
    //daten response
    vm.mig_dose = null;

    vm.schema = {
      "type": "object",
      "properties": {
        "token": {
          "title": "Token",
          "type": "string",
          "minLength": 6,
          "pattern": config.patterns.token,
          "default": $state.params.token
          //"description": "Bitte geben Sie den Token ein."
        },
        "email": {
          "title": "E-Mail-Adresse",
          "type": "string",
          "minLength": 6,
          "pattern": config.patterns.email
          //"description": "Bitte geben Sie ihre E-Mail-Adresse ein."
        }
      },
      "required": [
        "token",
        "email"
      ]
    };

    vm.form = [{
      "type": "fieldset",
      "title": "Freischaltung Vermittler",
      "items": [{
        "key": "token",
        "type": "text",
        "disableSuccessState": true,
        "disableErrorState": true,
        "feedback": false,
        "validationMessage": {
          "302": "Bitte geben Sie den von der AIG erhaltenen Token ein."
        }
      }, {
        "key": "email",
        "type": "text",
        "feedback": false,
        "disableSuccessState": true,
        "disableErrorState": true,
        "validationMessage": {
          "302": "Bitte E-Mail eingeben.",
          "202": "Bitte geben Sie eine gültige E-Mail-Adresse ein."
        }
      }, {
        "type": "actions",
        "style": "col-md-12",
        "items": [{
          "type": "button",
          "icon": "fa fa-arrow-right",
          "style": "btn-primary btn-block",
          "title": " Absenden",
          "onClick": "ctrl.onSubmit(clearanceRequestForm, ctrl.model)"
        }]
      }]
    }];

    vm.onSubmit = function(form, model) {
        // Event broadcasten um alle Felder zu validieren
        $scope.$broadcast('schemaFormValidate');
        // Prüfen ob Form valide ist
        if (form.$valid) {

         vm.loading = true;
         Restangular.one('migrationdocs').withHttpConfig({
           cache: false
         }).customPOST({
           "emailToken": model.token,
           "email": model.email
         }).then(function(response) {
           //$log.debug("1: "+ angular.toJson(response));
           vm.success = true;
           vm.error   = false;
           //vm.mig_dose = "(" + response.migrationbroker + "-" + response.doseid + ")"; wird nicht mehr geliefert
         }, function(response) {
           vm.success = false;
           vm.error   = true;
           try {
             //$log.debug("2: "+ angular.toJson(response));
             vm.errorCode = response.status;
             if (vm.errorCode === 404) { //token falsch
               vm.errorText = "Überprüfung des Tokens nicht erfolgreich. Bitte neu eingeben und Gross-/Kleinschreibung beachten.";
             } else if  (vm.errorCode === 500) {
                vm.errorText = "Dieser Service ist momentan leider nicht verfügbar.";
             } else {
               vm.errorText = "Aus technischen Gründen ist die Seite gegenwärtig nicht verfügbar."
             }
           } catch (e) {
             vm.errorText = "Dieser Service ist momentan leider nicht verfügbar.";
           }
         }).finally(function(response) {
           vm.loading = false;
         }); // finally
       }    //$valid
      }     //onSubmit

  } //ClearanceRequestController
})();

(function() {
  'use strict';

  angular
    .module('hydra')
    .factory('hydraMenu', hydraMenu);

  /** @ngInject */
  function hydraMenu($state, $log, eehNavigation, principal, hydraData) {

    var self = this;

    var isAuth = function() {
      return principal.isAuthenticated();
    }

    self.refresh = function() {
      eehNavigation.menuItem('navbar.home').isVisible = isAuth;
      eehNavigation.menuItem('navbar.user').isVisible = isAuth;
      eehNavigation.menuItem('navbar.user').text = principal.username();
      eehNavigation.menuItem('navbar.user.logout').isVisible = isAuth;
      eehNavigation.menuItem('navbar.user.logout').click = function() {
        principal.logout();
        $state.go('main.login', {
          "site": hydraData.site.data.key
        });
      };
      eehNavigation.menuItem('navbar.broker').isVisible = isAuth;
      eehNavigation.menuItem('navbar.broker').text = hydraData.brokers.active.data.number;
      angular.forEach(principal.user().brokers.broker, function(broker) {
        eehNavigation.menuItem('navbar.broker.' + broker.number, {
          text: broker.number + " " + broker.name,
          click: function() {
            principal.setBroker(broker.number);
          }
        })
      });

    };



    return self;
  }
})();

(function() {
  'use strict';

  angular
    .module('hydra')
    .factory('jsonParserService', function () {
      var allowedJSFunctions = [
        {
          //pattern     : / (moment\(\)\.year\(\))(\-)*(\d*)/gi,
          pattern     : / (moment\(\)\.year\(\))(\-)*(\d*)/gi,
          replacement : moment().year() // TODO: calc -10 dynamically
        },
        {
          pattern     : "moment().add(1, 'days').toDate()",
          replacement : '"' + moment().add(1, 'days').format('YYYY-MM-DD') + '"'
        },
        {
          pattern     : /(moment\(\)\.subtract\(60,[ ]*'years\'\)\.toDate\(\))/gi,
          //replacement : moment().subtract(60, 'years').toDate()
          replacement :  '"' + moment().subtract(60, 'years').format('YYYY-MM-DD') + '"'
        },
        {
          pattern     : /moment\(\)\.year\(\)/gi,
          replacement : moment().year()
        }
        /** allow $validators functions **
         {
           pattern : '$validators',
           replacement : '"$validators'
         },
         {
           pattern : 'function(',
           replacement : '"function('
         },*
         // https://regex101.com/r/jM932f/1
         {
           // (\\r\n}){1,2}
         pattern : /(\$validators)(:)([ ]*{)([\{\}\w() \r\n<>|;]*)(})(]*)/gi,
         //replacement : '"$1":{"$4"}'
         replacement : '"$dummy" : "validatorFunc"'
         }*/
      ];

      // via https://stackoverflow.com/a/274094
      String.prototype.regexIndexOf = function(regex, startpos) {
        var indexOf = this.substring(startpos || 0).search(regex);
        return (indexOf >= 0) ? (indexOf + (startpos || 0)) : indexOf;
      };

      function allIndexes(str, needle) {
        var indices = [];
        var offset = 0,
          nextIndex = 0;

        for(var i=0; i<str.length; i++) {
          nextIndex = str.regexIndexOf(needle, i);
          if (nextIndex == -1) {
            break; // found all matches, exit early
          }
          indices.push(nextIndex);
          // skip contents of search string
          i = nextIndex + 13; // can't use needle.length; anymore, just offset "enough"
          // and look for next match after
          offset += nextIndex;
        }
        return indices;
      }

      var service = {};

      service.findFunctions = function(input) {
        var startString = /\$validators:[ ]*\{/;
        var endString = '}';
        var openingBrackets = 0;
        var closingBrackets = 0;
        var currentSymbol = '';
        var beginnings = allIndexes(input, startString);
        var endings = [];
        var functions = [];
        var functionCounter = 0;

        var endOfString = 0; // cant use startString.length;

        // find matching closing bracket (after all if else clauses etc.)
        for (var i = 0; i < input.length; i++) {

          endOfString = input.indexOf('{', beginnings[functionCounter]) - beginnings[functionCounter];

          currentSymbol = input[beginnings[functionCounter] + endOfString + i];
          if (currentSymbol === '{') {
            openingBrackets++;
          }
          else if (currentSymbol === '}') {
            closingBrackets++;
          }

          // reached end of function?
          if (closingBrackets === openingBrackets && closingBrackets > 0) {
            endings.push(beginnings[functionCounter] + endOfString + i + 1);

            functions.push(input.substring(beginnings[functionCounter] + endOfString, endings[functionCounter]));

            functionCounter++;

            i = 0;
            closingBrackets = 0;
            openingBrackets = 1;
          }
          if (functionCounter === beginnings.length) {
            break;
          }
        }

        return functions;
      };


      function evaluateFunction(input) {
        var output = '';
        try {
          output = eval("(" + input + ")");
        }
        catch (e) {
          throw new Error('could not eval() function input', input);
        }
        return output;
      }

      function replaceMoment(input) {
        var output = input;

        var indexes = allIndexes(input, 'moment');
        var ending = 0;
        var x = 0;

        for (var i = 0; i < input.length; i++) {

          if (x === indexes.length) {
            break;
          }

          // find the next " or } symbol in JSON string
          var nextQuote = input.indexOf('"', indexes[x]);
          var nextMustache = input.indexOf('}', indexes[x]);

          if (nextMustache < nextQuote) {
            ending = nextMustache-1;
          }
          else {
            ending = nextQuote-1;
          }

          var content = input.substring(indexes[x], ending).trim();

          // remove comma at end (if it exists)
          if (content[content.length-1] === ',') {
            content = content.substr(0, content.length-1);
          }


          // always convert into date string
          var functionInput = content.replace('.toDate()', '');
          var functionValue = evaluateFunction(functionInput);

          var finalValue = (moment.isMoment(functionValue)) ? functionValue.format('YYYY-MM-DD') : functionValue;
          output = output.replace(content, '"' + finalValue + '"');
          x++;

        }

        return output;
      }

      service.parseJson = function(input) {
        var output = {};

        try {
          output = JSON.parse(input);
        }
        catch (e1) {
          // fun fact: malformed JSON (e.g. a comma at end of last list item) will work in eval but not JSON.parse
          try {
            output = eval("(" + input + ")");
          }
          catch (e2) {
            try {
              // use JSON5 (https://github.com/json5/json5), loaded via unpkg.com from index.html
              output = JSON5.parse(input);
            }
            catch(e3) {
              console.error('JSON is malformed, can not be parsed by jsonParser.parseJson (or JSON5)', input);
            }
          }
        }

        return output;
      };

      // based on https://stackoverflow.com/a/24861307
      function isIE() {
        if (navigator.appName == 'Microsoft Internet Explorer' ||  !!(navigator.userAgent.match(/Trident/) || navigator.userAgent.match(/rv:11/)) || (typeof $.browser !== "undefined" && $.browser.msie == 1))
        {
          return true;
        }
        return false;
      }

      // based on https://stackoverflow.com/a/15524326
      function setObject(theObject, theProp, newName, newValue) {
        var result = null;
        if(theObject instanceof Array) {
          for(var i = 0; i < theObject.length; i++) {
            result = setObject(theObject[i], theProp, newName, newValue);
            if (result) {
              break;
            }
          }
        }
        else
        {
          for(var prop in theObject) {
            if(prop == theProp) {
              console.log('here');
              // remove old attribute
              delete theObject[theProp];
              // and add new one
              theObject[newName] = newValue;

              return theObject;
            }
            if(theObject[prop] instanceof Object || theObject[prop] instanceof Array) {
              result = setObject(theObject[prop], theProp, newName, newValue);
              if (result) {
                break;
              }
            }
          }
        }
        return result;
      }

      service.replaceFunctions = function(input) {
        var output = input;
        var functions = service.findFunctions(input);

        for(var i=0; i < functions.length; i++) {
          output = output.replace(functions[i], '"dummy' + i + '"');
        }

        var counter = 0;
        output = output.replace(/\$validators/g, function() {
          counter++;
          return '"$validators' + counter + '"';
        });

        output = service.parseJson(output);

        if (isIE() === false) {
          // and finally, replace the functions again with real content
          for (var x = 0; x < functions.length; x++) {
            var realValidator = evaluateFunction(functions[x]);
            setObject(output, '$validators' + x, '$validators', realValidator);
            //output = output.replace('"dummy' + x + '"', eval("(" + functions[x] + ");"));
          }
        }

        return output;
      };

      /**
       * skip eval, but still allow moment.year() and other needed templating functions
       * @param JSONandFunctionCalls
       */
      service.safeParse = function(JSONandFunctionCalls) {
        var output = '';

        output = JSONandFunctionCalls;

        if (JSONandFunctionCalls == null) {
          return '';
        }

        output = replaceMoment(output);

        for (var i = 0; i < allowedJSFunctions.length; i++) {
          output = output.replace(allowedJSFunctions[i].pattern, allowedJSFunctions[i].replacement);
        }


        if (output.indexOf('function(') > -1) {
          output = service.replaceFunctions(output);
          //output = (new Function( 'return (' + output + ')' )());
        }
        else {
          output = service.parseJson(output);
        }

        return output;
      };

      return service;

    });

})();

(function() {
  'use strict';

  angular
    .module('hydra')
    .factory('hydraData', hydraData);

  /** @ngInject */
  function hydraData($log, config, Restangular, $filter, $q, principal, $window, jsonParserService, userShopsService) {
    var self = this;
    var logModName = 'DATA';
    var log = function(message) {
      $log.info(logModName + " " + message);
    };

    // aktive Seite
    self.site = {};

    self.site.get = function() {
      var key = principal.getSite();

      /*if (self.site.data !== null && self.site.data.key === key) {
        return self.site.data;
      }*/
      return userShopsService.getShop(key);
    };

    self.site.set = function(site) {
      self.site.data = site;
      $window.localStorage.setItem('siteData', JSON.stringify(site));
    };

    self.site.reloadFromClient = function(key) {
      if (!key) {
        return null;
      }
      var prevData = JSON.parse($window.localStorage.getItem('siteData'));

      if (prevData !== null && prevData.key === key) {
        return prevData;
      }
      else {
        return null;
      }
    };

    // first run
    self.site.data = self.site.reloadFromClient(principal.getSite()); // initialize based on localstorage value

    // Kategorien abrufen
    self.categories = {};
    self.categories.getList = function(siteId) {
      var categories = [];
      Restangular.all('sitecategories').getList({
        "site": siteId
      }).then(function(sitecategories) {
        angular.forEach(sitecategories, function(sitecategory) {
          Restangular.one('categories', sitecategory.category).get().then(
            function(category) {
              category.sort = sitecategory.sort;
              category.sitecategory = sitecategory.id;
              category.site = sitecategory.site;
              if (sitecategory.hasOwnProperty('_embedded')
                && sitecategory._embedded !== null
                && sitecategory._embedded.hasOwnProperty('sitecategorybadge')
                && sitecategory._embedded.sitecategorybadge.hasOwnProperty('_embedded')
                && sitecategory._embedded.sitecategorybadge._embedded.hasOwnProperty('badge')
                && sitecategory._embedded.sitecategorybadge._embedded.badge.hasOwnProperty('name')
              ) {
                category.badge = sitecategory._embedded.sitecategorybadge._embedded.badge.name;
              }
              categories.push(category);
              return category;
            }
          );
        });
      });
      return categories;
    };

    self.categories.getAll = function(siteId) {
      var mainPromise = $q.defer();
      var allPromises = [];

      Restangular.all('sitecategories').getList({
        "site": siteId
      }).then(function(sitecategories) {
        angular.forEach(sitecategories, function (sitecategory) {
          var deferred  = $q.defer();

          // request detailed data for each category
          Restangular.one('categories', sitecategory.category).get().then(
            // on success
            function (category) {
              // merge with info from sitecategory (specific to this current shop)
              category.sort = sitecategory.sort;
              category.sitecategory = sitecategory.id;
              category.site = sitecategory.site;
              if (sitecategory.hasOwnProperty('_embedded')
                && sitecategory._embedded !== null
                && sitecategory._embedded.hasOwnProperty('sitecategorybadge')
                && sitecategory._embedded.sitecategorybadge.hasOwnProperty('_embedded')
                && sitecategory._embedded.sitecategorybadge._embedded.hasOwnProperty('badge')
                && sitecategory._embedded.sitecategorybadge._embedded.badge.hasOwnProperty('name')
              ) {
                category.badge = sitecategory._embedded.sitecategorybadge._embedded.badge.name;
              }

              // keep data + progress of data loading here
              deferred.resolve(category);
            },
            // on error
            function() {
              // because a failing promise makes the whole chain fail, we need to handle this more "optimistically"
              deferred.resolve(null);
            }
          );

          allPromises.push(deferred.promise);
        });

        $q.all(allPromises).then(
          // Success
          function(allCategoriesData) {
            mainPromise.resolve(allCategoriesData);
          },
          // failure
          function() {
            // what now?
          }
        );
      });

      return mainPromise.promise;
    };

    self.categories.get = function(sitecategoryId) {
      var categories = [];
      Restangular.all('sitecategories').getList({
        "id": sitecategoryId
      }).then(function(sitecategories) {
        angular.forEach(sitecategories, function(sitecategory) {
          Restangular.one('categories', sitecategory.category).get().then(
            function(category) {
              category.sort = sitecategory.sort;
              category.sitecategory = sitecategory.id;
              category.site = sitecategory.site;
              categories.push(category);
              return category;
            }
          );
        });
      })
      return categories;
    };

    self.categories.getOne = function(sitecategoryId) {
      var deferred = $q.defer();
      Restangular.one('sitecategories', sitecategoryId).get().then(function(sitecategory) {
          Restangular.one('categories', sitecategory.category).get().then(
            function(category) {
              category.sort = sitecategory.sort;
              category.sitecategory = sitecategory.id;
              category.site = sitecategory.site;
              deferred.resolve(category);
            }
          );
      });
      return deferred.promise;
    };


    function resolveFormRefs(theObject) {
      var result = null;
      if (theObject instanceof Array) {
        for (var i = 0; i < theObject.length; i++) {
          result = resolveFormRefs(theObject[i]);
          if (result) {
            break;
          }
        }
      } else {
        for (var prop in theObject) {

          if (prop == '$ref') {
            theObject[prop] = config.baseUrl + "/forms/" + theObject[prop];
            $log.debug("$ref");
            $log.debug(theObject[prop]);
            if (theObject[prop] == 1) {
              return theObject;
            }


          }
          if (theObject[prop] instanceof Object || theObject[prop] instanceof Array) {
            result = resolveFormRefs(theObject[prop]);
            if (result) {
              break;
            }
          }
        }
      }
      return result;
    }


    function updateSchemRefUrls(theObject) {
      var result = null;
      if (theObject instanceof Array) {
        for (var i = 0; i < theObject.length; i++) {
          result = updateSchemRefUrls(theObject[i]);
          if (result) {
            break;
          }
        }
      } else {
        for (var prop in theObject) {

          if (prop == '$ref') {
            theObject[prop] = config.baseUrl + "/definitions/" + theObject[prop];
            if (theObject[prop] == 1) {
              return theObject;
            }
          }
          if (theObject[prop] instanceof Object || theObject[prop] instanceof Array) {
            result = updateSchemRefUrls(theObject[prop]);
            if (result) {
              break;
            }
          }
        }
      }
      return result;
    }


    self.entities = {};
    self.entities.defaultModel = {};
    self.entities.getList = function(sitecategoryId) {
      var user = principal.user();
      var categoryData = $q.defer();
      var _defaults = {};
      var _entities = [];

      var promises = [];

      Restangular.all('sitecategoryentities').getList({
        "sitecategory": sitecategoryId
      }).then(function(sitecategoryentities) {

        sitecategoryentities = $filter('orderBy')(sitecategoryentities, 'sort');

        angular.forEach(sitecategoryentities, function(sitecategoryentity) {

          var subPromise = $q.defer();
          promises.push(subPromise.promise);

          Restangular.one('entities', sitecategoryentity.entity).get().then(function(entity) {
            return Restangular.one('entitytypes', entity.type).get().then(function(entitytype) {
              //return Restangular.one('definitions', entitytype.definition).get({
              return Restangular.one('definitions', sitecategoryentity.id).get({
                js: false
              }).then(function(definition) {
                //return Restangular.one('forms', entity.form).get({
                return Restangular.one('forms', sitecategoryentity.id).get({
                  js: false
                }).then(function(form) {
                  entity.request = {};
                  entity.response = null;
                  // Berechtigung prüfen
                  entity.permission = false;
                  if (entitytype.right) {
                    angular.forEach(user.rights, function(userRight) {
                      if (userRight == entitytype.right) {
                        entity.permission = true;
                      }
                    });
                  } else {
                    // kein Recht eingetragen also anzeigen
                    entity.permission = true;
                  }

                  entity.pdfforms = [];
                  Restangular.all('sitecategoryentitypdfforms').getList({
                    sitecategoryentity: sitecategoryentity.id
                  }).then(
                    // success
                    function(sitecategoryentitypdfforms) {
                      angular.forEach(sitecategoryentitypdfforms, function(sitecategoryentitypdfform) {

                          Restangular.one('pdfforms',sitecategoryentitypdfform.pdfform).get().then(function(pdfform){
                            entity.pdfforms.push(pdfform);

                          });
                        },
                        // error
                        function() {
                          // nothing
                          console.log('no pdfforms for this entity');
                        });
                    });

                  entity.method = entitytype.key;
                  if (entitytype.terminate == 1) {
                    entity.terminate = false;
                  } else {
                    entity.terminate = true;
                  }
                  entity.sort = sitecategoryentity.sort;
                  entity.JSONReqSchema = jsonParserService.safeParse(definition.content);
                  if (entity.JSONReqSchema === '') {
                    entity.JSONReqSchema = {};
                  }
                  updateSchemRefUrls(entity.JSONReqSchema);

                  entity.JSONReqForm = jsonParserService.safeParse(form.content);
                  if (entity.JSONReqForm === '') {
                    entity.JSONReqForm = ["*"];
                  }
                  resolveFormRefs(entity.JSONReqForm);

                  entity.JSONReqDefault = jsonParserService.safeParse(entity.reqDefault);
                  if (entity.JSONReqDefault === '') {
                    entity.JSONReqDefault = {};
                  }

                  // Modelvorbelgung
                  _defaults = angular.merge({}, _defaults, entity.JSONReqDefault);
                  entity.resHtml = entitytype.resHtml;
                  if (entitytype.responsetype) {
                    Restangular.one('responsetypes', entitytype.responsetype).get().then(function(responsetype) {
                      entity.resSchema = responsetype.resSchema;
                      entity.resForm = responsetype.resForm;
                      try {
                        entity.JSONResSchema = jsonParserService.safeParse(responsetype.resSchema);
                        //entity.JSONResSchema = angular.fromJson(eval("(" + responsetype.resSchema + ")"));
                      } catch (e) {
                        entity.JSONResSchema = {};
                      }
                      try {
                        //entity.JSONResForm = angular.fromJson(eval("(" + responsetype.resForm + ")"));
                        entity.JSONResForm = jsonParserService.safeParse(responsetype.resForm);
                      } catch (e) {
                        entity.JSONResForm = ["*"];
                      }

                      // resolve nested Promise after all business logic is complete
                      subPromise.resolve(entity);
                      _entities.push(entity);
                    });
                  } else {
                    // resolve nested Promise after all business logic is complete
                    subPromise.resolve(entity);
                    _entities.push(entity);
                  }
                });
              });
            });
          });
        });

        $q.all(promises).then(
          // on success
          function() {
            categoryData.resolve({
              defaults: _defaults,
              entities: _entities
            });
          },
          // on error
          function() {
            categoryData.reject();
          }
        );
      });
      return categoryData.promise;
    };


    // Kontakte abrufen
    self.contacts = {};
    self.contacts.getList = function(siteCategoryId) {
      var contacts = []; // [] -> initialisiert
      Restangular.all('sitecategorycontacts').getList({
        "sitecategory": siteCategoryId
      }).then(
        // success
        function(sitecategorycontacts) {
        angular.forEach(sitecategorycontacts, function(sitecategorycontact) {
          Restangular.one('contacts', sitecategorycontact.contact).get().then(function(contact) {
            contact.sort = sitecategorycontact.sort;
            contacts.push(contact);
          });
        },
        // failed
        function() {
          // nothing
        });
      });
      return contacts;
    };

    // Dateien abrufen
    self.files = {};
    self.files.getList = function(siteCategoryId) {
      var files = []; // [] -> initialisiert
      Restangular.all('sitecategoryfiles').getList({
        "sitecategory": siteCategoryId
      }).then(
        // success
        function(sitecategoryfiles) {
          angular.forEach(sitecategoryfiles, function(sitecategoryfile) {
              Restangular.one('files', sitecategoryfile.file).get().then(function(file) {
                file.sort = sitecategoryfile.sort;
                files.push(file);
              });
            },
            // failed
            function() {
              // nothing
            });
        });
      return files;
    };

    return self;
  }
})();

(function() {
  'use strict';

  angular
    .module('hydra')
    .filter('getByNumber', getByNumber);

  /** @ngInject */
  function getByNumber() {
    return function(input, number) {
      var i = 0;
      var len = input.length;
      for (; i < len; i++) {
        if (+input[i].number == +number) {
          return input[i];
        }
      }
      return null;
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('hydra')
    .controller('ClearanceConfirmationController', ClearanceConfirmationController);

  /** @ngInject */
  function ClearanceConfirmationController($log, $scope, $state, $stateParams, Restangular, $translate, hydraData) {

    var vm = this;
    vm.loading = false;
    vm.success = false;
    vm.error = false;
    vm.id = null;

    // Token prüfen
    if ($state.params.token) {

      //$log.debug("0: token aus url - " + $state.params.token);
      vm.loading = true;
      Restangular.all('migrationbrokers')
                .withHttpConfig({cache: false})
                .getList({confirmToken:$state.params.token

        // sucess email token pruefung
        }).then(function(response) {
          //$log.debug("1: "+ angular.toJson(response));
          // Token existiert in der DB
          vm.id = response[0].id;
          //$log.debug("2 vm.id: " + vm.id);

          //wegen asynchronität muss aufruf geschachtelt erfolgen
          Restangular.one('migrationbrokers', vm.id).customPUT({"confirmDate": new moment().format("YYYY-MM-DD HH:mm:ss")})
          .then(function(response) {
            //$log.debug("3: "+ angular.toJson(response));
            vm.success = true;
            vm.error   = false;
          }, function(response) {
            vm.success = false;
            vm.error   = true;
            try {
              //$log.debug("f put: "+ angular.toJson(response));
              vm.errorCode = response.status;
              vm.errorText = "Aus technischen Gründen ist die Seite gegenwärtig nicht verfügbar."
            } catch (e) {
              vm.errorText = "Dieser Service ist momentan leider nicht verfügbar.";
            }
          });

        //error  email token pruefung
        }, function(response) {
          vm.success = false;
          vm.error   = true;
          try {
            //$log.debug("f email: "+ angular.toJson(response));
            vm.errorCode = response.status;
            if (vm.errorCode === 500) {
               vm.errorText = "Dieser Service ist momentan leider nicht verfügbar.";
            } else {
              vm.errorText = "Aus technischen Gründen ist die Seite gegenwärtig nicht verfügbar."
            }
          } catch (e) {
            vm.errorText = "Dieser Service ist momentan leider nicht verfügbar.";
          }
        }).finally(function(response) {
            vm.loading = false;
          });
    } else {

      vm.error = true;
      vm.successToken = false;
      vm.errorText = "Überprüfung URL nicht erfolgreich.";

    };

  } // ClearanceConfirmationController
})();

(function() {
  'use strict';

  angular
    .module('hydra')
    .component('categoryTile', {
      templateUrl: 'app/components/category-tile/category-tile.component.html',
      bindings: {
        category: '<'
      },
      controller: function CategoryTileController (QualitySealService) {
        this.showQualitySeal = showQualitySeal;

        function showQualitySeal(categoryKey) {
          this.imgName = QualitySealService.findQualitySealName(categoryKey);
          return this.imgName != null;
        }
      }
    });
})();

(function() {
  'use strict';

  angular
    .module('hydra')
    .controller('CategoriesController', CategoriesController);

  /** @ngInject */
  function CategoriesController(resolvedCategories, userShopsService, trackingService) {
    var vm = this;

    userShopsService.currentShop().then(function(data) {
      vm.site = data;

      trackingService.trackEvent('product', 'getList', 'Produktliste anzeigen', 1, {
      });
    });
    vm.categories = resolvedCategories;
  }
})();

(function() {
  'use strict';

  angular
    .module('hydra')
    .filter('getById', getById);

  /** @ngInject */
  function getById() {
    return function(input, id) {
      var i = 0;
      var len = input.length;
      for (; i < len; i++) {
        if (+input[i].id == +id) {
          return input[i];
        }
      }
      return null;
    }
  }
})();

(function () {
  'use strict';

  var COLLECTION_METHODS = {
    'Maklerinkasso' : 1,
    'Direktinkasso' : 2
  };

  angular
    .module('hydra')
    .controller('CategoryController', CategoryController);

  /** @ngInject */
  function CategoryController($http,
                              $q,
                              $log,
                              $scope,
                              $state,
                              $rootScope,
                              $stateParams,
                              $element,
                              hydraData,
                              Restangular,
                              $window,
                              toastr,
                              principal,
                              config,
                              trackingService,
                              resolvedBrokers,
                              resolvedCategory,
                              resolvedContacts,
                              resolvedFiles,
                              storageService,
                              $transitions,
                              $uibModal,
                              brokerService,
                              userShopsService,
                              QualitySealService) {

    var vm = this;

    vm.loading = false;
    vm.storeSubmitted = false;
    vm.storeLoading = false;
    vm.storeResponse = null;
    vm.submitted = false;
    vm.commentForMother = null;
    vm.initialRenderFinished = false;
    vm.getStorageLoading = false;
    vm.model = {};
    vm.case = {};
    vm.openSavingDialog = openSavingDialog;
    vm.addEntry = addEntry;
    vm.updateEntry = updateEntry;
    vm.loadEntry = loadEntry;
    vm.site = hydraData.site.data;

    // assign on first run
    vm.broker = brokerService.getBroker();
    // and make sure it's kept in sync
    var brokerWatcher = $scope.$watch(brokerService.getBroker, function(newValue, oldValue) {
      if (newValue !== oldValue) {
        vm.broker = newValue;
        showPaymentType();
      }
    });

    // and unbind on view destroy
    $scope.$on('$destroy', brokerWatcher);

    hydraData.categories.getOne($stateParams.sitecategoryId).then(function (data) {
      vm.category = data;
      trackingService.trackEvent('product', 'select', 'Product selected', 1, {
        productCategoryId: $stateParams.sitecategoryId,
        productKey: vm.category.key // e.g. wg022S
      });
    });
    vm.categoryData = {};
    vm.contacts = resolvedContacts;
    vm.files = resolvedFiles;
    // because loading the actual form is quite slow, get that part of the data only after a redirect
    vm.loadingForm = true;

    /**
     * Data is loading independently
     * 1. core product data via hydraData
     * 2. current case data (if passed via url param caseId)
     * then
     * merged together for display
     */
    $q.all([
      hydraData.entities.getList($stateParams.sitecategoryId),
      loadEntry(parseInt($stateParams.caseId, 10))
    ])
    .then(function (results) {
      var categoryData = results[0];
      vm.loadingForm = false;
      vm.categoryData = categoryData;

      var caseData = (typeof (vm.case) !== 'undefined' && typeof (vm.case.content) !== 'undefined' && typeof (vm.case.content.data) !== 'undefined') ? vm.case.content.data : {};
      vm.model = angular.merge({}, vm.model, categoryData.defaults, caseData);
      // in case we are repetitively reloading a previously saved case, need to also store the "initial" model (combination of model + defaults + existing case data)
      // this wey, we can reset to it later even if additions to a model have been made (such as extra "Risk" entry in subarray)
      vm.initialModel = angular.copy(vm.model);
    });
    vm.storage = [];
    vm.displayedStorage = [];

    // FUNCTION DECLARATIONS
    $scope.getTitlemaps = getTitlemaps;
    vm.getFileUrl = getFileUrl;
    vm.onSubmit = onSubmit;
    vm.openPdfFormUrl = openPdfFormUrl;
    vm.getPdfFormUrl = getPdfFormUrl;
    vm.showQualitySeal = showQualitySeal;

    function addEntry(title, key, model) {
      var caseEntry = {
        title: title,
        key: key,
        siteCategoryId: $stateParams.sitecategoryId,
        categoryId: vm.category.id,
        created: new Date(),
        data: model,
        siteKey: userShopsService.getSiteKey(),
        brokerId: brokerService.getBroker().number
      };
      vm.updateEntry(caseEntry);
    }

    function updateEntry(caseEntry) {
      storageService.save('caseStorage', caseEntry, {brokerid : parseInt(brokerService.getBroker().id, 10)}).then(
        // success
        function (result) {
          trackingService.trackEvent('product', 'caseSaved', 'Product Request saved', 1, {
            productCategoryId: $stateParams.sitecategoryId,
            productKey: vm.category.key, // e.g. wg022S
            caseId: (result.hasOwnProperty('id')) ? result.id : result.data.id
          });

          var caseTitle = (caseEntry.hasOwnProperty('content')) ? caseEntry.content.title : caseEntry.title;
          toastr.success('Die Anfrage wurde erfolgreich gespeichert.', caseTitle + ' gespeichert');
          // add ID to current URL
          $state.go($state.current.name, { siteCategoryId: $stateParams.sitecategoryId, caseId: (result.hasOwnProperty('id')) ? result.id : result.data.id });
        }
      );
    }

    /**
     * because case loading is async and core product data loading is async as well,
     * need to wrap each in a function so we can merge results in one swoop
     * (this function gets called even if empty caseId is passed (then resolves imediately)
     * @param caseId
     */
    function loadEntry(caseId) {
      var defer = $q.defer();

      if (caseId < 1) {
        // immediate (but empty) result
        defer.resolve({});
      }
      else {
        trackingService.trackEvent('product', 'caseOpened', 'Product Request opened', 1, {
          productCategoryId: $stateParams.sitecategoryId,
          // not available on first load, so skip always productKey : vm.category.key, // e.g. wg022S
          caseId: caseId
        });

        storageService.loadFromStorage('caseStorage', brokerService.getBroker().id, caseId).then(function (res) {
          console.log('got case', res);
          vm.case = res;
          defer.resolve(res);
        });
      }

      return defer.promise;
    }

    function openSavingDialog() {
      $uibModal.open({
        templateUrl: 'app/components/cases/case-save.html',
        controller: 'CasesController',
        controllerAs: 'ctrl',
        bindToController: true
      });
    }

    // URL für Dateidownload aufgrund Dateiinformationen erstellen
    function getFileUrl(file) {
      return Restangular.configuration.baseUrl + '/files/' + file.id + '?content=true';
    }

    /**
     * get Contents for Dropdown or Radio Select element based on key
     * e.g. paramObj.parameter.key = "AIG_WG021_STICHWORTE"
     * (a call to this is defined in form.options.asyncCallback)
     * @param paramObj
     * @returns {*}
     */
    function getTitlemaps(paramObj) {
      return $http({
        method: 'GET',
        url: config.baseUrl + '/titlemaps',
        headers: { Authorization: 'Bearer ' + principal.getToken() },
        params: paramObj,
        cache: true
      });
    }

    function onSubmit(formChildScope, entity, model) {

      // don't allow submitting same form twice
      if (vm.submitted) {
        return false;
      }

      //var form = formChildScope[entity.method];
      var form = formChildScope["schemaForm"];
      $log.debug(entity);
      $scope.$broadcast('schemaFormValidate');

      // in case we are at setorder stage, make sure to also check that getquote form is valid
      var previousIsValid = true;

      // not reliably working based on child > parent Scope traversal, so need to use jQuery style DOM locators
      var firstForm = angular.element(angular.element('form')[0]).scope().schemaForm;

      previousIsValid = firstForm.$valid;

      if (form.$valid && previousIsValid) {
        var actionName = '';
        var actionLabel = '';

        if (entity.key.toLowerCase().indexOf('getquote') > -1) {
          actionName = 'getQuote';
          actionLabel = 'Tarif berechnen';
        }
        else if (entity.key.toLowerCase().indexOf('setorder') > -1) {
          actionName = 'setOrder';
          actionLabel = 'Produkt buchen';
        }

        trackingService.trackEvent('product', actionName, actionLabel, 2, {
          productCategoryId: $stateParams.sitecategoryId,
          productKey: vm.category.key // e.g. wg022S
        });

        vm.submitted = true;
        // Defaults anwenden
        //model = angular.merge({}, entity.JSONReqDefault, model);
        vm.loading = true;
        // Hier immer den Vermittler unterbringen!
        model.Vermittler = {};
        model.Vermittler.Vermittlernummer = brokerService.getBroker().number;

        // Sicherstellen dass Methode verfügbar
        var bipromethod = Restangular.one('bipromethods', entity.method);
        bipromethod.customPOST(model).then(function (response) {
          entity.response = response;
        }, function () {
          toastr.error('Der Tarif konnte leider nicht berechnet werden.', 'Technische Probleme');
        }).finally(function () {
          vm.submitted = false; // make form submittable again
          vm.loading = false;
        });
      } else {
        toastr.error('Es sind noch nicht alle benötigten Felder korrekt ausgefüllt. Bitte überprüfen Sie die rot markierten Felder und probieren Sie es erneut.', 'Fehlende Angaben');
      }
    }

    function openPdfFormUrl(pdfFormId, processId) {
      trackingService.trackEvent('product', 'printPDF', 'Unterlagen drucken', 1, {
        productCategoryId: $stateParams.sitecategoryId,
        productKey: vm.category.key // e.g. wg022S
      });

      var pdfUrl = Restangular.configuration.baseUrl + '/pdfforms/' + pdfFormId + '/' + processId;
      $window.open(pdfUrl, '_blank');
    }

    function getPdfFormUrl(pdfFormId, processId) {
      return Restangular.configuration.baseUrl + '/pdfforms/' + pdfFormId + '/' + processId;
    }

    function showQualitySeal(categoryKey) {
      var imgName = QualitySealService.findQualitySealName(categoryKey);
      var result = imgName != null && imgName !== '';
      return result;
    }

    function showPaymentType() {
      // Inkassoart (true / false >> 1=Maklerinkasso, 2=Direktinkasso)
      vm.model.Inkassoart = COLLECTION_METHODS[brokerService.getBroker().billing];
    }

    // run once on page load
    showPaymentType();

    var currentProductSavingEventHandler = $rootScope.$on('case:save', function (event, payload) {
      vm.addEntry(payload.title, vm.category.key, vm.model);
    });
    // unbind event listener when scope is destroyed
    $scope.$on('$destroy', currentProductSavingEventHandler);

    var currentProductSaveIntentEventHandler = $rootScope.$on('case:saveIntent', function () {
      vm.openSavingDialog();
    });
    // unbind event listener when scope is destroyed
    $scope.$on('$destroy', currentProductSaveIntentEventHandler);

    // for special case of opening the current entry (same URL) again, we need to reset the form to its original state
    var doubleOpenEventHandler = $rootScope.$on('case:open', function (event, payload) {
      vm.loadEntry(payload.caseId).then(function(res) {
        mergeCaseContents();
        // ISSUE: in case payment methods change in the future, make sure that most recent is set in model
        showPaymentType();
      });
    });
    // unbind event listener when scope is destroyed
    $scope.$on('$destroy', doubleOpenEventHandler);

    // make sure form updates when broker is changed
    var brokerSwitchHandler = $rootScope.$on('broker:switch', function (event, payload) {
      showPaymentType();
    });
    // unbind event listener when scope is destroyed
    $scope.$on('$destroy', brokerSwitchHandler);


    function mergeCaseContents() {
      // merge case content (previously saved form data) and default values
      vm.model = angular.merge({}, vm.initialModel, vm.case.content.data);

      // only show if not coming from a saving action
      if (toastr.active() < 1) {
        toastr.success('Die Anfrage wurde erfolgreich geladen.', 'Anfrage "' + vm.case.content.title + '" geladen');
      }
    }

    /**
     * listen to render finish in form
     * PROBLEM: this event fires more than once, so we need to make sure the handler is only triggered once
     */
    var renderIsFinished = false;
    var renderFinishEventHandler = $scope.$on('sf-render-finished', function () {
      if (renderIsFinished !== true && vm.hasOwnProperty('case') && angular.isDefined(vm.case) && vm.case.hasOwnProperty('content')) {
        mergeCaseContents();
      }
      renderIsFinished = true;
    });
    // unbind event listener when scope is destroyed
    $scope.$on('$destroy', renderFinishEventHandler);

  }
})();

(function () {
  'use strict';

  angular
    .module('hydra')
    .factory('storageService', function (Restangular, $log, hydraData, $q, $timeout, userShopsService, $filter) {

      // via https://gist.github.com/TravelingTechGuy/32454b95a50d296912b9
      var objectToQueryString = function(obj) {
        var qs = _.reduce(obj, function(result, value, key) {
          return (!_.isNull(value) && !_.isUndefined(value)) ? (result += key + '=' + value + '&') : result;
        }, '').slice(0, -1);
        return qs;
      };

      var service = {
        status : {
          getStorageLoading : false
        },
        settings  : {
          adapter : {
            caseStorage : 'server', //(location.hostname === '10.204.6.9') ? 'local': 'server',
            userSettings : 'local'
          }
        },
        data : {
          storage : {}
        },
        /*
         store: function (formController, entity, model) {
         var form = formController[entity.method];
         //$log.debug(form);
         $scope.$broadcast('schemaFormValidate');
         if (form.$valid) {
         vm.storeSubmitted = true;
         vm.storeLoading = true;

         // TODO: check if mother is still working correctly (.data should already be undefined)
         var dataToStore = {
         content: JSON.stringify(model),
         comment: vm.commentForMother,
         mother: hydraData.site.data.mother.id,
         child: hydraData.site.data.id,
         category: vm.category[0].id
         };
         */
        save: function (itemName, dataToStore, extraParams) {

          var asyncSave = null;
          var realContent = (dataToStore.hasOwnProperty('content')) ? dataToStore.content : dataToStore;
          var params = {
            content: JSON.stringify(realContent),
            comment: '',
            mother: userShopsService.getSiteId(),
            child: userShopsService.getSiteId(),
            category: dataToStore.categoryId,
            id : dataToStore.id
          };

          params = _.extend(params, extraParams);


          // set it before so it can be used in localStorage logic
          if (_.isArray(service.data.storage[itemName]) === false) {
            service.data.storage[itemName] = [];
          }

          // update existing entry (if ID is given)
          if (dataToStore.hasOwnProperty('id') && dataToStore.id > 0) {
            var found = _.findWhere(service.data.storage[itemName], {id : dataToStore.id});
            found = angular.merge(found, params);
          }
          else {
            // OR: add to end
            service.data.storage[itemName].push(params);
          }


          if (service.settings.adapter.hasOwnProperty(itemName) && service.settings.adapter[itemName] === 'local') {
            asyncSave = service.setLocalStorageEntry(itemName, params);
          }
          else {
            asyncSave = service.setBackendEntry(itemName, params, extraParams);
          }

          asyncSave.then(function(response) {
            // update id in service data so we are in sync with backend
            params.id = parseInt((response.hasOwnProperty('data')) ? response.data.id : response.id, 10);

            // add new entry to list (if it's actually new)
            /*if (dataToStore.hasOwnProperty('id') === false) {
              service.data.storage.push(response.data);
            }*/

          });

          return asyncSave;
        },
        removeEntry : function(itemName, entry) {

          var asyncRemove = null;

          // first, remove from service storage array
          var found = _.findWhere(service.data.storage[itemName], {id : entry.id});
          var pos = service.data.storage[itemName].indexOf(found);
          if (pos > -1) {
            service.data.storage[itemName].splice(pos, 1);
          }

          if (service.settings.adapter.hasOwnProperty(itemName) && service.settings.adapter[itemName] === 'local') {
            asyncRemove = service.setLocalStorageEntry(itemName, entry);
          }
          else {
            //asyncRemove = Restangular.one('storage', entry.id).remove();
            asyncRemove = Restangular.one('storage/' + entry.id + '?brokerid=' + entry.brokerid).customDELETE();
          }

          return asyncRemove;
        },
        setBackendEntry : function(itemName, postParams, getParams) {

          /*
          var storeResponse = '';
          var storage = ;
          var storeLoading = true;
          */
          var subsection = '';
          if (getParams) {
            subsection = '?' + objectToQueryString(getParams);
          }

          if (postParams.hasOwnProperty('id') && typeof(postParams.id) !== 'undefined') {
            return Restangular.one('storage', postParams.id).customPUT(postParams);
          }
          else {
            return Restangular.one('storage' + subsection).customPOST(postParams, null, {}, {'Content-Type' : 'application/json'});
          }

           /*.then(function (response) {
            $log.debug(response);
            storeResponse = 'Ihre Eingaben wurden unter der Verarbeitungsnr. ' + response.id + ' übergeben.';
            //vm.loading = false;
          }, function (response) {
            $log.debug(response);
            storeResponse = 'Ihre Eingaben konnten nicht übertragen werden.';
            //vm.loading = false;
          }).finally(function (response) {
            storeLoading = false;
            return storeResponse;
          });*/

          /*
           } else {
           toastr.error('Es sind noch nicht alle benötigten Felder korrekt ausgefüllt. Bitte überprüfen Sie die rot markierten Felder und probieren Sie es erneut.', 'Fehlende Angaben');
           }
           */
        },

        loadFromStorage: function (itemName, brokerId, caseId) {

          var deferred = $q.defer();
          var entry = null;

          // always reload (might have new entry, coming to current url after saving)
          service.getStorage(itemName, true, {brokerid : brokerId}).then(function(results) {

            var entry = service.pickFromStorage(itemName, caseId);
            deferred.resolve(entry);

          },
          function(err) {
            // not standard conform ( no .reject() ), but necessary in our case
            deferred.resolve(null);
          });

          return deferred.promise;

        },

        pickFromStorage : function(itemName, caseId) {

          var entry = _.findWhere(service.data.storage[itemName], {id : caseId});
          if (typeof(entry) === 'undefined') {
            // try with id as string
            entry = _.findWhere(service.data.storage[itemName], {id : '' + caseId});
          }

          // workaround (directly after saving a new entry, entry.content is still JSON-encoded, so we need to decoded it again, here
          if (angular.isDefined(entry) && angular.isDefined(entry.content) && typeof (entry.content) === 'string') {
            entry.content = JSON.parse(entry.content);
          }

          return entry;
        },

        /*
        removeFromStorage: function (storedModel) {
          storedModel.remove().then(
            function (response) {
              //vm.getStorage();
            },
            function (response) {
              //vm.getStorage();
            }
          ).finally(function (response) {
            service.getStorage();
          });
          $log.debug(storedModel);
        },*/

        getStorage: function (itemName, skipCache, params) {

          if (Object.hasOwnProperty(service.data.storage, itemName) && _.isArray(service.data.storage[itemName]) && skipCache !== true) {
            return service.data.storage[itemName];
          }

          var dataQuery = (service.settings.adapter.hasOwnProperty(itemName) && service.settings.adapter[itemName] === 'local') ? service.getLocalStorageEntries(itemName) : service.getBackendStorage(itemName, params);
          var deferred = $q.defer();


          dataQuery.then(
            // if we get results
            function(results) {
              if (results !== null && _.isArray(results) && results.length > 0 && results[0].hasOwnProperty('content')) {
                _.each(results, function (entry) {
                  entry.content = JSON.parse(entry.content);
                });
              }
              deferred.resolve(results);
            },
            // if we don't
            function(err) {
              deferred.reject(err);
            }
          );


          return deferred.promise;
        },
        getBackendStorage: function (itemName, params) {
          service.status.getStorageLoading = true;
          var deferred1 = $q.defer();

          Restangular.all('storage').withHttpConfig({
            cache: false
          }).getList(params/*{
            mother: userShopsService.getSiteId()
            //category: categoryId
          }*/).then(
            function (response) {
              response = $filter('orderBy')(response, 'creationDate');
              service.data.storage[itemName] = response;
              deferred1.resolve(service.data.storage[itemName]);
            },
            function (response) {
              service.data.storage[itemName] = [];
              deferred1.resolve(service.data.storage[itemName]);
            }
          ).finally(function (response) {
            //vm.displayedStorage = vm.storage;
            service.status.getStorageLoading = false;
            deferred1.resolve(service.data.storage[itemName]);
          });

          return deferred1.promise;
        },


        getLocalStorageEntries : function(itemName, userId) {
          // TODO: who can access what? -> now: limit to own creations

          var deferred = $q.defer();
          var data = localStorage.getItem(itemName);

          $timeout(function() {
            var parsedData = JSON.parse(data);
            service.data.storage[itemName] = parsedData;
            deferred.resolve(parsedData);

          }, 100);

          return deferred.promise;
        },

        setLocalStorageEntry: function(itemName, newData) {

          if (newData.hasOwnProperty('id') && newData.id > 0) {

            // ASSUMPTION: new entry was already modified in global save() logic
            /*
            var found = _.findWhere(service.data.storage[itemName], {id : newData.id});
            found = angular.merge(found, newData);
            */
          }
          else {
            newData.id = service.data.storage[itemName].length;
            newData.created = new Date();
            newData.creationDate = moment(new Date()).format('YYYY-MM-DD HH:mm:s'); // string, like in regular API
            // should be last item in list
            service.data.storage[itemName][service.data.storage[itemName].length-1] = newData;
          }

          return service.updateLocalStorage(itemName, newData);
        },

        removeLocalStorageEntry : function(itemName, entry) {
          // just save adjustments to local service data array in LC
          return service.updateLocalStorage(itemName, {});
        },

          /**
           * in localStorage, we save all entries in one big array,
           * so any create / update / delete results in the same "saving" operation
           * @param itemName
           * @returns {Function}
           */
        updateLocalStorage : function(itemName, newData) {
          var deferred = $q.defer();

          // need to use copy() so we don't mangle the displayed values
          var allData = angular.copy(service.data.storage[itemName]);

          // make sure all 'content' elements are JSON.stringified first
            _.each(allData, function (entry) {
              entry.content = (typeof entry.content !== 'string') ? JSON.stringify(entry.content) : entry.content;
            });

          localStorage.setItem(itemName, JSON.stringify(allData));
          $timeout(function() {
            deferred.resolve({status : 200, data : newData});
          }, 100);

          return deferred.promise;
        }

    }
      ;

      return service;
    });

})();

(function() {
  'use strict';

  angular
    .module('hydra')
    .controller('CasesController', function(
      $rootScope, $state, $stateParams, $scope,
      toastr,
      storageService, userShopsService, brokerService
      // can't use resolved here because it's a modal
    ) {

      var vm = this;

      vm.data = {
        brokerName : brokerService.getBrokerName()
      };

      userShopsService.getCategories().then(function(cats) {
        vm.products = cats;
      });
      storageService.getStorage('caseStorage', true, {brokerid : brokerService.getBroker().id}).then(function(results) {
        vm.cases = results;
      });

      /* view helper */
      vm.getProductName = function(key) {
        var prod = _.findWhere(vm.products, {key : key});
        return (prod) ? prod.name : '';
      };

      /**
       * used from saving modal dialog (where we use this same controller)
       */
      vm.saveEntry = function() {
        $rootScope.$broadcast('case:save', vm.data);
        vm.$dismiss();
      };

      vm.openEntry = function(sitecategoryId, caseId) {


        // decide behavior based on current state of app
        // compare all as strings
        if (""+$stateParams.sitecategoryId === ""+sitecategoryId && ""+$stateParams.caseId === ""+caseId) {
          // can't redirect to same URL again, so trigger a form reset using scope event instead
          $rootScope.$broadcast('case:open', {sitecategoryId : sitecategoryId, caseId : caseId});
        }
        else {
          // do a regular state transition
          $state.go('main.authenticated.category', {sitecategoryId : sitecategoryId, brokerId : $stateParams.brokerId, caseId : caseId});
        }

        vm.$dismiss(); // close current modal
      };

      vm.removeEntry = function(id) {
        var entry = _.findWhere(vm.cases, {id : id});
        storageService.removeEntry('caseStorage', entry).then(function(result) {
          toastr.success('Die Anfrage wurde entfernt.', 'Anfrage gelöscht');
        });

      };

      vm.deletionDate = function(date) {
        var today = new moment();
        var delta = today.diff(date, 'days');
        var max = 89;
        var deletion = max-delta;
        return deletion;
      };

      /**
       * only show cases where site and broker are the same as currently selected
       * @param caseData
       * @returns {boolean}
       */
      vm.matchesCurrentBroker = function(caseData) {
        var brokerId = caseData.content.brokerId;
        var caseSiteKey = caseData.content.siteKey;
        var siteKey = userShopsService.getSiteKey();
        if (brokerId === brokerService.getBroker().number && caseSiteKey === siteKey) {
          return true;
        }
        return false;
      };
  });
})();

(function() {
  'use strict';

  angular
    .module('hydra')
    .controller('AuthenticatedController', AuthenticatedController);

  /** @ngInject */
  function AuthenticatedController($log,
                                  $scope,
                                  $state,
                                  $stateParams,
                                  principal,
                                  jwtHelper,
                                  Idle,
                                  Keepalive,
                                  $uibModal,
                                  hydraData,
                                  toastr,
                                  Restangular,
                                  brokerService,
                                  trackingService) {
    var logModName = 'AUTH';

    $scope.started = false;
    $scope.start = start;
    $scope.stop = stop;

    // in case we don't yet have a brokerId in current state's URL, make sure to add it
    if (!$stateParams.brokerId) {
      var all = _.clone($stateParams); // because $stateParams is read-only
      var allAndBroker = _.extend(all, {brokerId : brokerService.current.id});
      $state.go('.', allAndBroker, {});
    }

    $scope.start();


    // FUNCTION IMPL ===============================================

    function closeModals () {
      if ($scope.warning) {
        $scope.warning.close();
        $scope.warning = null;
      }
      if ($scope.timedout) {
        $scope.timedout.close();
        $scope.timedout = null;
      }
    }

    function start () {
      closeModals();
      Idle.watch();
      $scope.started = true;
    }

    function stop () {
      closeModals();
      Idle.unwatch();
      $scope.started = false;
    }

    function dismiss () {
      log('Logging out.');
      trackingService.trackEvent('user', 'logout-idle', 'User logged out automatically', 1, {});

      closeModals();
      principal.logout();
      $state.go('main.login', {
        "site": principal.getSite()
      });
    }

    function log (message){
      $log.info(logModName+" "+message);
    }


    // EVENT LISTENERS ================================================

    $scope.$on('IdleStart', function() {
      closeModals();
      trackingService.trackEvent('user', 'idle', 'User inactive', 1, {});

      $scope.warning = $uibModal.open({
        templateUrl: 'app/components/authenticated/warning-dialog.html',
        windowClass: 'modal-danger'
      });
    });

    $scope.$on('IdleEnd', function() {
      closeModals();
    });

    $scope.$on('IdleTimeout', function() {
      dismiss();
    });

    $scope.$on('Keepalive', function() {
      // do something to keep the user's session alive
      Restangular.one('renewal').withHttpConfig({
        cache: false
      }).get({
        'source': 'hydra_' + principal.getSite()
      }).then(function(response) {
        log("Keepalive : trying to refresh token");
        if (response.Jwt.Token) {
          if (principal.authenticate(response.Jwt.Token)) {
            log("Keepalive : SUCCESS");
          } else {
            log("Keepalive : FAILED");
            dismiss();
          }
        } else {
          $log.debug("Keepalive : FAILED");
          dismiss();
        }
      })
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('hydra')
    .directive('aigborder', aigborder);

  /** @ngInject */
  function aigborder() {
    var directive = {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/components/aigborder/aigborder.html',
      scope: {
        white: '&?white',
        blue: '&?blue'
      }
    };
    return directive;
  }
})();

(function () {
  'use strict';

  angular
    .module('hydra')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($rootScope, $log, $state) {
    var vm = this;
    vm.loggedIn = true;
    vm.year = moment().year();
    vm.sa = true;
    if (moment().isBefore('2018-12-01')) {
      vm.sa = false;
    }
    $rootScope.debug = false;

    $rootScope.isStateAuthenticated = function () {
      return $state.current.name.indexOf('main.authenticated') >= 0 ? true : false;
    }

    vm.switchDebug = function () {
      $rootScope.debug = !$rootScope.debug;
      $log.debug("DEBUG: " + $rootScope.debug);
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('hydra')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log, $rootScope, $state, $stateParams, $window, tmhDynamicLocale, authorization, principal, amMoment, hydraData, Analytics, $transitions, $templateCache, Restangular) {
    var logModName = 'RUN';
    var log = function(message){
      $log.info(logModName+" "+message);
    };

    log('run block start');

    //  and Restangular seperately (because of https://github.com/auth0/angular-jwt/issues/15)
    Restangular.setFullRequestInterceptor(function(element, operation, route, url, headers, params, httpConfig) {
      // NOTE: we cannot use principal service here because this is run in config block
      // compare: https://stackoverflow.com/questions/30580703
      // UGLY WORKAROUND: directly access localstorage
      var jwt = principal.getToken();
      //var jwt = window.localStorage.getItem('jwtToken');
      if(jwt !== null && !angular.isString(headers.Authorization)) {
        headers.Authorization = 'Bearer ' + jwt;
      }
      return {
        element: element,
        params: params,
        headers: headers,
        httpConfig: httpConfig
      };
    });

    // anonymize last digit of IP4 address etc.
    Analytics.set('anonymizeIp', true);

    // start watching when the app runs. also starts the Keepalive service by default.
    // Idle.watch(); // in AuthenticatedController verschoben
    // Deutsche Zeiteinstellung für moment.js
    amMoment.changeLocale('de');
    // Deutsche Lokalisierung
    tmhDynamicLocale.set('de');
    principal.getSite();
    hydraData.site.get();

    // Versuchen mit Cookieinformationen erneut einzuloggen
    principal.authenticate(null, true);


    // Event der beim statechange die Rechte abprüft
    // refactor based on https://ui-router.github.io/ng1/docs/latest/classes/transition.transitionservice.html#onstart
    $transitions.onStart( {to: 'main.authenticated.**'}, function(trans) {
      var $state = trans.router.stateService;
      var principal = trans.injector().get('principal');
      if (principal.isIdentityResolved()) {
        principal.authorize();
      }
    });
    $transitions.onFinish({}, function(trans) {
      var navigationService = trans.injector().get('navigationService');
      navigationService.createNav();

      // make sure we are at top of the page after a state transition (i.e. scroll down in list, make selection, switch state >> scroll up automatically)
      if (trans.options().notify) {
        window.scrollTo(0, 0);
      }
    });

    /**
     * adjust html <title> after each transition
     * needs: title attribute in state
     * based on https://stackoverflow.com/a/43553641
     */
    $transitions.onSuccess({}, function(transition) {
      var title = transition.to().title;
      if (title) {
        if (title instanceof Function) {
          title = title.call(transition.to(), transition.params());
        }
        $window.document.title = title;
      }
    });

      /*
      var stateChangeStart = $rootScope.$on('$stateChangeStart',
      function(event, toState, toStateParams) {
        // track the state the user wants to go to;
        // authorization service needs this
        $rootScope.toState = toState;
        $rootScope.toStateParams = toStateParams;
        // if the principal is resolved, do an
        // authorization check immediately. otherwise,
        // it'll be done when the state it resolved.
        if (principal.isIdentityResolved()) {
          authorization.authorize();
        }
      });*/

    // override ui-select template to make it work with long lists
    $templateCache.put("directives/decorators/bootstrap/uiselect/uiselect.html",
      "<div ng-controller=\"dynamicSelectController\" class=\"form-group\"\n" +
      "     ng-class=\"{\'has-error\': hasError(), \'has-success\': hasSuccess(), \'has-feedback\': form.feedback !== false}\"\n" +
      "         ng-init=\"insideModel=$$value$$;extraInit(item);populateTitleMap(form, $select.search);\">\n     " +
          "<label class=\"control-label {{form.labelHtmlClass}}\" ng-show=\"showTitle()\">{{form.title}}</label>\n\n    " +
            "<div class=\"form-group\">\n        " +
                "<ui-select ng-model=\"select_model.selected\" ng-if=\"!(form.options.tagging||false)\" theme=\"bootstrap\" ng-disabled=\"form.disabled\"\n on-select=\"$$value$$=$item.value;extraSelectBinding($item, item, $parent);\" reset-search-input=\"false\" class=\"{{form.options.uiClass}}\">\n         " +
      "   <ui-select-match\n                    placeholder=\"{{form.placeholder || form.schema.placeholder || 'Bitte wählen'}}\">\n " +
            "    {{select_model.selected.name}}\n" +
            "   </ui-select-match>\n       " +
            "   <ui-select-choices form-model=\"$$value$$\" refresh=\"populateTitleMap(form, $select.search)\" refresh-delay=\"form.options.refreshDelay\" group-by=\"'group'\"\n" +
      "all-choices=\"form.titleMap\" position=\"down\"" +
      " repeat=\"item in $select.pagingOptions.items track by item.value | propsFilter: {name: $select.search, description: (form.options.searchDescriptions===true ? $select.search : \'NOTSEARCHINGFORTHIS\') }\"" +
      " "+
      ">\n" +
            "     <div ng-click=\"fakeEnter($select, item);\" ng-bind-html=\"item.name | highlight: $select.search\"></div>\n                <div ng-if=\"item.description\">\n" +
      "                    <span ng-bind-html=\"\'<small>\' + (\'\'+item.description | highlight: (form.options.searchDescriptions===true ? $select.search : \'NOTSEARCHINGFORTHIS\'))+ \'</small>\'\"></span>\n" +
      "                </div>\n" +
            "   </ui-select-choices>\n        </ui-select>\n        " +
      "<ui-select ng-controller=\"dynamicSelectController\" ng-model=\"select_model.selected\"\n" +
      "                   ng-if=\"(form.options.tagging||false) && !(form.options.groupBy || false)\"\n" +
      "                   tagging=\"form.options.tagging||false\" tagging-label=\"form.options.taggingLabel\"\n" +
      "                   tagging-tokens=\"form.options.taggingTokens\"\n" +
      "                   theme=\"bootstrap\" ng-disabled=\"form.disabled\" on-select=\"$$value$$=$item.value;extraSelectBinding($item, item, '$$value$$');\"\n" +
      "                   class=\"{{form.options.uiClass}}\">\n" +
      "            <ui-select-match\n" +
      "                    placeholder=\"{{form.placeholder || form.schema.placeholder || 'Bitte wählen'}}\">\n " +
      "               {{select_model.selected.name}}&nbsp;\n" +
      "                <small>{{(select_model.selected.isTag===true ? form.options.taggingLabel : \'\')}}</small>\n" +
      "            </ui-select-match>\n" +
      "            <!--repeat code because tagging does not display properly under group by but is still useful -->\n" +
      "            <ui-select-choices form-model=\"$$value$$\" refresh=\"populateTitleMap(form, $select.search)\"\n" +
      "                               refresh-delay=\"form.options.refreshDelay\"\n  position=\"down\"" +
      "                               repeat=\"item in form.titleMap | propsFilter: {name: $select.search, description: (form.options.searchDescription===true ? $select.search : \'NOTSEARCHINGFORTHIS\') }\">\n" +
      "                <div ng-if=\"item.isTag\"\n                     ng-bind-html=\"\'<div>\' + (item.name   | highlight: $select.search) + \' \' + form.options.taggingLabel + \'</div><div class=&quot;divider&quot;></div>\'\"></div>\n" +
      "                <div ng-if=\"!item.isTag\" ng-bind-html=\"item.name + item.isTag| highlight: $select.search\"></div>\n" +
      "                <div ng-if=\"item.description\">\n" +
      "                    <span ng-bind-html=\"\'<small>\' + (\'\'+item.description | highlight: (form.options.searchDescriptions===true ? $select.search : \'NOTSEARCHINGFORTHIS\')) + \'</small>\'\"></span>\n" +
      "                </div>\n" +
      "            </ui-select-choices>\n" +
      "        </ui-select>\n" +
      "\n" +
      "        <!--repeat code because tagging does not display properly under group by but is still useful -->\n\n" +
      "        <ui-select ng-controller=\"dynamicSelectController\" ng-model=\"select_model.selected\"\n" +
      "                   ng-if=\"(form.options.tagging||false) && (form.options.groupBy || false)\"\n" +
      "                   tagging=\"form.options.tagging||false\" tagging-label=\"form.options.taggingLabel\"\n" +
      "                   tagging-tokens=\"form.options.taggingTokens\"\n" +
      "                   theme=\"bootstrap\" ng-disabled=\"form.disabled\" on-select=\"$$value$$=$item.value;extraSelectBinding($item, item, , '$$value$$');\"\n" +
      "                   class=\"{{form.options.uiClass}}\">\n" +
      "            <ui-select-match\n" +
      "                    placeholder=\"{{form.placeholder || form.schema.placeholder || 'Bitte wählen'}}\">\n" +
      "                {{select_model.selected.name}}&nbsp;\n                <small>{{(select_model.selected.isTag===true ? form.options.taggingLabel : \'\')}}</small>\n" +
      "            </ui-select-match>\n" +
      "            <ui-select-choices form-model=\"$$value$$\" group-by=\"form.options.groupBy\"\n" +
      "                               refresh=\"populateTitleMap(form, $select.search)\"\n" +
      "                               refresh-delay=\"form.options.refreshDelay\"\n  position=\"down\"" +
      "                               repeat=\"item in form.titleMap | propsFilter: {name: $select.search, description: (form.options.searchDescription===true ? $select.search : \'NOTSEARCHINGFORTHIS\') }\">\n" +
      "                <div ng-if=\"item.isTag\"\n" +
      "                     ng-bind-html=\"\'<div>\' + (item.name  | highlight: $select.search) + \' \' + form.options.taggingLabel + \'</div><div class=&quot;divider&quot;></div>\'\"></div>\n" +
      "                <div ng-if=\"!item.isTag\" ng-bind-html=\"item.name + item.isTag| highlight: $select.search\"></div>\n" +
      "                <div ng-if=\"item.description\">\n" +
      "                    <span ng-bind-html=\"\'<small>\' + (\'\'+item.description | highlight: (form.options.searchDescriptions===true ? $select.search : \'NOTSEARCHINGFORTHIS\')) + \'</small>\'\"></span>\n" +
      "                </div>\n" +
      "            </ui-select-choices>\n" +
      "        </ui-select>\n\n" +
      "        <input\n" +
      "            type=\"hidden\"\n" +
      "            name=\"{{form.key.slice(-1)[0]}}\"\n" +
      "            toggle-single-model\n" +
      "            sf-changed=\"form\"\n" +
      "            ng-model=\"insideModel\"\n" +
      "            schema-validate=\"form\"/>\n\n" +
      "        <span ng-if=\"form.feedback !== false\"\n" +
      "          class=\"form-control-feedback\"\n" +
      "          id=\"{{form.key.slice(-1)[0] + \'Status\'}}\"\n" +
      "          ng-class=\"evalInScope(form.feedback) || {\'glyphicon\': true, \'glyphicon-ok\': hasSuccess(), \'glyphicon-remove\': hasError() }\"></span>\n" +
      "        <div class=\"help-block\" sf-message=\"form.description\"></div>\n" +
      "    </div>\n" +
      "</div>\n");

    // Override eeh-navigation template to make it also show title (tooltip) in menu links
    $templateCache.put('template/eeh-navigation/menu-item-content/eeh-navigation-menu-item-content.html',
      "<span ng-if=\"menuItem.isIconVisible\"\n" +
      "      class=\"menu-item-icon icon-fw {{ iconBaseClass() }} {{ menuItem.iconClass}}\" title=\"{{menuItem.title}}\"></span>\n" +
      "<span ng-if=\"menuItem.text\"\n" +
      "      class=\"menu-item-text\"> {{ menuItem.text|translate }}</span>\n" +
      "<span ng-if=\"menuItem._ngBindHtml()\" ng-bind-html=\"menuItem._ngBindHtml()\"></span>\n"
    );

    $templateCache.put('template/eeh-navigation/navbar/eeh-navigation-navbar.html',
      "<nav class=\"navbar eeh-navigation eeh-navigation-navbar\"\n" +
      "     ng-class=\"navClass\"\n" +
      "     role=\"navigation\">\n" +
      "    <div ng-class=\"containerClass\">\n" +
      "        <div class=\"navbar-header\">\n" +
      "            <button type=\"button\" class=\"navbar-toggle\" ng-click=\"isNavbarCollapsed = !isNavbarCollapsed\">\n" +
      "                <span class=\"sr-only\">Toggle navigation</span>\n" +
      "                <span class=\"icon-bar\"></span>\n" +
      "                <span class=\"icon-bar\"></span>\n" +
      "                <span class=\"icon-bar\"></span>\n" +
      "            </button>\n" +
      "            <eeh-navigation-navbar-brand text=\"brandText\"\n" +
      "                                         state=\"brandState\"\n" +
      "                                         href=\"brandHref\"\n" +
      "                                         target=\"brandTarget\"\n" +
      "                                         src=\"brandSrc\"\n" +
      "                                         click=\"brandClick\"></eeh-navigation-navbar-brand>\n" +
      "        </div>\n" +
      "        <div uib-collapse=\"isNavbarCollapsed\" class=\"navbar-collapse\">\n" +
      "            <ul class=\"nav navbar-nav navbar-left\">\n" +
      "                <li ng-repeat=\"item in leftNavbarMenuItems | orderBy:'weight'\"\n" +
      "                    ng-attr-id=\"{{item.id ? item.id : 'eeh-navigation-navbar-' + item.menuItemName}}\"\n" +
      "                    ng-include=\"'template/eeh-navigation/navbar-menu-item.html'\"\n" +
      "                    ng-if=\"item._isVisible()\"\n" +
      "                    uib-dropdown\n" +
      "                    ui-sref-active-eq=\"active\"\n" +
      "                    eeh-navigation-active-menu-item=\"item\">\n" +
      "                </li>\n" +
      "            </ul>\n" +
      "            <ul class=\"nav navbar-nav navbar-right\">\n" +
      "                <li ng-repeat=\"item in rightNavbarMenuItems | orderBy:'weight'\"\n" +
      "                    ng-attr-id=\"{{item.id ? item.id : 'eeh-navigation-navbar-' + item.menuItemName}}\"\n" +
      "                    ng-include=\"'template/eeh-navigation/navbar-menu-item.html'\"\n" +
      "                    ng-if=\"item._isVisible()\"\n" +
      "                    uib-dropdown\n" +
      "                    ui-sref-active-eq=\"active\"\n" +
      "                    eeh-navigation-active-menu-item=\"item\"></li>\n" +
      "            </ul>\n" +
      "        </div>\n" +
      "    </div>\n" +
      "</nav>\n" +
      "\n" +
      "<script type=\"text/ng-template\" id=\"template/eeh-navigation/navbar-menu-item.html\">\n" +
      "    <p ng-if=\"item.isReadOnly\" class=\"navbar-text\">\n" +
      "        <span eeh-navigation-menu-item-content=\"item\"></span>\n" +
      "    </p>\n" +
      "    <span ng-if=\"item.ngInclude\" ng-include=\"item.ngInclude\"></span>\n" +
      "    <a ng-if=\"!item.isDivider && item.state\" ui-sref=\"{{ item.state }}\">\n" +
      "        <span eeh-navigation-menu-item-content=\"item\"></span>\n" +
      "    </a>\n" +
      "    <a ng-if=\"item.click\" ng-click=\"item.click()\">\n" +
      "        <span eeh-navigation-menu-item-content=\"item\"></span>\n" +
      "    </a>\n" +
      "    <a ng-if=\"item.href\" ng-href=\"{{item.href}}\" target=\"{{item.target ? item.target : '_self'}}\">\n" +
      "        <span eeh-navigation-menu-item-content=\"item\"></span>\n" +
      "    </a>\n" +
      "    <a ng-if=\"item.hasChildren()\" uib-dropdown-toggle=\"\" title=\"{{item.title}}\">\n" +
      "        <span class=\"icon-fw {{ iconBaseClass() }} {{ item.iconClass }}\"></span>\n" +
      "        <span> {{ item.text|translate }}</span>\n" +
      "        <span class=\"caret\"></span>\n" +
      "    </a>\n" +
      "    <ul ng-if=\"item.hasChildren()\" class=\"dropdown-menu\">\n" +
      "        <li ng-repeat=\"item in item.children()|orderBy:'weight'\"\n" +
      "            ng-attr-id=\"{{item.id ? item.id : 'eeh-navigation-navbar-' + item.menuItemName}}\"\n" +
      "            ng-class=\"{'divider': item.isDivider}\"\n" +
      "            ng-include=\"'template/eeh-navigation/navbar-menu-item.html'\"\n" +
      "            ng-if=\"item._isVisible()\"\n" +
      "            ui-sref-active-eq=\"active\"></li>\n" +
      "    </ul>\n" +
      "</script>\n"
    );


      log('run block end');
  }
})();

(function() {
  'use strict';

  angular
    .module('hydra')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider, eehNavigationProvider) {
    $urlRouterProvider.otherwise('/404');
    $stateProvider
      .state('main', {
        abstract: true,
        controller: 'MainController',
        controllerAs: 'ctrl',
        templateUrl: 'app/main/main.html',
        data: {
          rights: []
        },
        // these will be available for ALL substates automatically
        resolve : {
        }
      })
      .state('main.register', {
        controller: 'RegisterController',
        url: '/register?token',
        controllerAs: 'ctrl',
        templateUrl: 'app/user/register/register.html',
        data: {
          rights: []
        }
      })
      .state('main.resetPwdRequest', {
        controller: 'ResetPwdRequestController',
        url: '/resetpwdrequest',
        controllerAs: 'ctrl',
        templateUrl: 'app/user/resetPwdRequest/resetPwdRequest.html',
        data: {
          rights: []
        }
      })
      .state('main.resetPassword', {
        controller: 'ResetPasswordController',
        url: '/password?token',
        controllerAs: 'ctrl',
        templateUrl: 'app/user/resetPassword/resetPassword.html',
        data: {
          rights: []
        }
      })
      .state('main.clearanceRequest', {
        controller: 'ClearanceRequestController',
        url: '/clearancerequest',
        controllerAs: 'ctrl',
        templateUrl: 'app/components/clearanceRequest/clearanceRequest.html',
        data: {
          rights: []
        }
      })
      .state('main.clearanceConfirmation', {
        controller: 'ClearanceConfirmationController',
        url: '/clearanceconfirmation?token',
        controllerAs: 'ctrl',
        templateUrl: 'app/components/clearanceConfirmation/clearanceConfirmation.html',
        data: {
          rights: []
        }
      })
      .state('main.404', {
        url: '/404',
        templateUrl: 'app/components/static/404.html',
        data: {
          rights: []
        }
      })
      .state('nutzungsbedingungen', {
        url: '/nutzungsbedingungen',
        templateUrl: 'app/components/static/nutzungsbedingungen/nutzungsbedingungen.html',
        data: {
          rights: []
        }
      })
      .state('anzeigepflicht', {
        url: '/anzeigepflicht',
        templateUrl: 'app/components/static/anzeigepflicht/anzeigepflicht.html',
        data: {
          rights: []
        }
      })
      .state('main.authenticated', {
        url: '/authenticated/:brokerId',
        abstract: true,
        controller: 'AuthenticatedController',
        controllerAs: 'ctrl',
        templateUrl: 'app/components/authenticated/authenticated.html',
        data: {
          rights: ['hydra.READ']
        },
        params : {
          brokerId : {
            value: null,
            dynamic : true
          }
        },
        resolve : {
          resolvedCategories : function(hydraData) {
            return hydraData.categories.getAll(hydraData.site.data.id);
          },
          resolvedBrokers : function(principal) {
            return principal.restoreAuthFromCookie();
          },
          resolvedBroker : function(brokerService, $stateParams) {
            brokerService.setBrokerById($stateParams.brokerId);
          }
        }
      })
      .state('main.authenticated.profile', {
        url: '/profile',
        controller: 'ProfileController',
        controllerAs: 'ctrl',
        templateUrl: 'app/user/profile/profile.html',
        data: {
          rights: ['hydra.WRITE']
        }
      })
      .state('main.authenticated.settings', {
        url: '/settings',
        controller: 'SettingsController',
        controllerAs: 'ctrl',
        templateUrl: 'app/user/settings/settings.html',
        data: {
          rights: ['hydra.WRITE']
        }
      })
      .state('main.authenticated.categories', {
        url: '/categories',
        controller: 'CategoriesController',
        controllerAs: 'ctrl',
        templateUrl: 'app/components/categories/categories.html',
        data: {
          rights: ['hydra.READ']
        },
        resolve : {
          resolvedCategories : function(hydraData) {
            return hydraData.categories.getList(hydraData.site.data.id);
          }
        }
      })
      .state('main.authenticated.category', {
        url: '/category/:sitecategoryId/:caseId',
        controller: 'CategoryController',
        controllerAs: 'ctrl',
        templateUrl: 'app/components/category/category.html',
        data: {
          rights: ['hydra.READ']
        },
        params : {
          sitecategoryId : null,
          caseId : {
            value : null
          }
        },
        resolve : {
          /*
          resolvedCase: function(storageService, $stateParams) {
            return ($stateParams.caseId !== null) ? storageService.loadFromStorage('caseStorage', $stateParams.caseId) : {};
          },*/
          resolvedCategory: function(hydraData, $stateParams) {
            return hydraData.categories.getOne($stateParams.sitecategoryId); // Kategorie ermitteln
          },
          resolvedContacts: function(hydraData, $stateParams) {
            return hydraData.contacts.getList($stateParams.sitecategoryId); // Kontakte
          },
          resolvedFiles: function(hydraData, $stateParams) {
            return hydraData.files.getList($stateParams.sitecategoryId); // Dateien
          }
        }
      })
      .state('main.playForm', {
        title : 'Playground',
        url: '/play/{formId}',
        controller: 'PlaygroundController',
        controllerAs: 'ctrl',
        templateUrl: 'app/components/playground/playground.html'
      })
      .state('main.loginNoSite', {
        url: '/login?user&pass&site',
        controller: 'LoginController',
        controllerAs: 'ctrl',
        templateUrl: 'app/user/login/login.html',
        data: {
          rights: []
        }
      })
      .state('main.loginShopSelect', {
        url: '/loginshopselect?jwt',
        controller: 'LoginShopSelectController',
        controllerAs: 'ctrl',
        templateUrl: 'app/user/loginShopSelect/loginShopSelect.html',
        data: {
          rights: []
        }
      })
      .state('main.migration', {
        controller: 'MigrationController',
        url: '/changeofpolicy',
        controllerAs: 'ctrl',
        templateUrl: 'app/components/migration/migration.html',
        data: {
          rights: []
        }
      })
      .state('main.transferserviceapproval', {
        controller: 'TransferServiceApprovalController',
        url: '/transferserviceapproval',
        controllerAs: 'ctrl',
        templateUrl: 'app/components/transferServiceApproval/transferServiceApproval.html',
        data: {
          rights: []
        }
      })
      .state('main.authenticated.migrationcategory', {
        url: '/changeofpolicycategory?token&jwt',
        controller: 'MigrationCategoryController',
        controllerAs: 'ctrl',
        templateUrl: 'app/components/migrationcategory/migrationcategory.html',
        data: {
          rights: []
        },
        resolve: {
          /*
          authorize: function(authorization) {
              return authorization.authorize();
          },*/
          migration: function(Restangular, $stateParams) {
            return Restangular.one('migrations', $stateParams.token).get();
          },
          migrationDefaults: function(migration) {
            return angular.fromJson(eval("(" + migration.request + ")"));
          },
          site: function(Restangular) {
            return Restangular.one('sites', 'migration').get();
          },
          siteCategories: function(Restangular, site, migration) {
            return Restangular.all('sitecategories').getList({
              site: site.id,
              category: migration.category
            })
          },
          category: function(hydraData, siteCategories){
            return hydraData.categories.get(siteCategories[0].id);
          },
          categoryData: function(hydraData, siteCategories){
            return hydraData.entities.getList(siteCategories[0].id);
          },
          /*categoryDataDefaults: function(categoryData){
            return categoryData.defaults;
          },
          defaultModel:function(categoryDataDefaults) {
            return angular.merge({}, categoryDataDefaults, migrationDefaults, {
              Versicherungsnehmer: {
                Neuanlage: false
              }
            });
          },*/
          contacts: function(hydraData, siteCategories){
            return hydraData.contacts.getList(siteCategories[0].id);
          },
          files: function(hydraData, siteCategories){
            return hydraData.files.getList(siteCategories[0].id);
          }
        }
      })
      .state('main.loginJwt', { // Interpretiert alles als Partnershop, was zuvor nicht abgefangen wurde!!!!!!!!!!!!!!!!
        url: '/{site}?jwt',
        params: {
          "site": null,
          "jwt" : null
        },
        controller: 'LoginController',
        controllerAs: 'ctrl',
        templateUrl: 'app/user/login/login.html',
        data: {
          rights: []
        }
      })
      .state('main.login', {
        url: '/{site}?user&ticket',
        params: {
          "site": null
        },
        controller: 'LoginController',
        controllerAs: 'ctrl',
        templateUrl: 'app/user/login/login.html',
        data: {
          rights: []
        }
      });

    eehNavigationProvider.iconBaseClass('fa fa-fw fa-lg');
    eehNavigationProvider
      .menuItem('navbar.home', {
        text: '',
        title: 'Home',
        iconClass: 'fa-home',
        state: 'main.authenticated.categories',
        isVisible: false,
        weight: -10
      })
      .menuItem('navbar.migration', {
        text: 'zurück zur Tokeneingabe',
        iconClass: 'fa-arrow-left',
        isVisible: false,
        weight: -10
      })
      .menuItem('navbar.caseList', {
        text: '',
        title : 'gespeicherte Vorgänge',
        iconClass: 'fa-folder',
        isVisible: false,
        weight: -10
      })
      .menuItem('navbar.caseNew', {
        text: '',
        title : 'Neuer Vorgang (für aktuelles Produkt)',
        iconClass: 'fa-file-o',
        isVisible: false,
        weight: -9
      })
      .menuItem('navbar.caseSave', {
        text: '',
        title : 'Vorgang speichern',
        iconClass: 'fa-floppy-o',
        isVisible: false,
        weight: -8
      })
      .menuItem('navbar.broker', {
        text: 'Broker',
        title: 'Vermittlernummer',
        iconClass: 'fa-suitcase',
        isVisible: false,
        weight: 9
      })
      .menuItem('navbar.user', {
        text: 'User',
        title: 'User',
        iconClass: 'fa-user',
        isVisible: false,
        weight: 10
      })
      .menuItem('navbar.user.profile', {
        text: 'Profil',
        iconClass: 'fa-id-card',
        state: 'main.authenticated.profile',
        isVisible: false
      })
      .menuItem('navbar.user.logout', {
        text: 'abmelden',
        iconClass: 'fa-sign-out',
        isVisible: false
      });


    for (var i = 0; i < 100; i++) {
      eehNavigationProvider.menuItem('navbar.broker.' + i, {
        text: i,
        isVisible: false,
        click: function() {
          // nichts
        }
      });
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('hydra')
    .config(rest);

  /** @ngInject */
  function rest(RestangularProvider, config) {

    //set the base url for api calls on our RESTful services
    //var newBaseUrl = "/X4/httpstarter/ReST/hydra";
    //var newBaseUrl = "/X4/Service/hydra";

    RestangularProvider.setBaseUrl(config.baseUrl);
    RestangularProvider.setDefaultHeaders({
      "Content-Type": "application/json+hal"
    });

    // Set an interceptor in order to parse the API response
    // when getting a list of resources
    RestangularProvider.setResponseInterceptor(function(data, operation, what) {
      if (operation == 'getList') {
        var response = data._embedded[what];
        response._links = data._links;
        return response
      }
      return data;
    });



    // Using self link for self reference resources
    RestangularProvider.setRestangularFields({
      selfLink: 'self.link'
    });

    // Caching an
    RestangularProvider.setDefaultHttpFields({
      cache: true
    });

  }

})();

(function() {
  'use strict';

  angular
    .module('hydra')
    .config(localize);

  function localize(tmhDynamicLocaleProvider) {
    tmhDynamicLocaleProvider.localeLocationPattern('angular/i18n/angular-locale_{{locale}}.js');
  }
})();

(function() {
  'use strict';

  angular
    .module('hydra')
    .constant('moment', moment)
    .constant('config', {
        baseUrl: '/X4/Service/hydra',
        //baseUrl: (location.hostname === '10.204.6.9') ? 'http://10.204.6.9:3005' : '/X4/Service/hydra',
        appName: 'Hydra',
        appVersion: 1.1,
        patterns: {
          password :  /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[\\#?!@$%^&*-]).{8,50}$/,
          email : /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
          telephone: /^[\d\/\+\-]+$/,
          brokernumber: /^\d+$/
        }
    });
})();

(function() {
  'use strict';

  // var airbrake = new airbrakeJs.Client({
  //   projectId: 155260,
  //   projectKey: 'cace7b28a8a8432ede211d462249001f'
  // });

  // moved airbrake up in chain, only add filter
  //  airbrake.addFilter(function (notice) {
  //   notice.context.environment = __env.name;
  //   notice.context.version = __env.version;
  //   return notice;
  // });

  angular
    .module('hydra')

    // handle exceptions inside angular app
    .factory('$exceptionHandler', function ($log) {

      return function (exception, cause) {
        $log.error(exception);
        if (__env.name !== 'local') {
          // airbrake.notify({
          //   error: exception,
          //   params: {angular_cause: cause}
          // });
        }
      };
    })

    // handle HTTP 404 errors, based on https://github.com/airbrake/airbrake-js/issues/170#issuecomment-201245861
    .factory('error404Interceptor', function($q) {
        return {
          responseError: function (rejection) {

            // track everything except "valid" 404 repsonses for X4 Service calls
            if (rejection.config.url.length > 0 && rejection.config.url.indexOf('/X4/Service/hydra/') < 0 && __env.name !== 'local') {
              // airbrake.notify('HTTP error - ' + rejection.status + ' - ' + rejection.statusText + ' - ' + rejection.config.url);
            }
            return $q.reject(rejection);
          }
        };
    })

    .factory('httpAuthInterceptor', function() {
        return {
          request: function(config) {
            var token = window.localStorage.getItem('jwtToken');
            if (!config.headers['Auth'] && token !== null && token !== "null") {
              config.headers['Auth'] = 'Bearer : ' + token;
            }
            return config;
          }
        };
    })


    .config(configF);

  /** @ngInject */
  function configF($qProvider, $logProvider, toastrConfig, sfErrorMessageProvider, IdleProvider, KeepaliveProvider, $translateProvider, AnalyticsProvider, $httpProvider, RestangularProvider, cfpLoadingBarProvider, jwtOptionsProvider) { //, $datepickerProvider

    // Enable log
    $logProvider.debugEnabled(true);
    moment.locale('de');

    // disable Error if rejection is not handled (e.g. no PDF files from API)
    $qProvider.errorOnUnhandledRejections(false);

    $translateProvider.useStaticFilesLoader({
      prefix: './assets/i18n/locale-',
      suffix: '.json'
    });
    $translateProvider.preferredLanguage('de');

    // Set options third-party lib
    toastrConfig.allowHtml = false;
    toastrConfig.timeOut = 5000;
    toastrConfig.positionClass = 'toast-bottom-left';
    toastrConfig.preventDuplicates = false;
    toastrConfig.progressBar = true;

    // configure Idle settings
    //IdleProvider.idle(10 * 60); // in seconds
    IdleProvider.idle(50 * 60); // in seconds
    IdleProvider.timeout(30); // in seconds
    KeepaliveProvider.interval(55); // in seconds

    $httpProvider.interceptors.push('error404Interceptor');

    // add JWT token to all requests (regular $http)
    $httpProvider.interceptors.push('httpAuthInterceptor');

    // dont use auth0 libs version because it leaves us with
    // https://github.com/auth0/angular-jwt/issues/27 and https://github.com/angular-ui/ui-router/issues/3354
    // ALSO: use injector for Restangular in RUN block, so we can inject real services (principal)

    jwtOptionsProvider.config({
      // redirect to login page if auth is expired or invalid or nonexisting
      unauthenticatedRedirector: ['$state', function($state) {
        $state.go('main.login');
      }]
    });

    //$httpProvider.interceptors.push('jwtInterceptor');

    AnalyticsProvider
      .setAccount({
        tracker : 'UA-103107818-1',
        fields : {
          appName : 'hydra',
          appVersion : __env.version
        },
        trackEvents : true,
        trackEcommerce : true
      })
      .setCurrency('EUR');

    cfpLoadingBarProvider.includeSpinner = false;
    cfpLoadingBarProvider.parentSelector = '#loading-bar-container';

/*
    angular.extend($datepickerProvider.defaults, {
      startWeek: 1,
      modelDateFormat: 'yyyy-MM-dd'
    });


*/
    // Standard Validierungsmeldungen
    var defaultMessages = {
      'default': 'Ungültiger Wert',
      0: 'unzulässiger Wert {{schema.type}}',
      1: 'unzulässiger Wert: {{viewValue}}',
      10: 'Data does not match any schemas from "anyOf"',
      11: 'Data does not match any schemas from "oneOf"',
      12: 'Data is valid against more than one schema from "oneOf"',
      13: 'Data matches schema from "not"',
      // Numeric errors
      100: 'Value is not a multiple of {{schema.multipleOf}}',
      101: '{{schema.minimum}} Minimum',
      102: 'Wert über {{schema.minimum}} benötigt',
      103: '{{schema.maximum}} Maximum',
      104: 'Wert unterhalb {{schema.maximum}} liegen',
      105: 'Nur Zahlenwerte!',
      // String errors
      200: 'Zu kurz. Mindestens {{schema.minLength}} Zeichen.',
      201: 'Zu lang. Höchstens {{schema.maxLength}} Zeichen.',
      202: 'Entspricht nicht dem Muster: {{schema.pattern}}',
      // Object errors
      300: 'Zu wenig Werte gewählt. Minimum {{schema.minProperties}}.',
      301: 'Zu viele Werte gewählt. Maximum {{schema.maxProperties}}.',
      302: 'Pflichtfeld',
      303: 'Zusätzliche Werte sind nicht gestattet.',
      304: 'Abhängigkeit nicht erfüllt.',
      // Array errors
      400: 'Zu wenig Einträge ({{value.length}}). Minimum: {{schema.minItems}}',
      401: 'Zu viele Einträge ({{value.length}}). Maximum: {{schema.maxItems}}',
      402: 'Einträge müssen eindeutig (unikal) sein.',
      403: 'Zusätzliche Einträge sind unzuässig.',
      // Format errors
      500: 'Formatüberprüfung fehlgeschlagen',
      501: 'Schlüsselwort-Verletzung: "{{title}}"',
      // Schema structure
      600: 'Circular $refs',
      // Non-standard validation options
      1000: 'Unbekanntes Feld (nicht in Schema enthalten)'
    };
    sfErrorMessageProvider.setDefaultMessages(defaultMessages);

    // Polyfill IE11
    if (typeof Object.assign != 'function') {
      Object.assign = function(target) {
        'use strict';
        if (target == null) {
          throw new TypeError('Cannot convert undefined or null to object');
        }

        target = Object(target);
        for (var index = 1; index < arguments.length; index++) {
          var source = arguments[index];
          if (source != null) {
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
        }
        return target;
      };
    }

    /*
    // Datumsauswahl
    jQuery.extend( jQuery.fn.pickadate.defaults, {
        monthsFull: [ 'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember' ],
        monthsShort: [ 'Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez' ],
        weekdaysFull: [ 'Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag' ],
        weekdaysShort: [ 'So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa' ],
        today: 'Heute',
        clear: 'Löschen',
        close: 'Schließen',
        firstDay: 1,
        format: 'dddd, dd. mmmm yyyy',
        formatSubmit: 'yyyy/mm/dd'
    });

    jQuery.extend( jQuery.fn.pickatime.defaults, {
        clear: 'Löschen'
    });
*/

  }
})();

/**
 * based on https://www.jvandemo.com/how-to-configure-your-angularjs-application-using-environment-variables/
 */
(function (window) {
  window.__env = window.__env || {};
  window.__env.baseUrl = '/';
  window.__env.enableDebug = true;
  window.__env.version = "0.40.6";

  window.__env.name = 'production';

  function setEnvIdent() {
    var url = document.location.origin;

    if (url.indexOf('/localhost') > -1) { return 'local'; }
    else if (url.indexOf('127.0.') > -1) { return 'local'; }
    else if (url.indexOf('10.204.') > -1) { return 'local'; }
    else if (url.indexOf('dev.') > -1) { return 'dev'; }
    else if (url.indexOf('test.') > -1) { return 'test'; }
    //if (url.indexOf('test.') > -1) { return 'test'; } stage?
    else if (url.indexOf('www.') > -1) { return 'production'; }
    else if (url.indexOf('aig.de') > -1) { return 'production'; }
    else if (url.indexOf('https://wuebanet.de') > -1) { return 'production'; }

    return 'unknown';
  }

  window.__env.name = setEnvIdent();

}(this));

angular.module("hydra").run(["$templateCache", function($templateCache) {$templateCache.put("app/main/main.html","<eeh-navigation-navbar brand-src=\"\'./assets/images/logo.png\'\" nav-class=\"\'navbar-inverse navbar-fixed-top\'\" menu-name=\"\'navbar\'\" brand-state=\"\'main.authenticated.categories\'\"></eeh-navigation-navbar><ui-view></ui-view><back-top><i class=\"fa fa-angle-double-up fa-lg\" aria-hidden=true></i> <span>zum Seitenanfang</span></back-top><footer><div class=container><div class=row><div class=\"col-sm-3 col-xs-12\"><ul><li><a href=https://www.aig.de/home/kontakt target=_blank>Kontakt</a></li><li><a href=https://www.aig.de/home/corporate-entdecken-sie-aig target=_blank>Entdecken Sie AIG</a></li><li><a href=http://www.aig.de/claims target=_blank>Schaden</a></li><li><a href=https://www.aig.de/home/maklerbereich target=_blank>Maklerbereich</a></li></ul></div><div class=\"col-sm-3 col-xs-12\"><ul><li><a href=http://www.aig.de/impressum target=_blank>Impressum</a></li><li><a href=http://www.aig.de/privacy-policy target=_blank>Datenschutz</a></li><li><a href=http://www.aig.de/terms-of-use target=_blank>Terms of Use</a></li><li><a ui-sref=nutzungsbedingungen target=_blank>Nutzungsbedingungen</a></li></ul></div><div class=\"col-sm-6 col-xs-12\"><div class=row><div class=\"col-sm-12 col-xs-12\"><strong>Support:</strong><br></div></div><!-- <div class=\"row\" ng-if=\"ctrl.currentStateName!==\'main.404\'\"> --><div class=row><div class=\"col-sm-6 col-xs-12\"><address ng-if=!isStateAuthenticated()><strong>AIG Digital Service Team</strong><br>Fragen zur Anmeldung? Gerne k&ouml;nnen Sie sich an folgende Rufnummer wenden:<br><span><i class=\"fa fa-phone\" aria-hidden=true></i> </span>07131 – 186 216<br><!-- <span> <i class=\"fa fa-envelope\" aria-hidden=\"true\"></i> </span> <a href=\"mailto:maklerservice@aig.com\">maklerservice@aig.com</a><br><br>--></address><address ng-if=isStateAuthenticated()><strong>AIG Digital Service Team</strong><br><span><i class=\"fa fa-envelope\" aria-hidden=true></i> </span><a href=mailto:angebot@aig.com>angebot@aig.com</a><br></address></div><div class=\"col-sm-6 col-xs-12\"><address><dl><dt>Montag - Donnerstag</dt><dd>08:00 - 17:00 Uhr</dd><dt>Freitag</dt><dd>08:00 - 16:00 Uhr</dd></dl></address></div></div></div></div><div class=row><div class=\"col-sm-12 col-xs-12\"><p>Copyright © {{ctrl.year}} AIG Europe S.A<span ng-click=ctrl.switchDebug()>.</span></p></div></div></div></footer>");
$templateCache.put("app/components/aigborder/aigborder.html","<div ng-class=\"{ \'aigwhite\': white, \'aigblue\': blue }\"><div class=aigcorner1></div><div class=aigcorner2></div><div class=aigcorner3></div><div class=aigcorner4></div><div class=aigcornercontent><ng-transclude></ng-transclude></div></div>");
$templateCache.put("app/components/authenticated/authenticated.html","<ui-view></ui-view>");
$templateCache.put("app/components/authenticated/warning-dialog.html","<div class=modal-header><h3><span><i class=\"fa fa-clock-o fa-spin\" aria-hidden=true></i> </span>Sie sind inaktiv!</h3></div><div idle-countdown=countdown ng-init=\"countdown=30\" class=modal-body><p><span>Sie werden in <strong>{{countdown}} Sekunde(n)</strong> abgemeldet.</span></p></div>");
$templateCache.put("app/components/categories/categories.html","<random-background><div style=\"padding-top: 96px\"><div class=container><div class=row><div class=col-md-12><aigborder white><h1>{{ctrl.site.name}}</h1><p ng-if=ctrl.site.mother>SERVICESHOP</p></aigborder></div></div></div></div></random-background><div class=\"container container-body\"><category-tile ng-repeat=\"category in ctrl.categories | orderBy:\'sort\'\" category=category></category-tile></div>");
$templateCache.put("app/components/cases/case-list.html","<div class=modal-header><h3><span><i class=\"fa fa-fw fa-folder-o\" aria-hidden=true></i> </span>Ihre gespeicherten Vorgänge für <span>{{ctrl.data.brokerName}}</span> <span class=pull-right ng-click=$dismiss();><i class=\"fa fa-fw fa-times\"></i></span></h3></div><div class=modal-body><!--\n  <p>\n    eine Überschrift mit viel Aussagekraft\n  </p>--><div ng-hide=filteredCases.length><p>Bisher haben Sie noch keinen Vorgang gespeichert</p></div><table class=table><thead ng-if=\"filteredCases.length > 0\"><tr><th>ID</th><th>für</th><th>Anfrage erstellt am</th><th>Produkt</th><th>noch verfügbar</th><th></th></tr></thead><tbody><tr ng-repeat=\"case in ctrl.cases | orderBy:\'-creationDate\' | filter:ctrl.matchesCurrentBroker as filteredCases\"><td>{{case.id}}</td><td>{{case.content.title}}</td><td>{{case.content.created | date : \'EEEE, d.M. HH:mm\' }}</td><td>{{ctrl.getProductName(case.content.key)}}</td><td><abbr title=\"{{\'dieser Vorgang wird in \' + ctrl.deletionDate(case.content.created) + \' Tagen automatisch gelöscht\'}}\">{{ctrl.deletionDate(case.content.created)}}</abbr></td><td><div class=btn-group uib-dropdown><button id=split-button type=button class=\"btn btn-primary btn-sm\" ng-click=\"ctrl.openEntry(case.content.siteCategoryId, case.id);\">&ouml;ffnen</button> <button type=button class=\"btn btn-primary btn-sm\" uib-dropdown-toggle><span class=caret></span> <span class=sr-only>Split button!</span></button><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=split-button><li role=menuitem><a ng-click=ctrl.openEntry(case.id);><i class=\"fa fa-fw fa-file\"></i> &ouml;ffnen</a></li><!--\n              <li role=\"menuitem\"><a href=\"#\"><i class=\"fa fa-fw fa-print\"></i> drucken</a></li>\n              <li role=\"menuitem\"><a href=\"#\"><i class=\"fa fa-fw fa-check-square-o\"></i> bestellen</a></li>\n            --><li class=divider></li><li role=menuitem><a ng-click=ctrl.removeEntry(case.id);><i class=\"fa fa-fw fa-trash-o\"></i> löschen</a></li></ul></div></td></tr></tbody></table></div>");
$templateCache.put("app/components/cases/case-save.html","<div class=modal-header><h3><span><i class=\"fa fa-fw fa-save\" aria-hidden=true></i> </span>Anfrage speichern <span class=pull-right ng-click=$dismiss();><i class=\"fa fa-fw fa-times\"></i></span></h3></div><div class=modal-body><p>bitte geben Sie hier einen eindeutigen Namen ein,<br>mit dem sich diese Anfrage leicht wieder finden lässt.</p><form><div class=form-group><label class=control-label>für</label><input class=form-control type=text placeholder=\"Name des Auftraggebers\" ng-model=ctrl.data.title></div></form><p><strong>Wichtig: </strong>Die Beiträge für den Kunden können sich bis zur verbindlichen Buchung ändern, daher bitte vor Abschluss erneut berechnen.</p></div><div class=modal-footer><button class=\"btn btn-primary pull-left\" ng-click=ctrl.saveEntry();>Speichern</button> &nbsp; <button class=\"btn btn-default pull-left\" ng-click=$dismiss();>Abbrechen</button></div>");
$templateCache.put("app/components/category/category.html","<!-- header --><div ng-show=ctrl.category.image class=\"jumbotron bg\" style=\"background-image: url(\'./assets/images/{{ctrl.category.image}}.jpg\')\"><div class=\"container top-container\"><div class=row><div class=col-md-12><aigborder white><h1>{{ctrl.category.name}}</h1></aigborder></div></div></div></div><div id=placeholder ng-show=ctrl.loadingForm><nav sticky offset=96 class=\"navbar navbar-default nav-center\"><ul class=\"nav nav-pills\"><li><a href=#><i class=\"fa fa-fw fa-spinner fa-spin\"></i> Formularinhalte werden geladen</a></li></ul></nav></div><div id=form-content ng-hide=ctrl.loadingForm><!-- navbar --><nav sticky offset=96 class=\"navbar navbar-default nav-center\"><ul class=\"nav nav-pills\"><li ng-repeat=\"entity in ctrl.categoryData.entities | orderBy:\'sort\'\"><a offset=192 du-scrollspy du-smooth-scroll={{entity.id}} href=#{{entity.id}}>{{entity.name}}</a></li><li ng-if=\"ctrl.files.length > 0\"><a offset=192 du-scrollspy du-smooth-scroll href=#files du-smooth-scroll=files>Dateien</a></li><li ng-if=\"ctrl.contacts.length > 0\"><a offset=192 du-scrollspy du-smooth-scroll href=#contacts du-smooth-scroll=contacts>Kontakt</a></li></ul></nav><div class=container><div ng-if=\"ctrl.category && ctrl.showQualitySeal(ctrl.category.key)\" class=quality-seal-image><quality-seal category=ctrl.category></quality-seal></div><!-- entities --><div id={{entity.id}} ng-repeat=\"entity in ctrl.categoryData.entities | orderBy:\'sort\'\"><div class=row><div class=col-md-12><h2 class=category-heading>{{entity.name}}</h2><div><form name=schemaForm sf-options=\"{setSchemaDefaults: true ,pristine: {errors: false, success: false} ,destroyStrategy: \'retain\', formDefaults:{notitle:false, feedback:false, disableSuccessState:true}}\" sf-schema=entity.JSONReqSchema sf-form=entity.JSONReqForm sf-model=ctrl.model ng-submit=\"ctrl.onSubmit(this, entity, ctrl.model)\"></form></div><hr><br><br><div class=row><div class=\"col-md-10 col-md-offset-1\"><button data-entity-name={{entity.name}} ng-if=\"entity.button && entity.permission\" ng-class=\"{\'disabled\' : ctrl.loading==true}\" type=button class=\"btn btn-primary btn-block btn-lg\" ng-click=\"ctrl.onSubmit(this, entity, ctrl.model)\"><i class=fa ng-class=\"{\'fa-send\' : ctrl.loading==false, \'fa-spinner fa-pulse\' : ctrl.loading}\"></i> <span>{{entity.button}}</span></button><br><br><div ng-show=\"ctrl.loading==false && entity.response\" class=response><form name={{entity.method}}Response sf-options=\"{formDefaults:{notitle:true, feedback:false, disableSuccessState:true, readonly:true}}\" sf-schema=entity.JSONResSchema sf-form=entity.JSONResForm sf-model=entity.response></form></div><div ng-show=ctrl.loading class=response><span><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></span><br><br><h4>Bitte gedulden Sie sich einen Moment.</h4><h4>Ihre Anfrage wird verarbeitet.</h4></div><br><!-- <div ng-show=\"ctrl.loading==false && entity.response\" bind-html-compile=\"entity.resHtml\"></div>--><div ng-repeat=\"pdfform in entity.pdfforms\" ng-show=\"ctrl.loading==false && entity.response.pid\"><a ng-click=ctrl.openPdfFormUrl(pdfform.id,entity.response.pid) target=_blank class=\"btn btn-info btn-sm pull-right\" role=button><i class=\"fa fa-file-pdf-o\"></i> <span>{{pdfform.name}}</span></a></div><!--\n              <div ng-if=\"$last && ctrl.site.mother\">\n                <div class=\"form-group\">\n                  <label for=\"comment\">Ihr Kommentar für\n                    {{ctrl.site.mother.name}}:</label>\n                  <textarea ng-model=\"ctrl.commentForMother\" class=\"form-control\" id=\"comment\"></textarea>\n                </div>\n                <button ng-class=\"{\'disabled\' : ctrl.loading==true}\" type=\"button\" class=\"btn btn-default btn-block\" ng-click=\"ctrl.store(this, entity, ctrl.model)\">\n                  <i class=\"fa\" ng-class=\"{\'fa-send\' : ctrl.loading==false, \'fa-spinner fa-pulse\' : ctrl.loading}\"></i>\n                  <span>an\n                    {{ctrl.site.mother.name}}\n                    übertragen</span>\n                </button>\n                <br/>\n                <div ng-show=\"ctrl.storeLoading==false && ctrl.storeResponse\" class=\"response\">\n                  {{ctrl.storeResponse}}\n                </div>\n                <div ng-show=\"ctrl.storeLoading\" class=\"response\">\n                  <span>\n                    <i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i>\n                  </span>\n                  <br/>\n                  <br/>\n                  <h4>Bitte gedulden Sie sich einen Moment.</h4>\n                  <h4>Ihre Anfrage wird verarbeitet.</h4>\n                </div>\n              </div>\n              --></div></div></div></div><div ng-if=$root.debug class=row><div class=col-md-12><uib-tabset active=active><uib-tab index=0 heading=Schema><pre>{{entity.JSONReqSchema | json}}</pre></uib-tab><uib-tab index=1 heading=Formular><pre>{{entity.JSONReqForm| json}}</pre></uib-tab><uib-tab index=2 heading=Model><pre>{{ctrl.model | json}}</pre></uib-tab><uib-tab index=3 heading=Default><div ui-ace=\"{mode: \'json\'}\" readonly ng-model=entity.reqDefault></div></uib-tab><uib-tab index=4 heading=ResponseSchema><div ui-ace=\"{mode: \'json\'}\" readonly ng-model=entity.resSchema></div></uib-tab><uib-tab index=5 heading=ResponseFormular><div ui-ace=\"{mode: \'json\'}\" readonly ng-model=entity.resForm></div></uib-tab><uib-tab index=6 heading=Response><pre>{{entity.response | json}}</pre></uib-tab></uib-tabset></div></div></div></div><!-- files --><div ng-if=\"ctrl.files.length > 0\" class=container id=files><div class=row><div class=col-md-12><h2>Dateien</h2></div></div><div class=\"row row-centered\"><div ng-repeat=\"file in ctrl.files | orderBy:\'sort\'\" class=\"col-md-4 col-centered\"><a href={{ctrl.getFileUrl(file)}} target=_blank><h4><span><i class=\"fa fa-file-pdf-o\"></i> </span>{{file.name}}</h4></a><small>{{file.description}}</small></div></div></div><!-- contacts --><div ng-if=\"ctrl.contacts.length > 0\" class=container id=contacts><div class=row><div class=col-md-12><h2>Kontakt</h2><div class=\"row row-centered\"><div class=\"col-md-4 col-centered\" ng-repeat=\"contact in ctrl.contacts | orderBy:\'sort\'\"><h3>{{contact.type}}</h3><address><strong>{{contact.name}}</strong><br><small><span>{{contact.function}}</span> <span ng-show=\"{{ contact.title}}\">({{contact.title}})</span> </small><br><small>{{contact.department}}</small><br><span><i class=\"fa fa-phone\"></i> </span><span>{{contact.phone}}</span><br><span><i class=\"fa fa-envelope\"></i> </span><span><a href=mailto:{{contact.email}}>{{contact.email}}</a> </span><br><br><strong>{{contact.company}}<br></strong>{{contact.street}}<br>{{contact.zip}} {{contact.city}}<br></address></div></div></div></div></div></div>");
$templateCache.put("app/components/clearanceConfirmation/clearanceConfirmation.html","<random-background><div class=\"container top-container\"><div class=row><div class=\"col-md-4 col-md-offset-4\"><div ng-show=ctrl.loading class=\"alert alert-info text-center\" role=alert><span><i class=\"fa fa-spinner fa-pulse fa-fw\"></i> </span><strong>Daten werden geprüft.</strong></div><div ng-show=\"ctrl.error && !ctrl.loading\" class=\"alert alert-danger text-center\" role=alert><span><i class=\"fa fa-ban\"></i> </span><strong>Fehler {{ctrl.errorCode}}</strong><br><span>{{ctrl.errorText}}</span></div><div ng-show=\"ctrl.success && !ctrl.loading\"><div class=\"alert alert-success text-center\" role=alert><span><i class=\"fa fa-check\"></i> </span><strong>Freischaltung abgeschlossen.</strong><br><span>Ihre Freischaltung ist damit erfolgreich abgeschlossen. Sie erhalten in den nächsten Wochen weitere Informationen zur Umstellung der Bestandsverträge.</span></div></div></div></div></div></random-background>");
$templateCache.put("app/components/category-tile/category-tile.component.html","<div class=category-tile><span ng-if=$ctrl.showQualitySeal($ctrl.category.key) class=quality-seal-tooltip><img alt=Qualitätssiegel data-ng-src=assets/images/{{$ctrl.imgName}}.jpg> </span><span ng-if=$ctrl.showQualitySeal($ctrl.category.key) class=quality-seal-tooltip-arrow></span><div class=\"row category-tile-row\" data-category-id={{$ctrl.category.sitecategory}}><div class=col-md-3><a ui-sref=\"main.authenticated.category({sitecategoryId: $ctrl.category.sitecategory})\"><div style=\"height: 144px; background-image: url(\'./assets/images/{{$ctrl.category.image}}_tn.jpg\')\" class=bg></div></a></div><div class=col-md-9><h4 class=category-title>{{$ctrl.category.branch}}</h4><h5><span ng-if=$ctrl.category.badge class=\"label label-primary\">{{$ctrl.category.badge}}</span> {{$ctrl.category.name}}</h5><small>{{$ctrl.category.description}}</small><p><a ui-sref=\"main.authenticated.category({sitecategoryId: $ctrl.category.sitecategory})\">{{$ctrl.category.button}}</a></p></div></div></div>");
$templateCache.put("app/components/clearanceRequest/clearanceRequest.html","<random-background><div class=\"container top-container\"><div class=row><!-- <div class=\"col-md-6\">\r\n        <aigborder white>\r\n          <h1>test1</h1>\r\n        </aigborder>\r\n      </div> --><div class=\"col-md-4 col-md-offset-4\"><div class=login-panel><form name=clearanceRequestForm sf-schema=ctrl.schema sf-form=ctrl.form sf-model=ctrl.model></form><br><div ng-show=ctrl.loading class=\"alert alert-info text-center\" role=alert><span><i class=\"fa fa-spinner fa-pulse fa-fw\"></i> </span><strong>Daten werden übertragen.</strong></div><div ng-show=\"ctrl.error && !ctrl.loading\" class=\"alert alert-danger text-center\" role=alert><span><i class=\"fa fa-ban\"></i> </span><strong>Fehler {{ctrl.errorCode}}</strong><br><span>{{ctrl.errorText}}</span></div><div ng-show=\"ctrl.success && !ctrl.loading\"><div class=\"alert alert-success text-center\" role=alert><span><i class=\"fa fa-check\"></i> </span><strong>Daten erfolgreich übertragen.</strong><br><span>Die Daten wurden erfolgreich übertragen. Sie erhalten in Kürze eine Bestätigungsmail.</span><!-- <br/>\r\n              <span style=\"font-size: 70%\">{{ctrl.mig_dose}}</span> --></div></div></div></div></div></div></random-background>");
$templateCache.put("app/components/migration/migration.html","<random-background><div class=\"container top-container\"><div class=row><div ng-if=ctrl.site class=col-md-6><aigborder white><h1>{{ctrl.site.name}}</h1><!--<p ng-if=\"ctrl.site.description\">{{ctrl.site.description}}</p>--></aigborder></div><div class=col-md-4 ng-class=\"{ \'col-md-offset-4\' : !ctrl.site, \'col-md-offset-1\' : ctrl.site}\"><div class=login-panel><form name=resetForm sf-schema=ctrl.schema sf-form=ctrl.form sf-model=ctrl.model></form><br><div ng-show=ctrl.loading class=\"alert alert-info text-center\" role=alert><span><i class=\"fa fa-spinner fa-pulse fa-fw\"></i> </span><strong>überprüfe Token und Vertragsnummer</strong></div><div ng-show=\"ctrl.error && !ctrl.loading\" class=\"alert alert-danger text-center\" role=alert><span><i class=\"fa fa-ban\"></i> </span><strong>Fehler {{ctrl.errorCode}}</strong><br><span>{{ctrl.errorText}}</span></div></div></div></div></div></random-background>");
$templateCache.put("app/components/playground/playground.html","<br><div class=\"container top-container\"><div class=row><div class=col-md-4><ul><li ng-repeat=\"(key, form) in ctrl.forms\"><a ui-sref=\"main.playForm({formId : key})\">{{form.name}}</a></li><li><a ui-sref=\"main.playForm({formId : \'hauruck\'})\">Hausrat via Backend</a></li></ul></div><div class=col-md-8><label ng-click=\"ctrl.showModel != showModel\"><input type=checkbox ng-model=ctrl.showModel> show model</label><pre ng-if=ctrl.showModel>\n        {{ ctrl.model | json }}\n      </pre><form name={{entity.method}} sf-options=\"{setSchemaDefaults: true ,pristine: {errors: false, success: false} ,destroyStrategy: \'retain\', formDefaults:{notitle:false, feedback:false, disableSuccessState:true}}\" sf-schema=ctrl.form.schema sf-form=ctrl.form.form sf-model=ctrl.model ng-submit=\"ctrl.onSubmit(this, entity, ctrl.model)\"></form><!--<pre>       {{ctrl.form}}\n    </pre>--></div></div></div>");
$templateCache.put("app/components/migrationcategory/migrationcategory.html","<!-- header --><div ng-show=ctrl.category[0].image class=\"jumbotron bg\" style=\"background-image: url(\'./assets/images/{{ctrl.category[0].image}}.jpg\')\"><div class=\"container top-container\"><div class=row><div class=col-md-12><aigborder white><h1>{{ctrl.category[0].name}}</h1></aigborder></div></div></div></div><!-- navbar --><!--<nav sticky anchor=\"top\" offset=\"96\" class=\"navbar navbar-default nav-center\">--><!--<nav id=\"sticky-nav\" class=\"becomes-sticky navbar navbar-default nav-center\" style=\"z-index:-9;\">--><nav sticky offset=96 class=\"navbar navbar-default nav-center\"><ul class=\"nav nav-pills\"><li ng-repeat=\"entity in ctrl.categoryData.entities | orderBy:\'sort\'\"><a offset=192 du-scrollspy du-smooth-scroll={{entity.id}} href=#{{entity.id}} )>{{entity.name}}</a></li><li ng-if=\"ctrl.files.length > 0\"><a offset=192 du-scrollspy du-smooth-scroll href=#files du-smooth-scroll=files>Dateien</a></li><li ng-if=\"ctrl.contacts.length > 0\"><a offset=192 du-scrollspy du-smooth-scroll href=#contacts du-smooth-scroll=contacts>Kontakt</a></li></ul></nav><!-- entities --><div class=container id={{entity.id}} ng-repeat=\"entity in ctrl.categoryData.entities | orderBy:\'sort\'\"><div class=row><div class=col-md-12><div class=container><h2>{{entity.name}}</h2><div><form name={{entity.method}} sf-options=\"{setSchemaDefaults: true ,pristine: {errors: false, success: false} ,destroyStrategy: \'retain\', formDefaults:{notitle:false, feedback:false, disableSuccessState:true}}\" sf-schema=entity.JSONReqSchema sf-form=entity.JSONReqForm sf-model=ctrl.model ng-submit=\"ctrl.onSubmit(this, entity, ctrl.model)\"></form></div><hr><br><br><div class=row><div class=\"col-md-10 col-md-offset-1\"><!--\n            <button ng-if=\"entity.button\" ng-class=\"{\'disabled\' : ctrl.loading==true}\" type=\"button\" class=\"btn btn-info btn-block\" ng-click=\"ctrl.clear(this, entity, ctrl.model)\">\n              <i class=\"fa fa-trash\"></i>\n              <span>Formulare zurücksetzen / leeren</span>\n            </button>\n            --> <button ng-if=entity.button ng-class=\"{\'disabled\' : ctrl.loading==true}\" type=button class=\"btn btn-primary btn-block btn-lg\" ng-click=\"ctrl.onSubmit(this, entity, ctrl.model)\"><i class=fa ng-class=\"{\'fa-send\' : ctrl.loading==false, \'fa-spinner fa-pulse\' : ctrl.loading}\"></i> <span>{{entity.button}}</span></button><br><br><div ng-show=\"ctrl.loading==false && entity.response\" class=response><form name={{entity.method}}Response sf-options=\"{formDefaults:{notitle:true, feedback:false, disableSuccessState:true, readonly:true}}\" sf-schema=entity.JSONResSchema sf-form=entity.JSONResForm sf-model=entity.response></form></div><div ng-show=ctrl.loading class=response><span><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></span><br><br><h4>Bitte gedulden Sie sich einen Moment.</h4><h4>Ihre Anfrage wird verarbeitet.</h4></div><br><div ng-repeat=\"pdfform in entity.pdfforms\" ng-show=\"ctrl.loading==false && entity.response.pid\"><a href={{ctrl.getPdfFormUrl(pdfform.id,entity.response.pid)}} target=_blank class=\"btn btn-info btn-sm pull-right\" role=button><i class=\"fa fa-file-pdf-o\"></i> <span>{{pdfform.name}}</span></a></div><!-- <div ng-show=\"ctrl.loading==false && entity.response\" bind-html-compile=\"entity.resHtml\"></div>--><!--\n            <div ng-show=\"ctrl.loading==false && entity.response.pid\">\n              <button type=\"button\" class=\"btn btn-info btn-sm pull-right\" ng-click=\"ctrl.showProt(entity.response.pid)\">\n                <i class=\"fa fa-file-pdf-o\"></i>\n                <span>Protokoll anzeigen</span>\n              </button>\n            </div>\n          --></div></div></div></div></div><div ng-if=$root.debug class=row><div class=col-md-12><uib-tabset active=active><uib-tab index=0 heading=Schema><pre>{{entity.JSONReqSchema | json}}</pre></uib-tab><uib-tab index=1 heading=Formular><pre>{{entity.JSONReqForm| json}}</pre></uib-tab><uib-tab index=2 heading=Model><pre>{{ctrl.model | json}}</pre></uib-tab><uib-tab index=3 heading=Default><div ui-ace=\"{mode: \'json\'}\" readonly ng-model=ctrl.categoryData.defaults></div></uib-tab><uib-tab index=4 heading=MigrationsDefault><div ui-ace=\"{mode: \'json\'}\" readonly ng-model=ctrl.migrationDefaults></div></uib-tab><uib-tab index=5 heading=ResponseSchema><div ui-ace=\"{mode: \'json\'}\" readonly ng-model=entity.resSchema></div></uib-tab><uib-tab index=6 heading=ResponseFormular><div ui-ace=\"{mode: \'json\'}\" readonly ng-model=entity.resForm></div></uib-tab><uib-tab index=7 heading=Response><pre>{{entity.response | json}}</pre></uib-tab></uib-tabset></div></div></div><!-- files --><div ng-if=\"ctrl.files.length > 0\" class=container id=files><div class=row><div class=col-md-12><h2>Dateien</h2></div></div><div class=\"row row-centered\"><div ng-repeat=\"file in ctrl.files | orderBy:\'sort\'\" class=\"col-md-4 col-centered\"><a href={{ctrl.getFileUrl(file)}} target=_blank><h4><span><i class=\"fa fa-file-pdf-o\"></i> </span>{{file.name}}</h4></a><small>{{file.description}}</small></div></div></div><!-- contacts --><div ng-if=\"ctrl.contacts.length > 0\" class=container id=contacts><div class=row><div class=col-md-12><h2>Kontakt</h2><div class=\"row row-centered\"><div class=\"col-md-4 col-centered\" ng-repeat=\"contact in ctrl.contacts | orderBy:\'sort\'\"><h3>{{contact.type}}</h3><address><strong>{{contact.name}}</strong><br><small><span>{{contact.function}}</span> <span ng-show=\"{{ contact.title}}\">({{contact.title}})</span> </small><br><small>{{contact.department}}</small><br><span><i class=\"fa fa-phone\"></i> </span><span>{{contact.phone}}</span><br><span><i class=\"fa fa-envelope\"></i> </span><span><a href=mailto:{{contact.email}}>{{contact.email}}</a> </span><br><br><strong>{{contact.company}}<br></strong>{{contact.street}}<br>{{contact.zip}} {{contact.city}}<br></address></div></div></div></div></div>");
$templateCache.put("app/components/quality-seal/quality-seal.component.html","<img alt=Qualitätssiegel data-ng-src=assets/images/{{$ctrl.getImageName($ctrl.category.key)}}.jpg>");
$templateCache.put("app/components/randomBackground/randomBackground.directive.html","<div class=\"jumbotron bg random-background\" style=\"background-image: url(\'./assets/images/{{image}}\')\"><ng-transclude></ng-transclude></div>");
$templateCache.put("app/components/randomBackground/randomBackground.html","<div class=\"jumbotron bg\" style=\"background-image: url(\'./assets/images/{{image}}\')\"><ng-transclude></ng-transclude></div>");
$templateCache.put("app/components/transferServiceApproval/transferServiceApproval.html","<random-background><div class=\"container top-container\"><div class=row><div class=\"col-md-5 col-lg-4 aig-border-wrapper\"><aigborder white><h1>Antrag auf Nutzung des Transferservice</h1><!--<p ng-if=\"ctrl.site.description\">{{ctrl.site.description}}</p>--></aigborder></div><div class=\"col-md-7 col-lg-8\"><!-- <pre>{{ctrl.user.userid | json}}</pre> --><div class=login-panel><div ng-show=!ctrl.success><div ng-show=!ctrl.success><form id=transferserviceapproval name=registerForm sf-schema=ctrl.schema sf-form=ctrl.form sf-model=ctrl.model ng-submit=\"ctrl.onSubmit(registerForm, ctrl.model)\"></form></div><br><div ng-show=ctrl.loading class=\"alert alert-info text-center\" role=alert><span><i class=\"fa fa-spinner fa-pulse fa-fw\"></i> </span><strong ng-show=!ctrl.user>Daten werden geprüft.</strong> <strong ng-show=ctrl.user>Passwort wird geändert.</strong></div><div ng-show=\"ctrl.error && !ctrl.loading\" class=\"alert alert-danger text-center\" role=alert><span><i class=\"fa fa-ban\"></i> </span><strong>Fehler {{ctrl.errorCode}}</strong><br><span>{{ctrl.errorText}}</span></div></div><div ng-show=\"ctrl.success && !ctrl.loading\"><legend>Registrierung abgeschlossen</legend><div class=\"alert alert-success text-center\" role=alert><span><i class=\"fa fa-check\"></i> </span><strong>Die Registrierung wurde abgeschlossen.</strong><br><span>Die Registrierung wurde abgeschlossen. Sie können sich nun mit Ihren Zugangsdaten anmelden.</span></div><a class=\"btn btn-block btn-primary\" ui-sref=main.login()><span><i class=\"fa fa-arrow-right\"></i> </span>zur Anmeldung</a></div><!-- login-panel       --></div><!-- bootstrap spalten --></div><!-- row --></div><!-- container top-container --></div></random-background>");
$templateCache.put("app/components/static/404.html","<div class=\"jumbotron bg\" style=\"background-image: url(\'./assets/images/image038.jpg\')\"><div class=\"container top-container\"><div class=row><div class=col-md-6><aigborder white><h1>404</h1><p>Seite nicht verfügbar</p></aigborder></div><div class=\"col-md-offset-1 col-md-4\"><div class=login-panel><span>Die aufgerufene Seite exisitiert nicht. Eventuell wollen Sie zur Anmeldung?</span><br><p></p><p></p><p></p><p></p><p></p><button class=\"btn btn-block btn-primary\" ui-sref=main.login>Anmeldung</button></div></div></div></div></div>");
$templateCache.put("app/user/loginShopSelect/loginShopSelect.html","<random-background><div class=\"container top-container\"><div class=row><div class=col-md-6><aigborder white><h1>Partnershops</h1></aigborder></div><div class=\"col-md-offset-1 col-md-4\"><div class=login-panel><form name=loginShopSelectForm sf-schema=ctrl.schema sf-form=ctrl.form sf-model=ctrl.model></form><br><div ng-show=ctrl.loading class=\"alert alert-info text-center\" role=alert><span><i class=\"fa fa-spinner fa-pulse fa-fw\"></i> </span><strong>initialisiere Sicherheitsprüfung</strong></div><div ng-show=\"ctrl.error && !ctrl.loading\" class=\"alert alert-danger text-center\" role=alert><span><i class=\"fa fa-ban\"></i> </span><strong>Fehler {{ctrl.errorCode}}</strong><br><span>{{ctrl.errorText}}</span></div><small><a class=pull-right ui-sref=main.login>Zurück zur Anmeldung.</a></small></div></div></div></div></random-background>");
$templateCache.put("app/user/profile/profile.html","<random-background><div style=\"padding-top: 96px\"><div class=container><div class=row><div class=col-md-12><aigborder white><h1>Profil</h1></aigborder></div></div></div></div></random-background><!-- navbar --><!--<nav sticky anchor=\"top\" offset=\"96\" class=\"navbar navbar-default nav-center\">--><!--<nav id=\"sticky-nav\" class=\"becomes-sticky navbar navbar-default nav-center\" style=\"z-index:-9;\">--><nav sticky offset=96 class=\"navbar navbar-default nav-center\"><ul class=\"nav nav-pills\"><li><a offset=192 du-scrollspy du-smooth-scroll href=#reset-pw du-smooth-scroll=reset-pw>Passwort</a></li></ul></nav><!-- passwort --><div class=container id=reset-pw><div class=\"row row-centered\"><div class=\"col-md-6 col-centered\"><form name=passwordForm sf-options=\"{formDefaults:{notitle:false, feedback:false, disableSuccessState:true}}\" sf-schema=ctrl.password.schema sf-form=ctrl.password.form sf-model=ctrl.password.model></form><br><div ng-show=ctrl.password.loading class=\"alert alert-info text-center\" role=alert><span><i class=\"fa fa-spinner fa-pulse fa-fw\"></i> </span><strong>ändere Passwort</strong></div><div ng-show=\"ctrl.password.error && !ctrl.password.loading\" class=\"alert alert-danger text-center\" role=alert><span><i class=\"fa fa-ban\"></i> </span><strong>Fehler {{ctrl.password.errorCode}}</strong><br><span>{{ctrl.password.errorText}}</span></div></div></div></div><hr><br><br><!--\n<div class=\"container\" id=\"reset-email\">\n  <div class=\"row\">\n    <div class=\"col-md-12\">\n      <form name=\"resetEmailForm\" sf-options=\"{formDefaults:{notitle:false, feedback:false, disableSuccessState:true}}\" sf-schema=\"ctrl.resetEmail.schema\" sf-form=\"ctrl.resetEmail.form\" sf-model=\"ctrl.resetEmail.model\"></form>\n      <br/>\n      <br/>\n      <div ng-show=\"ctrl.resetEmail.loading\" class=\"alert alert-info text-center\" role=\"alert\">\n        <span>\n          <i class=\"fa fa-spinner fa-pulse fa-fw\"></i>\n        </span>\n        <strong>ändere E-Mail-Adresse</strong>\n      </div>\n      <div ng-show=\"ctrl.resetEmail.error && !ctrl.resetEmail.loading\" class=\"alert alert-danger text-center\" role=\"alert\">\n        <span>\n          <i class=\"fa fa-ban\"></i>\n        </span>\n        <strong>\n          Fehler</strong>\n        <br/>\n        <span>Die E-Mail-Adresse konnte nicht geändert werden.</span>\n      </div>\n    </div>\n  </div>\n  <div class=\"row row-centered\"></div>\n</div>\n -->");
$templateCache.put("app/user/register/register.html","<random-background><div class=\"container top-container\"><div class=row><div class=col-md-3><aigborder white><h1>Registrierung</h1><!--<p ng-if=\"ctrl.site.description\">{{ctrl.site.description}}</p>--></aigborder></div><div class=\"col-md-4 col-md-offset-1\"><!-- <pre>{{ctrl.user.userid | json}}</pre> --><div class=login-panel><legend ng-show=!ctrl.success>Passwort vergeben für {{ctrl.user.userid}}</legend><div ng-show=!ctrl.success><div ng-show=!ctrl.success><form name=registerForm sf-schema=ctrl.schema sf-form=ctrl.form sf-model=ctrl.model ng-submit=\"ctrl.onSubmit(registerForm, ctrl.model)\"></form></div><br><div ng-show=ctrl.loading class=\"alert alert-info text-center\" role=alert><span><i class=\"fa fa-spinner fa-pulse fa-fw\"></i> </span><strong ng-show=!ctrl.user>Daten werden geprüft.</strong> <strong ng-show=ctrl.user>Passwort wird geändert.</strong></div><div ng-show=\"ctrl.error && !ctrl.loading\" class=\"alert alert-danger text-center\" role=alert><span><i class=\"fa fa-ban\"></i> </span><strong>Fehler {{ctrl.errorCode}}</strong><br><span>{{ctrl.errorText}}</span></div></div><div ng-show=\"ctrl.success && !ctrl.loading\"><legend>Registrierung abgeschlossen</legend><div class=\"alert alert-success text-center\" role=alert><span><i class=\"fa fa-check\"></i> </span><strong>Die Registrierung wurde abgeschlossen.</strong><br><span>Die Registrierung wurde abgeschlossen. Sie können sich nun mit Ihren Zugangsdaten anmelden.</span></div><a class=\"btn btn-block btn-primary\" ui-sref=main.login()><span><i class=\"fa fa-arrow-right\"></i> </span>zur Anmeldung</a></div><!-- login-panel       --></div><!-- bootstrap spalten --></div><div class=col-md-4><!-- <pre>{{ctrl.user.userid | json}}</pre> --><div class=login-panel><legend>Passwortkriterien:</legend><ul><li>Passwort darf keine Teile der E-Mail-Adresse enthalten.</li><li>Es muss Groß- und Kleinbuchstaben enthalten.</li><li>Eine Zahl muss enthalten sein.</li><li>Ein Sonderzeichen (#?!@$%^&*-) muss enthalten sein.</li><li>Es muss mindestens 8 Stellen lang sein.</li><li>Beispiel: katZe368!</li></ul></div></div><!-- row --></div><!-- container top-container --></div></random-background>");
$templateCache.put("app/user/resetPwdRequest/resetPwdRequest.html","<random-background><div class=\"container top-container\"><div class=row><div ng-if=ctrl.site class=col-md-6><aigborder white><h1>{{ctrl.site.name}}</h1><!--<p ng-if=\"ctrl.site.description\">{{ctrl.site.description}}</p>--></aigborder></div><div class=col-md-4 ng-class=\"{ \'col-md-offset-4\' : !ctrl.site, \'col-md-offset-1\' : ctrl.site}\"><div class=login-panel><div ng-show=!ctrl.success><form name=resetPwdRequestForm sf-schema=ctrl.schema sf-form=ctrl.form sf-model=ctrl.model ng-submit=\"ctrl.onSubmit(resetPwdRequestForm, ctrl.model)\"></form><br><div ng-show=ctrl.loading class=\"alert alert-info text-center\" role=alert><span><i class=\"fa fa-spinner fa-pulse fa-fw\"></i> </span><strong>Verarbeitung</strong></div><div ng-show=\"ctrl.error && !ctrl.loading\" class=\"alert alert-danger text-center\" role=alert><span><i class=\"fa fa-ban\"></i> </span><strong>Fehler {{ctrl.errorCode}}</strong><br><span>{{ctrl.errorText}}</span></div></div><div ng-show=\"ctrl.success && !ctrl.loading\"><div class=\"alert alert-success text-center\" role=alert><span><i class=\"fa fa-check\"></i> </span><strong>Daten erfolgreich übertragen.</strong><br><span>Die Daten wurden erfolgreich übertragen. Sie erhalten in Kürze eine Bestätigungsmail.</span><!-- <br/>\r\n              <span style=\"font-size: 70%\">{{ctrl.mig_dose}}</span> --></div></div></div></div></div></div></random-background>");
$templateCache.put("app/user/settings/settings.html","<random-background><div style=\"padding-top: 96px\"><div class=container><div class=row><div class=col-md-12><aigborder white><h1>Einstellungen</h1></aigborder></div></div></div></div></random-background><!-- navbar --><!--<nav sticky anchor=\"top\" offset=\"96\" class=\"navbar navbar-default nav-center\">--><!--<nav id=\"sticky-nav\" class=\"becomes-sticky navbar navbar-default nav-center\" style=\"z-index:-9;\">--><nav sticky offset=96 class=\"navbar navbar-default nav-center\"><ul class=\"nav nav-pills\"><li><a offset=192 du-scrollspy du-smooth-scroll href=#reset-pw du-smooth-scroll=reset-pw>Passwort</a></li></ul></nav><!-- passwort --><div class=container id=reset-pw><div class=\"row row-centered\"><div class=\"col-md-6 col-centered\"><form name=passwordForm sf-options=\"{formDefaults:{notitle:false, feedback:false, disableSuccessState:true}}\" sf-schema=ctrl.password.schema sf-form=ctrl.password.form sf-model=ctrl.password.model.content></form><br><div ng-show=ctrl.password.loading class=\"alert alert-info text-center\" role=alert><span><i class=\"fa fa-spinner fa-pulse fa-fw\"></i> </span><strong>ändere Passwort</strong></div><div ng-show=\"ctrl.password.error && !ctrl.password.loading\" class=\"alert alert-danger text-center\" role=alert><span><i class=\"fa fa-ban\"></i> </span><strong>Fehler {{ctrl.password.errorCode}}</strong><br><span>{{ctrl.password.errorText}}</span></div></div></div></div><hr><br><br><!--\n<div class=\"container\" id=\"reset-email\">\n  <div class=\"row\">\n    <div class=\"col-md-12\">\n      <form name=\"resetEmailForm\" sf-options=\"{formDefaults:{notitle:false, feedback:false, disableSuccessState:true}}\" sf-schema=\"ctrl.resetEmail.schema\" sf-form=\"ctrl.resetEmail.form\" sf-model=\"ctrl.resetEmail.model\"></form>\n      <br/>\n      <br/>\n      <div ng-show=\"ctrl.resetEmail.loading\" class=\"alert alert-info text-center\" role=\"alert\">\n        <span>\n          <i class=\"fa fa-spinner fa-pulse fa-fw\"></i>\n        </span>\n        <strong>ändere E-Mail-Adresse</strong>\n      </div>\n      <div ng-show=\"ctrl.resetEmail.error && !ctrl.resetEmail.loading\" class=\"alert alert-danger text-center\" role=\"alert\">\n        <span>\n          <i class=\"fa fa-ban\"></i>\n        </span>\n        <strong>\n          Fehler</strong>\n        <br/>\n        <span>Die E-Mail-Adresse konnte nicht geändert werden.</span>\n      </div>\n    </div>\n  </div>\n  <div class=\"row row-centered\"></div>\n</div>\n -->");
$templateCache.put("app/user/resetPassword/resetPassword.html","<random-background><div class=\"container top-container\"><div class=row><div class=col-md-3><aigborder white><h1>Passwort-Reset</h1></aigborder></div><div class=\"col-md-4 col-md-offset-1\"><div class=login-panel><legend ng-show=!ctrl.success>Neues Passwort vergeben für {{ctrl.user}}</legend><div ng-show=!ctrl.success><form name=resetPasswordForm sf-schema=ctrl.schema sf-form=ctrl.form sf-model=ctrl.model></form><br><div ng-show=ctrl.loading class=\"alert alert-info text-center\" role=alert><span><i class=\"fa fa-spinner fa-pulse fa-fw\"></i> </span><strong>ändere Passwort</strong></div><div ng-show=\"ctrl.error && !ctrl.loading\" class=\"alert alert-danger text-center\" role=alert><span><i class=\"fa fa-ban\"></i> </span><strong>Fehler {{ctrl.errorCode}}</strong><br><span>{{ctrl.errorText}}</span></div></div><div ng-show=\"ctrl.success && !ctrl.loading\"><legend>Passwort zurücksetzen - Ende</legend><div class=\"alert alert-success text-center\" role=alert><span><i class=\"fa fa-check\"></i> </span><strong>Passwort geändert</strong><br><span>Das Passwort wurde geändert. Sie können sich nun mit dem neuen Passwort anmelden.</span></div><a class=\"btn btn-block btn-primary\" ui-sref=\"main.login({site:ctrl.site.key, user_name: ctrl.user_name})\"><span><i class=\"fa fa-arrow-right\"></i> </span>zur Anmeldung</a></div><!--\n          <small>\n            <a ng-if=\"ctrl.site\" class=\"pull-right\" ui-sref=\"main.login({site:ctrl.site.key})\">Passwort eingefallen? Zurück zur Anmeldung.</a>\n            <a ng-if=\"!ctrl.site\" class=\"pull-right\" ui-sref=\"main.loginPartnerSelect\">Passwort eingefallen? Zurück zur Anmeldung.</a>\n          </small>\n        --><!-- login-panel       --></div><!-- bootstrap spalten --></div><div class=col-md-4><!-- <pre>{{ctrl.user.userid | json}}</pre> --><div class=login-panel><legend>Passwortkriterien:</legend><ul><li>Passwort darf keine Teile der E-Mail-Adresse enthalten.</li><li>Es muss Groß- und Kleinbuchstaben enthalten.</li><li>Eine Zahl muss enthalten sein.</li><li>Ein Sonderzeichen (#?!@$%^&*-) muss enthalten sein.</li><li>Es muss mindestens 8 Stellen lang sein.</li><li>Beispiel: katZe368!</li></ul></div></div><!-- row --></div><!-- container top-container --></div></random-background>");
$templateCache.put("app/user/login/login.html","<random-background><div class=\"container top-container\"><div class=row><div class=col-md-6><aigborder white><h1 ng-show=ctrl.site.name>{{ctrl.site.name}}</h1><h1 ng-show=!ctrl.site.name>Anmeldung</h1><p ng-if=ctrl.site.mother>SERVICE</p></aigborder></div><div class=\"col-md-offset-1 col-md-4\"><div class=login-panel><div ng-if=!ctrl.ticket><form name=loginForm sf-schema=ctrl.schema sf-form=ctrl.form sf-model=ctrl.model ng-submit=\"ctrl.onSubmit(loginForm, ctrl.model)\"></form><br><br></div><div ng-if=ctrl.ticket><legend>Sie werden angemeldet...</legend></div><div ng-show=ctrl.loading class=\"alert alert-info text-center\" role=alert><span><i class=\"fa fa-spinner fa-pulse fa-fw\"></i> </span><strong>überprüfe Zugangsdaten</strong></div><div ng-show=\"ctrl.error && !ctrl.loading\" class=\"alert alert-danger text-center\" role=alert><span><i class=\"fa fa-ban\"></i> </span><strong>Zugriff verweigert</strong><br><span ng-if=\"ctrl.errorReason !== \'broker\'\">Bitte überprüfen Sie ihre Anmeldedaten und versuchen Sie es erneut.</span> <span ng-if=\"ctrl.errorReason == \'broker\'\">Ihre Nutzerdaten enthalten Fehler, bitte wenden Sie sich an die Support-Hotline.</span></div><small ng-if=!ctrl.ticket><a class=pull-right ui-sref=main.resetPwdRequest()>Passwort vergessen?</a></small></div></div></div></div></random-background>");
$templateCache.put("app/components/static/anzeigepflicht/anzeigepflicht.html","<nav class=\"navbar navbar-inverse navbar-fixed-top nav-center\"><ul class=nav><li><a href=#><img src=./assets/images/logo.png></a></li></ul></nav><div class=\"jumbotron bg\" style=\"background-image: url(\'./assets/images/image210.jpg\')\"><div class=\"container top-container\"><div class=row><div class=col-md-12><aigborder white=white><h1>Hinweis</h1></aigborder></div></div></div></div><nav sticky offset=96 class=\"navbar navbar-default nav-center\"><ul class=\"nav nav-pills\"><li><a href=./assets/docs/Anzeigepflicht.pdf target=_blank>Download als PDF</a></li></ul></nav><div class=container><div class=row><div class=col-sm-12><div><h2>Besonderer Hinweis &#252;ber die Folgen einer Verletzung der vorvertraglichen Anzeigepflichten gem&#228;&#223; &#167;&#167; 19 ff. VVG</h2><p><strong>Vorvertragliche Anzeigepflicht</strong></p><p>Der Versicherungsnehmer ist gem&#228;&#223; &#167; 19 Abs. 1 VVG verpflichtet, bis zur Abgabe seiner Vertragserkl&#228;rung die ihm bekannten Gefahrumst&#228;nde dem Versicherer anzuzeigen, die f&#252;r den Entschluss des Versicherers, den Vertrag mit dem vereinbarten Inhalt zu schlie&#223;en, erheblich sind und nach denen der Versicherer in Textform gefragt hat. Stellt der Versicherer nach der Vertragserkl&#228;rung des Versicherungsnehmers, aber vor Vertragsannahme Fragen im Sinn des Satzes 1, ist der Versicherungsnehmer auch insoweit zur Anzeige verpflichtet.</p><p><strong>R&#252;cktritt und Wegfall des Versicherungsschutzes</strong></p><p>Verletzt der Versicherungsnehmer die vorvertragliche Anzeigepflicht, kann der Versicherer vom Vertrag zur&#252;cktreten. Dies gilt nicht, wenn der Versicherungsnehmer nachweist, dass er die vorvertragliche Anzeigepflicht weder vors&#228;tzlich noch grob fahrl&#228;ssig verletzt hat.</p><p>Das R&#252;cktrittsrecht des Versicherers wegen grob fahrl&#228;ssiger Verletzung der Anzeigepflicht ist ausgeschlossen, wenn der Versicherer den Vertrag auch bei Kenntnis der nicht angezeigten Umst&#228;nde, wenn auch zu anderen Bedingungen geschlossen h&#228;tte.</p><p>Im Fall eines R&#252;cktritts besteht kein Versicherungsschutz. Erkl&#228;rt der Versicherer den R&#252;cktritt nach Eintritt des Versicherungsfalles, bleibt der Versicherer dennoch zur Leistung verpflichtet, wenn der Versicherungsnehmer nachweist, dass der nicht oder nicht richtig angegebene Umstand</p><p>- weder f&#252;r den Eintritt oder die Feststellung des Versicherungsfalles</p><p>- noch f&#252;r die Feststellung oder den Umfang der Leistungspflicht des Versicherers</p><p>urs&#228;chlich war. Die Leistungspflicht des Versicherers entf&#228;llt jedoch, wenn der Versicherungsnehmer die Anzeigepflicht arglistig verletzt hat.</p><p>Bei einem R&#252;cktritt steht dem Versicherer der Teil der Beitrags (Pr&#228;mie) zu, welcher der bis zum Wirksamwerden der R&#252;cktrittserkl&#228;rung abgelaufenen Vertragszeit entspricht.</p><p><strong>K&#252;ndigung</strong></p><p>Kann der Versicherer nicht vom Vertrag zur&#252;cktreten, weil der Versicherungsnehmer die vorvertragliche Anzeigepflicht lediglich einfach fahrl&#228;ssig oder schuldlos verletzt hat, ist der Versicherer berechtigt, den Vertrag unter Einhaltung einer Frist von einem Monat zu k&#252;ndigen.</p><p>Das K&#252;ndigungsrecht des Versicherers ist ausgeschlossen, wenn er den Vertrag auch bei Kenntnis der nicht angezeigten Umst&#228;nde, wenn auch zu anderen Bedingungen, geschlossen h&#228;tte.</p><p><strong>Vertrags&#228;nderung</strong></p><p>Ist das R&#252;cktritts- oder K&#252;ndigungsrecht des Versicherers ausgeschlossen, weil der Versicherer, den Vertrag auch bei Kenntnis der nicht angezeigten Umst&#228;nde, wenn auch zu anderen Bedingungen, geschlossen h&#228;tte, werden die anderen Bedingungen auf Verlangen des Versicherers r&#252;ckwirkend Vertragsbestandteil. Hat der Versicherungsnehmer die Anzeigepflicht schuldlos verletzt, werden die anderen Bedingungen erst ab der laufenden Versicherungsperiode Vertragsbestandteil.</p><p>Erh&#246;ht sich durch die Vertrags&#228;nderung der Beitrag um mehr als 10 % oder schlie&#223;t der Versicherer die Gefahrabsicherung f&#252;r den nicht angezeigten Umstand aus, kann der Versicherungsnehmer den Vertrag innerhalb eines Monats nach Zugang der Mitteilung des Versicherers &#252;ber die Vertrags&#228;nderung fristlos k&#252;ndigen. Der Versicherer hat den Versicherungsnehmer in der Mitteilung auf dieses Recht hinzuweisen.</p><p><strong>Aus&#252;bung der Rechte</strong></p><p>Der Versicherer muss die Rechte zum R&#252;cktritt, zur K&#252;ndigung oder zur Vertrags&#228;nderung innerhalb eines Monats schriftlich geltend machen. Die Frist beginnt mit dem Zeitpunkt, zu dem der Versicherer von der Verletzung der Anzeigepflicht, die das von ihm geltend gemachte Recht begr&#252;ndet, Kenntnis erlangt. Der Versicherer hat bei der Aus&#252;bung seiner Rechte die Umst&#228;nde anzugeben, auf die er seine Erkl&#228;rung st&#252;tzt. Zur Begr&#252;ndung darf der Versicherer nachtr&#228;glich weitere Umst&#228;nde angeben, wenn f&#252;r diese die Frist nach Satz 1 nicht verstrichen ist.</p><p>Die Rechte zum R&#252;cktritt, zur K&#252;ndigung oder zur Vertrags&#228;nderung sind ausgeschlossen, wenn der Versicherer den nicht angezeigten Gefahrumstand oder die Unrichtigkeit der Anzeige kannte.</p><p>Die Rechte zum R&#252;cktritt, zur K&#252;ndigung oder zur Vertrags&#228;nderung erl&#246;schen zudem mit Ablauf von f&#252;nf Jahren nach Vertragsschluss. Dies gilt allerdings nicht f&#252;r Versicherungsf&#228;lle, die vor Ablauf dieser Frist eingetreten sind. Die Frist betr&#228;gt zehn Jahre, wenn der Versicherungsnehmer die Anzeigepflicht vors&#228;tzlich oder arglistig verletzt hat.</p><p><strong>Stellvertretung durch andere Person</strong></p><p>L&#228;sst sich der Versicherungsnehmer bei Abschluss des Vertrags durch eine andere Person vertreten, so sind bez&#252;glich der Anzeigepflicht, des R&#252;cktritts, der K&#252;ndigung, der r&#252;ckwirkenden Vertrags&#228;nderung und der Ausschlussfrist f&#252;r die Aus&#252;bung der dem Versicherer zustehenden Rechte sowohl die Kenntnis und Arglist des Stellvertreters als auch diejenige des Versicherungsnehmers zu ber&#252;cksichtigen. Der Versicherungsnehmer kann sich darauf, dass die Anzeigepflicht nicht vors&#228;tzlich oder grob fahrl&#228;ssig verletzt worden ist, nur berufen, wenn weder dem Versicherungsnehmer, noch dessen Stellvertreter Vorsatz oder grobe Fahrl&#228;ssigkeit zur Last f&#228;llt.</p><p><strong>Anfechtung</strong></p><p>Das Recht des Versicherers, den Vertrag wegen arglistiger T&#228;uschung anzufechten, bleibt unber&#252;hrt. Sofern der Vertrag wegen einer arglistigen T&#228;uschung vom Versicherer wirksam angefochten wird, ist der Versicherer nicht zur Leistung verpflichtet (&#167; 22 VVG).</p></div></div></div></div>");
$templateCache.put("app/components/static/nutzungsbedingungen/nutzungsbedingungen.html","<nav class=\"navbar navbar-inverse navbar-fixed-top nav-center\"><ul class=nav><li><a href=#><img src=./assets/images/logo.png></a></li></ul></nav><div class=\"jumbotron bg\" style=\"background-image: url(\'./assets/images/image210.jpg\')\"><div class=\"container top-container\"><div class=row><div class=col-md-12><aigborder white><h1>Nutzungsbedingungen</h1></aigborder></div></div></div></div><nav sticky offset=96 class=\"navbar navbar-default nav-center\"><ul class=\"nav nav-pills\"><li><a href=./assets/docs/Nutzungsbedingungen.pdf target=_blank>Download als PDF</a></li></ul></nav><div class=container><div class=row><div class=col-sm-12><h2>Allgemeine Nutzungsbedingungen &bdquo;AIG-Microsite&ldquo; (Stand 01. Dezember 2018)</h2><p>Die nachfolgenden Allgemeinen Nutzungsbedingungen (im Folgenden &bdquo;Nutzungsbedingungen&ldquo;) enthalten die grundlegenden Regelungen f&uuml;r die Nutzung von Webservices der <strong>AIG Europe S.A., Direktion f&uuml;r Deutschland</strong>, Neue Mainzer Straße 46 – 50, 60327 Frankfurt, (im Folgenden &bdquo;AIG&ldquo;) durch den nutzenden Vermittler. Von diesen Nutzungsbedingungen abweichende Gesch&auml;ftsbedingungen des Vermittlers finden keine Anwendung, wenn sie von AIG nicht ausdr&uuml;cklich schriftlich best&auml;tigt werden sind.</p><h3>1 &nbsp;&nbsp;&nbsp; Begriffsbestimmungen</h3><p>&bdquo;<strong>Kunde</strong>&ldquo; ist jede nat&uuml;rliche oder juristische Person oder Personenvereinigung, die Versicherungsnehmer von AIG oder einer mit AIG Verbundenen Versicherungsgesellschaft ist oder die sich f&uuml;r den Abschluss eines Versicherungsvertrages mit AIG oder mit einer mit AIG Verbundenen Versicherungsgesellschaft interessiert.</p><p>&bdquo;<strong>Kundendaten</strong>&ldquo; sind alle &uuml;ber die Microsite eingegebenen oder abrufbaren Daten, Dokumente oder sonstigen Informationen, die Einzelangaben &uuml;ber pers&ouml;nliche oder sachliche Verh&auml;ltnisse eines Kunden, bei dem es sich um eine nat&uuml;rliche Person handelt, enthalten.</p><p>&bdquo;<strong>Microsite</strong>&ldquo; bezeichnet diese seitens AIG speziell f&uuml;r den Vermittler entwickelte Website mitsamt Unterseiten innerhalb des AIG Internet-Auftritts. Die Microsite ist von der eigentlichen AIG-Website unabh&auml;ngig und bilden thematisch und gestalterisch eine separate AIG-Internetpr&auml;senz f&uuml;r den Vermittler.</p><p>&bdquo;<strong>Nutzer</strong>&ldquo; ist der Vermittler und jede andere nat&uuml;rliche oder juristische Person oder Personenvereinigung, die von dem Vermittler angemeldet wurde und die Microsite nutzt.</p><p>&bdquo;<strong>Verbundene Versicherungsgesellschaften</strong>&ldquo; sind alle Versicherungsgesellschaften, die mit AIG i. S. d. &sect;&sect; 15 ff. AktG verbunden sind und auf deren Daten &uuml;ber Webservices von AIG zugegriffen werden kann.</p><p>&bdquo;<strong>Zugangsdaten</strong>&ldquo; sind die f&uuml;r den Zugang zur Microsite vergebene Benutzernummer und das Passwort des Nutzers.</p><h3>2&nbsp;&nbsp;&nbsp;&nbsp; Nutzungsberechtigte</h3><p>2.1&nbsp;&nbsp; Nutzungsberechtigt sind der der Vermittler sowie weitere Nutzer, die durch den Vermittler angemeldet werden.</p><p>2.2&nbsp;&nbsp; Die Neuanmeldung eines weiteren Nutzers setzt das Anerkennen dieser Nutzungsbedingungen durch den neuen Nutzer voraus. Hierf&uuml;r hat der Vermittler Sorge zu tragen und gegen&uuml;ber AIG bei Aufforderung nachzuweisen.</p><p>2.3&nbsp;&nbsp; Der Vermittler hat AIG &uuml;ber jede &Auml;nderung seiner und der Daten der &uuml;ber ihn angemeldeten weiteren Nutzer unverz&uuml;glich zu informieren.</p><p>2.4&nbsp;&nbsp; Der Vermittler hat AIG unverz&uuml;glich mitzuteilen, wenn ein durch ihn angemeldeter Nutzer aus dem Kreis der Nutzungsberechtigten ausscheidet. AIG wird daraufhin unverz&uuml;glich die Zugangsdaten des ausgeschiedenen Nutzers sperren.</p><h3>3&nbsp;&nbsp;&nbsp;&nbsp; Zugangsdaten</h3><p>3.1&nbsp;&nbsp; Zur Nutzung der Microsite bedarf es der Einrichtung eines Microsite-Zuganges. Nach erfolgreicher Einrichtung erh&auml;lt der Vermittler von AIG Benutzername und Kennwort. Mit Benutzername und Kennwort erfolgt der Login als Nutzer der Microsite.</p><p>3.2&nbsp;&nbsp; Passworte sollten aus einer Folge von 8 bis 10 Zeichen bestehen und sowohl Buchstaben als auch Ziffern oder Sonderzeichen enthalten.</p><p>3.3&nbsp;&nbsp; Die Nutzer sind verpflichtet, die Zugangsdaten und Kennw&ouml;rter geheim zu halten, insbesondere nicht an andere Personen weiterzugeben und vor dem Zugriff durch Dritte gesch&uuml;tzt aufzubewahren. Sind dem Vermittler oder einem Nutzer die Zugangsdaten abhandengekommen oder wird von ihnen festgestellt oder der Verdacht gehegt, dass Zugangsdaten von einem Dritten genutzt werden, haben diese dies AIG unverz&uuml;glich mitzuteilen.</p><p>3.4&nbsp;&nbsp; AIG ist berechtigt, die Zugangsdaten des Vermittlers oder eines Nutzers unverz&uuml;glich zu sperren, wenn der begr&uuml;ndete Verdacht besteht, dass das Passwort durch unberechtigte Personen genutzt wird; der betroffene Nutzer wird hier&uuml;ber informiert und erh&auml;lt ein neues Passwort zugeteilt, soweit er nicht selbst bewusst zu dem Missbrauch beigetragen hat.</p><p>3.5&nbsp;&nbsp; F&uuml;r eine &uuml;ber seine Zugangsdaten begangene Rechtsverletzung ist der Vermittler auch f&uuml;r die ihm zugeordneten Nutzer verantwortlich, es sei denn, er hat die Rechtsverletzung nicht zu vertreten.</p><h3>4&nbsp;&nbsp;&nbsp;&nbsp; Nutzung der Microsite</h3><p>4.1&nbsp;&nbsp; AIG stellt die Microsite ausschlie&szlig;lich zur beruflichen Nutzung der Nutzer zur Verf&uuml;gung. Die Microsite dient ausschlie&szlig;lich als Medium zur Platzierung von Deckungsaufgaben durch die Nutzer.</p><p>4.2&nbsp;&nbsp; Die Nutzer haben alle Handlungen zu unterlassen, die den sicheren Betrieb der Systeme von AIG gef&auml;hrden oder andere Nutzer bel&auml;stigen k&ouml;nnten oder die sonst &uuml;ber eine bestimmungsgem&auml;&szlig; Nutzung der Microsite und/oder der Systeme von AIG hinausgehen. Die Nutzer sind insbesondere dazu zu verpflichten, es zu unterlassen,</p><ul><li>die Systeme von AIG einer &uuml;berm&auml;&szlig;igen Belastung auszusetzen oder auf andere Weise das Funktionieren der Systeme von AIG zu st&ouml;ren oder zu gef&auml;hrden,</li><li>ohne ausdr&uuml;ckliche Zustimmung durch AIG Crawler, Spider, Scraper oder &auml;hnliche Technologien einzusetzen, um zur Erlangung von Daten auf Systeme von AIG zuzugreifen, oder</li><li>Ma&szlig;nahmen zu umgehen, die dazu dienen, den Zugriff auf Systeme von AIG zu verhindern oder zu beschr&auml;nken.</li></ul><p>4.3&nbsp;&nbsp; St&ouml;rungen/ Unterbrechungen der Microsite, die den Nutzern im Rahmen des Zugriffs auf die Microsite bekannt werden, sollen diese unverz&uuml;glich AIG per Mail an <a target=blank href=mailto:digital.broker@aig.com onclick=\"s_objectID=&quot;mailto:digital.broker@aig.com_3&quot;;return this.s_oc?this.s_oc(e):true\">digital.broker@aig.com</a> oder telefonisch unter +49 7131/ 186-216 zur Kenntnis gebracht werden.</p><h3>5&nbsp;&nbsp;&nbsp;&nbsp; Angebot und Annahme des Versicherungsvertrags</h3><p>5.1&nbsp;&nbsp; Die Microsite bietet den Nutzern die M&ouml;glichkeit, f&uuml;r spezifische Produkte Tarifberechnungen durchzuf&uuml;hren und Angebote auf Abschluss von Versicherungsvertr&auml;gen elektronisch an AIG zu &uuml;bermitteln (&bdquo;Antrag senden&ldquo;).</p><p>5.2&nbsp;&nbsp; Sofern der Nutzer als Versicherungsmakler t&auml;tig ist, sichert er mit Absendung des Antrags zu, dass<ul><li>ihm eine schriftliche Bevollm&auml;chtigung des Kunden zur Entgegennahme und Abgabe von Willenserkl&auml;rungen mit Wirkung f&uuml;r und gegen den Kunden vorliegt und etwaige Untervollmachten wirksam erteilt wurden und</li><li>er den Kunden vor der Erteilung der im Folgenden dargestellten Vollmacht oder Einwilligungserkl&auml;rung &uuml;ber die Nutzung, Speicherung und Verwendung der personenbezogenen Daten des Kunden durch AIG umfassend aufgekl&auml;rt hat.</li><li>ihm vom Kunden eine Vollmacht zum Empfang und zur Abgabe datenschutzrechtlich relevanter Erkl&auml;rungen erteilt wurde.</li><li>er im Rahmen seiner Vertretungsmacht entweder vertragliche Erkl&auml;rungen und Risikofragen auf Grundlage des vom AIG auf der Microsite zur Verf&uuml;gung gestellten Risikoerfassungsbogens abgibt, den er im Vorfeld dem Kunden vorgelegt hat und der durch diesen beantwortet wurde oder - sofern die Erkl&auml;rungen und Risikofragen auf Grundlage eines anderweitig erstellten und gg&uuml;. dem Kunden genutzten Fragebogens erfragt wurden – er den Kunden zuvor belehrt hat, dass es sich bei den gestellten Fragen um Fragen des Versicherers i.S.v. &sect; 19 Abs. 1 VVG handelt und er den Kunden &uuml;ber die Rechtsfolgen einer vorvertraglichen Anzeigepflicht gem. &sect; 19 Abs. 5 VVG durch Aush&auml;ndigung gesonderten Mitteilung des Versicherers zu den Folgen einer Verletzung der vorvertraglichen Anzeigepflicht belehrt hat.</li><li>er f&uuml;r den Kunden rechtzeitig vor Vertragsschuss das auf der Microsite Produktinformationsblatt, die Informationen nach &sect; 1 der Verordnung &uuml;ber Informationspflichten bei Versicherungsvertr&auml;gen, die Widerrufsbelehrung und die Versicherungsbedingungen erhalten und dem Kunden ausgeh&auml;ndigt hat.</li></ul></p><p>5.3&nbsp;&nbsp; Sofern der Nutzer als Versicherungsmehrfachvertreter t&auml;tig ist, sichert er mit Absendung des Antrags zu, dass</p><ul><li>er f&uuml;r AIG die AIG gegen&uuml;ber dem Versicherungsnehmer gesetzlich obliegenden Beratungs-, Informations- und Dokumentationspflichten erf&uuml;llt hat. Hierzu hat er insbesondere das auf der Microsite hinterlegte Produktinformationsblatt, die Informationen nach § 1 der Verordnung &uuml;ber Informationspflichten bei Versicherungsvertr&auml;gen, die Widerrufsbelehrung und die Versicherungsbedingungen sowie die Datenschutzhinweise nebst &bdquo;Merkblatt zum Datenschutz&bdquo; dem Kunden ausgeh&auml;ndigt und reicht aufgrund eines vom Kunden unterzeichneten Beratungsprotokolls den Antrag ein.</li><li>er den Informationspflichten gem. Art. 13 ff. DSGVO nachgegangen ist und die Kunden &uuml;ber Ihre Betroffenenrechte informiert hat.</li><li>er vertragliche Erkl&auml;rungen und Risikofragen auf Grundlage des vom AIG auf der Microsite zur Verf&uuml;gung gestellten Risikoerfassungsbogens abgibt, den er im Vorfeld dem Kunden vorgelegt hat und der durch diesen beantwortet wurde oder - sofern die Erkl&auml;rungen und Risikofragen auf Grundlage eines anderweitig erstellten und gg&uuml;. dem Kunden genutzten Fragebogens erfragt wurden – er den Kunden zuvor belehrt hat, dass es sich bei den gestellten Fragen um Fragen des Versicherers i.S.v. § 19 Abs. 1 VVG handelt und er den Kunden &uuml;ber die Rechtsfolgen einer vorvertraglichen Anzeigepflicht gem. § 19 Abs. 5 VVG durch Aush&auml;ndigung gesonderten Mitteilung des Versicherers zu den Folgen einer Verletzung der vorvertraglichen Anzeigepflicht belehrt hat.</li></ul><p>5.4&nbsp;&nbsp; Mit Absendung des Antrags kommt kein Vertrag &uuml;ber eine vorl&auml;ufige Deckung nach &sect;&sect; 49ff. VVG zustande.</p><p>5.5&nbsp;&nbsp; Nach Erhalt des gesendeten Antrags pr&uuml;ft AIG, ob dieser angenommen wird oder nicht. Der Nutzer erh&auml;lt unmittelbar nach Abschluss des Antragspr&uuml;fungsprozesses auf der Microsite eine Mitteilung (in der Regel binnen 30 Sekunden nach Senden des Antrags). Des Weiteren steht den Nutzern auf der Microsite eine Protokollierungsfunktion zur Verf&uuml;gung, die &uuml;ber die erfolgten Bearbeitungsschritte sowie den Status des Vertragsschlusses Auskunft gibt.</p><h3>6&nbsp;&nbsp;&nbsp;&nbsp; Verf&uuml;gbarkeit</h3><p>6.1&nbsp;&nbsp; Die AIG ist bestrebt, die Nutzung der Microsite rund um die Uhr und fehlerfrei zu erm&ouml;glichen. Eine permanente Verf&uuml;gbarkeit kann die AIG jedoch nicht garantieren (bereits aus technischen Gr&uuml;nden und aufgrund der Abh&auml;ngigkeit von &auml;u&szlig;eren Einfl&uuml;ssen, z. B. im Rahmen der Fernmeldenetze, kann eine ununterbrochene Verf&uuml;gbarkeit nicht sichergestellt werden). F&uuml;r Ausf&auml;lle der Microsite wird daher keine Haftung &uuml;bernommen.</p><p>6.2&nbsp;&nbsp; AIG &uuml;bernimmt dar&uuml;ber hinaus keine Gewahr f&uuml;r eine bestimmte &Uuml;bertragungsleistung oder f&uuml;r bestimmte Kapazit&auml;ten ihrer Systeme.</p><p>6.3&nbsp;&nbsp; AIG f&uuml;hrt an den eigenen Systemen zur Sicherstellung des Betriebes und ggf. zum Zwecke der Erweiterung der eigenen Angebote gelegentlich Wartungsarbeiten durch, die zu einer vor&uuml;bergehenden Beeintr&auml;chtigung der Nutzbarkeit der Microsite f&uuml;hren k&ouml;nnen.</p><h3>7&nbsp;&nbsp;&nbsp;&nbsp; &Auml;nderungen</h3><p>7.1&nbsp;&nbsp; Soweit AIG die Microsite w&auml;hrend der Vertragslaufzeit in nicht nur unerheblichem Umfang &auml;ndert, wird AIG die Nutzer &uuml;ber die f&uuml;r sie relevanten &Auml;nderungen rechtzeitig im Voraus per E-Mail informieren und mit diesem abstimmen.</p><p>7.2&nbsp;&nbsp; AIG beh&auml;lt sich jedoch vor, die Zugangsmethoden zu ihren Systemen, zu der AIG-Datenbank und/oder zu den AIG-Inhalten zu &auml;ndern, soweit dies zur Aufrechterhaltung oder Verbesserung der betrieblichen Stabilit&auml;t und Sicherheit der Systeme von AIG erforderlich ist. Hierbei wird AIG auch ber&uuml;cksichtigen, inwieweit eine solche &Auml;nderung f&uuml;r den Partner zumutbar ist.</p><h3>8&nbsp;&nbsp;&nbsp;&nbsp; Datenschutz, Datensicherheit</h3><p>8.1&nbsp;&nbsp; Die Nutzer sind verpflichtet, ihnen &uuml;ber die Microsite zur Verf&uuml;gung gestellte oder sonst zur Kenntnis gelangte Kundendaten vertraulich zu behandeln und in Bezug auf diese Daten die Einhaltung aller geltenden Datenschutzbestimmungen sicherzustellen.</p><p>8.2&nbsp;&nbsp; Die Nutzer sind verpflichtet, AIG unverz&uuml;glich zu informieren, wenn festgestellt oder der begr&uuml;ndete Verdacht gehegt wird, dass &uuml;ber die Microsite abrufbare personenbezogene Daten unbefugten Dritten zur Kenntnis gelangt sind, oder dass eine entsprechende Gefahr besteht.</p><p>8.3&nbsp;&nbsp; Sollten dem Nutzer im Rahmen des ihm gestatteten Zugriffs auf die Microsite Kundendaten zug&auml;nglich sein, obwohl ihm die betreffenden Kundendaten nicht zug&auml;nglich sein d&uuml;rften, hat er dies AIG unverz&uuml;glich anzuzeigen.</p><p>8.4&nbsp;&nbsp; AIG ist im Falle einer Verschlechterung oder Instabilit&auml;t ihrer Systeme, oder um den Zugriff unbefugter Dritter auf die bei AIG gespeicherten Daten zu verhindern, berechtigt, den Zugang der Nutzer zur Microsite vor&uuml;bergehend auszusetzen, wenn dies zur Verringerung von Bedrohungen der Systeme oder Daten von AIG und zur Gew&auml;hrleistung der Sicherheit der Systeme von AIG notwendig ist. AIG wird den Vermittler unverz&uuml;glich &uuml;ber eine solche notwendige Aussetzung des Zugangs informieren.</p><p>8.5&nbsp;&nbsp; AIG beh&auml;lt sich vor, die Verwaltung der Nutzer-Konten auf die 100%ige Tochtergesellschaft der AIG, die AIGGS, zu &uuml;bertragen. Im Rahmen dieser Nutzer-Konten-Verwaltung kann eine &Uuml;bermittlung und Verarbeitung von personenbezogenen Daten des Nutzers an und durch die AIGGS erfolgen. AIG verpflichtet sich, die f&uuml;r eine rechtm&auml;&szlig;ige Daten&uuml;bermittlung und Verarbeitung erforderlichen datenschutzrechtlichen Anforderungen sicherzustellen. AIG gew&auml;hrleistet dabei insbesondere die zweckgebundene (ausschlie&szlig;lich zum Zweck der Nutzer-Konten-Verwaltung) Verarbeitung der personenbezogenen Daten des Nutzers durch die AIGGS.</p><p>8.6&nbsp;&nbsp; AIG beh&auml;lt sich ferner vor, Google Analytics, einen Webanalysedienst der Google Inc. (&bdquo;Google&ldquo;), oder ein vergleichbares Analyse-Tool (im Folgenden: Analyse-Tool) einzusetzen. Das Analyse-Tool verwendet sogenannte &bdquo;Cookies&ldquo;, Textdateien, die auf den Computern der Nutzer gespeichert werden und die eine Analyse der Benutzung von Microsites durch die Nutzer erm&ouml;glichen. Die durch den Cookie erzeugten Informationen &uuml;ber die Benutzung von Microsites werden in der Regel an einen Server von Google in den USA &uuml;bertragen und dort gespeichert. Auch wird das Analyse-Tool diese Informationen gegebenenfalls an Dritte &uuml;bertragen, sofern dies gesetzlich vorgeschrieben ist oder soweit Dritte diese Daten im Auftrag von dem Analyse-Tool verarbeiten.<br>Im Auftrag von AIG wird das Analyse-Tool diese Informationen benutzen, um die Nutzung der Website auszuwerten (Nutzungsverhalten), um Reports &uuml;ber die Websiteaktivit&auml;ten zusammenzustellen und weitere mit der Websitebenutzung verbundene Dienstleistungen gegen&uuml;ber AIG zu erbringen. Die im Rahmen von dem Analyse Tool vom Browser der Nutzer &uuml;bermittelte IP-Adresse wird nicht mit anderen Daten des Analyse Tools zusammengef&uuml;hrt.</p><h3>9&nbsp;&nbsp;&nbsp;&nbsp; K&uuml;ndigung / Verst&ouml;&szlig;e gegen diese Nutzungsbedingungen</h3><p>9.1&nbsp;&nbsp; AIG und der Vermittler haben das Recht, diese Nutzungsbedingung mit einer Frist von drei Monaten zum Jahresende zu beenden. Die Beendigungserkl&auml;rung&nbsp; bedarf der Textform.</p><p>9.2&nbsp;&nbsp; Verletzt der Nutzer Pflichten aus diesen Nutzungsbedingungen trotz erfolgter Abmahnung durch AIG und ist AIG die Fortsetzung des Vertragsverh&auml;ltnisses unter Ber&uuml;cksichtigung aller Umst&auml;nde des Einzelfalls und unter Abw&auml;gung der beiderseitigen Interessen nicht zumutbar, hat AIG das Recht, diese Nutzungsbedingungen ohne Einhaltung einer K&uuml;ndigungsfrist aus wichtigem Grund zu k&uuml;ndigen.</p><h3>10&nbsp;&nbsp;&nbsp;&nbsp; Haftung</h3><p>10.1&nbsp;&nbsp; AIG haftet f&uuml;r aus der Benutzung der Microsite entstehenden Sch&auml;den der Nutzer nach den gesetzlichen Bestimmungen, sofern die Sch&auml;den vors&auml;tzlich oder grob fahrl&auml;ssig verursacht wurden, sie die Folge des Nichtvorhandenseins einer garantierten Beschaffenheit der Leistung sind, sie die Folge einer schuldhaften Verletzung der Gesundheit, des K&ouml;rpers oder des Lebens sind, oder f&uuml;r die eine Haftung nach dem Produkthaftungsgesetz vorgesehen ist. Im &Uuml;brigen ist die Haftung von AIG unabh&auml;ngig vom Rechtsgrund ausgeschlossen.</p><p>10.2&nbsp;&nbsp; Der Nutzer ist f&uuml;r die regelm&auml;&szlig;ige Sicherung seiner Daten selbst verantwortlich. Resultieren Sch&auml;den des Partners aus dem Verlust von Daten, so haftet AIG hierf&uuml;r, sofern nicht die Haftung gem&auml;&szlig; Ziffer 9.1 ohnehin ausgeschlossen ist, nur, soweit die Sch&auml;den auch durch eine regelm&auml;&szlig;ige Sicherung aller relevanten Daten durch den Partner nicht vermieden worden w&auml;ren.</p><h3>11&nbsp;&nbsp;&nbsp; &Auml;nderung der Nutzungsbedingungen, Wirksamkeit</h3><p>11.1 AIG beh&auml;lt sich das Recht vor, diese Nutzungsbedingungen jederzeit ganz oder teilweise zu &auml;ndern. &Uuml;ber &Auml;nderungen wird der Vermittler sp&auml;testens 14 Tage vor deren Inkrafttreten per E-Mail informiert. Diese Information hat der Vermittler an die Nutzer weiterzureichen. Die &Auml;nderungen gelten als genehmigt, wenn der Nutzer die Microsite nach Inkrafttreten der &Auml;nderungen weiternutzt.</p><p>11.2 Sollten einzelne Bestimmungen dieser Nutzungsbedingungen ganz oder teilweise unwirksam sein oder werden, ber&uuml;hrt dies die Wirksamkeit der &uuml;brigen Bestimmungen nicht.</p></div></div></div>");}]);